// Copyright (c) Tangible It, Mexico. All rights reserved.
// Licensed under the MIT License.

import * as microsoftTeams from "@microsoft/teams-js";
import React from "react";
import ReactTooltip from "react-tooltip";

import axios from "axios";

import "./Whiteboard.css";

import {
  CloseIcon,
  IndentIcon,
  NumberListIcon,
} from "@fluentui/react-icons-northstar";
import dbImage from "../../Assets/images/subjects/db.png";
import Controls from "../../components/Controls";
import { Subscription } from "../../components/Subscription/Subscription";

import {
  Card,
  Dialog,
  Flex,
  Image,
  Label,
  Loader,
  Text,
} from "@fluentui/react-northstar";

import {
  Box,
  IconButton,
  Dialog as MUIDialog,
  Typography,
} from "@mui/material";

import moment from "moment";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";

import Imgart from "../../Assets/images/subjects/art.png";
import Imgcivil from "../../Assets/images/subjects/civil.png";
import Imghistory from "../../Assets/images/subjects/history.png";
import ImgnaturalScience from "../../Assets/images/subjects/natural-science.png";
import Imgother from "../../Assets/images/subjects/other.png";
import Imgphilosophy from "../../Assets/images/subjects/philosophy.png";
import ImgscienceExact from "../../Assets/images/subjects/science-exact.png";
import Imgtech from "../../Assets/images/subjects/tech.png";
import DateSelection from "../../Assets/images/svg/DateSelection.svg";
import LessonSelection from "../../Assets/images/svg/LessonSelection.svg";
import { StorageRequestDialog } from "../../components/Storage/StorageRequestDialog";
import AvailbleClass from "../Attendance/AvailbleClass";
import {
  isUndoIntent,
  isRedoIntent,
  getLanguageCode,
  isOpenLibraryIntent,
  isCloseLibraryIntent,
  isSwitchLibraryTopTabIntent,
  getLibraryTopTabTarget,
  isSwitchLibrarySidebarTabIntent,
  getLibrarySidebarTarget,
  isUseTemplateIntent,
  getUseTemplateTarget,
  isExportToCanvasIntent,
  getExportTarget,
  isExportSelectedCollectionIntent,
  isConfirmIntent,
  isCancelIntent,
  isAddNewPageIntent,
  isSwitchPageByNameIntent,
  getSwitchPageNameTarget,
  isCopyPageByNameIntent,
  isCopyPageByNumberIntent,
  getCopyPageNameTarget,
  isDeletePageByNameIntent,
  isDeletePageByNumberIntent,
  getDeletePageNameTarget,
  isSwitchPageByNumberIntent,
  getSwitchPageNumberTarget,
  isChangeBackgroundIntent,
  getBackgroundChangeTarget,
} from "../../utils/voiceIntents";

const url = process.env.REACT_APP_EP_URL;
const whiteboard_api_url = process.env.REACT_APP_EP_URL_WHITEBOARD_API;

const v = new Date(new Date().setHours(0, 0, 0, 0));
// const v = new Date(new Date().setUTCHours(0, 0, 0, 0));
let headers;
class Whiteboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      context: {},
      lessions: [],
      records: [],
      selectedLesson: null,
      showLesson: [],
      showRecords: [],
      showRecordsAnalytics: {
        virtual: 0,
        total: 0,
        present: 0,
        absent: 0,
        late: 0,
        justification: 0,
      },
      showTopic: false,
      showNote: false,
      selectedDate: v.toISOString(),
      selectedClass: null,
      selectedTeacher: null,
      response: {},
      checkAll: false,
      checkedRecords: [],
      checkedRecordsMode: [],
      onLine: null,
      load: false,
      dialog: false,
      isExpire: false,
      accDlg: false,
      collabLinkDlg: false,
      isJoinCollab: false,
      contactDlg: false,
      selectedLessonType: false,
      isCompactMode: false,
      collabLink: null,
      activeCollabLinks: [],
      isFlexibleGroups: [],
      classLists: [],
      isDateSelected: false,
      currentLanguage: "en",
      // iframeRef:null,
      isSubscribed: true,
      isActiveSession: {
        lessonId: null,
        active: false,
      },
      currentDate: null,
      isLoading: false,
      waitingDialog: false,
      isImageUploading: false,
      currentLsn: null,
      isShowWaitingDialog: false,
      isFullscreen: false,
      isEditable: false,
      isOpen: false,
      getSelectedData: v,
      selectedDay: null,
      lessonData: [],
      isDataNotAvailable: false,
      wbDataNotAvailable: false,
      isChangedLesson: false,
      // iframe: null,
      isMyWorkSpace: false,
      isReloadingWorkspace: false,
      activeStreamLinks: [],
      isLivestream: false,
      isConfirmLiveStream: false,
      mutationObserverWithWorkspace: false,
      // Spin Wheel (AI topics) dialog state
      isSpinWheelDialogOpen: false,
      spinWheelTopic: "",
      spinWheelLimit: 10,
      spinWheelSegments: [],
      isGeneratingSpinWheelTopics: false,
      spinWheelError: "",
    };
    // Bind language change handler
    this._onLangChange = this._onLangChange.bind(this);
    this.setupErrorListener = this.setupErrorListener.bind(this);
    this.refreshIframe = this.refreshIframe.bind(this);
    this.checkIframeStillRunning = this.checkIframeStillRunning.bind(this);
    this.handleIframeError = this.handleIframeError.bind(this);
    // --- Undo/Redo scaffolding ---
    this.undoStack = [];
    this.maxUndoItems = 100;
    this.redoStack = [];
    this.lastAction = null;
    this.isPerformingUndo = false;
    // Collection search state
    this.pendingCollectionPrompt = null;
    this.collectionsCache = null;
  }
  mutationObserver = null;

  componentDidMount() {
    try {
      const i18n = this.props?.i18n;
      const currentLang =
        (i18n && i18n.language) || localStorage.getItem("i18nextLng") || "en";
      if (currentLang && currentLang !== this.state.currentLanguage) {
        this.setState({ currentLanguage: currentLang });
        try {
          localStorage.setItem("i18nextLng", currentLang);
        } catch {}
        this._broadcastLanguageToWhiteboard(currentLang);
      }
      if (i18n && i18n.on) {
        i18n.on("languageChanged", this._onLangChange);
      }
    } catch (e) {
      /* noop */
    }
  }

  componentWillUnmount() {
    try {
      const i18n = this.props?.i18n;
      if (i18n && i18n.off && this._onLangChange) {
        i18n.off("languageChanged", this._onLangChange);
      }
    } catch (e) {
      /* noop */
    }
  }

  _onLangChange(lng) {
    const lang = lng || "en";
    this.setState({ currentLanguage: lang });
    try {
      localStorage.setItem("i18nextLng", lang);
    } catch {}
    this._broadcastLanguageToWhiteboard(lang);
  }

  _broadcastLanguageToWhiteboard(lang) {
    try {
      const iframe = document.querySelector("iframe.frameTag");
      if (iframe && iframe.contentWindow) {
        const base = getLanguageCode(lang);
        iframe.contentWindow.postMessage(
          {
            type: "acv.whiteboard.command",
            action: "setLanguage",
            payload: { lang: base },
          },
          "*"
        );
      }
    } catch (e) {
      /* noop */
    }
  }

  handleChangeLsn() {
    if (
      !this.state.isLoading &&
      !this.state.isImageUploading &&
      this.state.currentLsn &&
      !this.state.isEditable &&
      // This state is used to check if the user clicked on the card to change the lesson.
      // Without this state, glitches occur and the function gets called repeatedly.
      this.state.isChangedLesson
    ) {
      setTimeout(() => {
        this.setState({
          load: true,
          checkedRecords: [],
          checkedRecordsMode: [],
          selectedLesson: this.state.currentLsn,
          waitingDialog: false,
          isShowWaitingDialog: false,
          isChangedLesson: false,
        });
        this.fetchRecordsByLesson(this.state.currentLsn);
      }, 1000);
    }
  }

  checkForChildren = () => {
    const workspaceDiv = document.getElementById("my-workspace");
    const msg = JSON.parse(localStorage.getItem("msg"));
    this.props.getDb();
    if (
      workspaceDiv &&
      workspaceDiv.children.length > 0 &&
      !msg.isOpenWorkSpace
    ) {
      this.setState({ isMyWorkSpace: true, isReloadingWorkspace: false });
      localStorage.setItem(
        "msg",
        JSON.stringify({
          ...msg,
          isOpenWorkSpace: true,
          isReloadingWorkspace: false,
          access_token: this.props.user.accessToken,
          user: this.props.user,
          i18nextLng: localStorage.getItem("i18nextLng"),
        })
      );
    } else {
      this.setState({ isMyWorkSpace: false });
      localStorage.setItem(
        "msg",
        JSON.stringify({
          ...msg,
          isOpenWorkSpace: false,
          isReloadingWorkspace: false,
          access_token: this.props.user.accessToken,
          user: this.props.user,
          i18nextLng: localStorage.getItem("i18nextLng"),
        })
      );
    }
  };

  // --- Undo helpers for lesson changes ---
  getLessonDomKey = (lsn) => {
    try {
      if (!lsn) return null;
      // Prefer stable LessonId if present
      const id = lsn?.LessonId ?? lsn?.Title ?? null;
      if (id !== undefined && id !== null && id !== "") return String(id);
      // Fall back to composite key based on date/time/class
      const d = lsn?.LessonDate ?? "";
      const st = lsn?.StartTime ?? "";
      const et = lsn?.EndTime ?? "";
      const cn = lsn?.ClassName ?? "";
      return [d, st, et, cn].map((v) => String(v ?? "")).join("|");
    } catch (e) {
      return null;
    }
  };

  _pushUndoAction = (action) => {
    try {
      const entry = {
        timestamp: Date.now(),
        ...action,
      };
      // Keep a single fallback reference outside the stack
      this.lastAction = entry;
      try {
        sessionStorage.setItem(
          "ACV_WHITEBOARD_LAST_ACTION",
          JSON.stringify(entry)
        );
      } catch (e) {
        // Storage may be unavailable in some environments
      }
      this.undoStack.push(entry);
      if (this.undoStack.length > this.maxUndoItems) {
        this.undoStack.shift();
      }
    } catch (e) {}
  };

  _undoLastAction = async () => {
    let last = null;
    if (!this.undoStack || this.undoStack.length === 0) {
      // Use fallback lastAction when stack is empty
      if (this.lastAction) {
        last = this.lastAction;
        this.lastAction = null;
        try {
          sessionStorage.removeItem("ACV_WHITEBOARD_LAST_ACTION");
        } catch (e) {}
      } else {
        // Try persistent fallback
        try {
          const saved = sessionStorage.getItem("ACV_WHITEBOARD_LAST_ACTION");
          if (saved) {
            last = JSON.parse(saved);
            sessionStorage.removeItem("ACV_WHITEBOARD_LAST_ACTION");
          } else {
            return { success: false, message: "No recent action to undo." };
          }
        } catch (e) {
          return { success: false, message: "No recent action to undo." };
        }
      }
    } else {
      last = this.undoStack.pop();
    }

    try {
      // Prevent re-pushing while performing undo
      this.isPerformingUndo = true;
      if (last.type === "lesson") {
        const { showLesson } = this.state;
        // Try strict ID match first, normalizing type
        let prevLsn = null;
        const prevId = last?.previous;
        // If there was no previously selected lesson, clear selection
        if (prevId === undefined || prevId === null || prevId === "") {
          this.setState({ selectedLesson: null, showRecords: [] });
          return { success: true, message: "Cleared lesson selection." };
        }
        if (prevId !== undefined && prevId !== null && prevId !== "") {
          prevLsn = (showLesson || []).find(
            (l) =>
              String(l?.LessonId) === String(prevId) ||
              String(l?.Title) === String(prevId)
          );
        }
        // Fall back to stable DOM key
        if (!prevLsn && last?.previousKey) {
          prevLsn = (showLesson || []).find(
            (l) => this.getLessonDomKey(l) === last.previousKey
          );
        }
        if (prevLsn) {
          this.setState({ selectedLesson: prevLsn }, () => {
            this.fetchRecordsByLesson(prevLsn);
          });
          return { success: true, message: "Reverted last lesson change." };
        }
        return {
          success: false,
          message: "Previous lesson not found to undo.",
        };
      }
      // Unknown type
      return { success: false, message: "Nothing to undo for last action." };
    } catch (e) {
      return { success: false, message: "Undo failed. Please try again." };
    } finally {
      // After a successful undo attempt, push the undone entry to redo stack
      try {
        if (last) {
          this.redoStack.push(last);
          if (this.redoStack.length > this.maxUndoItems) this.redoStack.shift();
        }
      } catch (e) {}
      this.isPerformingUndo = false;
    }
  };

  _redoLastAction = async () => {
    if (!this.redoStack || this.redoStack.length === 0) {
      return { success: false, message: "No recent action to redo." };
    }
    const last = this.redoStack.pop();
    try {
      this.isPerformingUndo = true;
      if (last.type === "lesson") {
        const { showLesson } = this.state;
        // Try strict ID match first, normalizing type
        let nextLsn = null;
        const nextId = last?.next;
        // If next target implies clearing selection, do so
        if (nextId === undefined || nextId === null || nextId === "") {
          this.setState({ selectedLesson: null, showRecords: [] });
          return { success: true, message: "Cleared lesson selection." };
        }
        if (nextId !== undefined && nextId !== null && nextId !== "") {
          nextLsn = (showLesson || []).find(
            (l) =>
              String(l?.LessonId) === String(nextId) ||
              String(l?.Title) === String(nextId)
          );
        }
        // Fall back to stable DOM key
        if (!nextLsn && last?.nextKey) {
          nextLsn = (showLesson || []).find(
            (l) => this.getLessonDomKey(l) === last.nextKey
          );
        }
        if (nextLsn) {
          this.setState({ selectedLesson: nextLsn }, () => {
            this.fetchRecordsByLesson(nextLsn);
          });
          // After redo, make it undoable again
          this._pushUndoAction(last);
          return { success: true, message: "Reapplied last lesson change." };
        }
        return { success: false, message: "Next lesson not found to redo." };
      }
      return { success: false, message: "Nothing to redo for last action." };
    } catch (e) {
      return { success: false, message: "Redo failed. Please try again." };
    } finally {
      this.isPerformingUndo = false;
    }
  };

  // Voice command handler for Whiteboard lesson navigation
  handleVoiceCommand = async (command) => {
    // Extract command text from various possible properties
    const originalCommand =
      command?.originalCommand ||
      command?.text ||
      command?.providedText ||
      command?.currentTranscript ||
      "";
    const { type, lessonName } = command || {};
    // Early handling for Undo/Redo via raw speech (language-aware).
    // First, query the iframe whiteboard if it can undo/redo; if not, fall back to lesson.
    try {
      const rawText = originalCommand || "";
      const langCode = getLanguageCode(this.state?.currentLanguage || "en");
      // Prime WB caches once per session
      if (!this._voiceCachePrimed) {
        try {
          const iframeP = document.querySelector("iframe.frameTag");
          iframeP?.contentWindow?.postMessage(
            { type: "acv.whiteboard.command", action: "primeVoiceCache" },
            "*"
          );
          this._voiceCachePrimed = true;
        } catch {}
      }
      const sendWhiteboard = (action, payload = {}) => {
        const iframe = document.querySelector("iframe.frameTag");
        if (!iframe || !iframe.contentWindow) return false;
        iframe.contentWindow.postMessage(
          { type: "acv.whiteboard.command", action, payload },
          "*"
        );
        return true;
      };
      const performWhiteboard = (doAction) => {
        return new Promise((resolve) => {
          const timeout = setTimeout(() => {
            console.warn("[VOICE->WB]", doAction, "timeout waiting for reply");
            window.removeEventListener("message", onMessage);
            resolve(false);
          }, 600);
          const onMessage = (e) => {
            const d = e?.data;
            if (!d || d.type !== "acv.whiteboard.reply") return;
            if (d.action !== doAction) return;
            window.removeEventListener("message", onMessage);
            clearTimeout(timeout);
            resolve(!!d.handled);
          };
          window.addEventListener("message", onMessage);
          sendWhiteboard(doAction);
        });
      };
      if (rawText && isUndoIntent(rawText, langCode)) {
        const canvasHandled = await performWhiteboard("undo");
        if (canvasHandled)
          return { success: true, message: "Undid last whiteboard action." };
        const topUndo = this.undoStack?.[this.undoStack.length - 1] || null;
        const hasLessonUndo =
          (topUndo && topUndo.type === "lesson") ||
          (this.lastAction && this.lastAction.type === "lesson");
        if (hasLessonUndo) {
          const result = await this._undoLastAction();
          if (result?.message) {
            if (result.success) toast.success(result.message);
            else toast.error(result.message);
          }
          return result;
        }
        return { success: false, message: "Nothing to undo." };
      }
      if (rawText && isRedoIntent(rawText, langCode)) {
        const canvasHandled = await performWhiteboard("redo");
        if (canvasHandled)
          return { success: true, message: "Redid last whiteboard action." };
        const topRedo = this.redoStack?.[this.redoStack.length - 1] || null;
        const hasLessonRedo = topRedo && topRedo.type === "lesson";
        if (hasLessonRedo) {
          const result = await this._redoLastAction();
          if (result?.message) {
            if (result.success) toast.success(result.message);
            else toast.error(result.message);
          }
          return result;
        }
        return { success: false, message: "Nothing to redo." };
      }
    } catch (e) {}
    // Voice: open/close library dialog in the embedded whiteboard (multilingual)
    try {
      const rawText2 = command?.originalCommand || "";
      const langCode2 = getLanguageCode(this.state?.currentLanguage || "en");

      // CRITICAL: Check for collection prompt response FIRST, before any voice processing
      // This prevents "I want from collection" from being sent to whiteboard as insertByText/insertCollectionByTitle
      if (this.pendingCollectionPrompt && rawText2) {
        const normalizedCmd = String(rawText2 || "")
          .toLowerCase()
          .trim();
        const isCollectionResponse =
          /^(yes|collection|from collection|use collection|add from collection|use it|add it|from the collection|i want from collection|want from collection)$/i.test(
            normalizedCmd
          ) ||
          /(?:i\s+)?(?:want|need|get|use|add|put|show|bring)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
            normalizedCmd
          ) ||
          /(?:use|get|add|put|show)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
            normalizedCmd
          );

        if (isCollectionResponse) {
          console.log(
            "[VOICE-DEBUG] ✅✅✅ Collection response detected in EARLY voice handler, intercepting BEFORE any whiteboard calls:",
            normalizedCmd
          );
          const pending = this.pendingCollectionPrompt;
          this.pendingCollectionPrompt = null;

          if (pending.collectionMatch) {
            const { collection, file } = pending.collectionMatch;
            console.log("[VOICE-DEBUG] Adding collection item to canvas:", {
              collectionName: collection.name,
              fileUrl: file.url,
              itemName: pending.itemName,
            });

            const iframe = document.querySelector("iframe.frameTag");
            if (!iframe || !iframe.contentWindow) {
              console.error(
                "[VOICE-DEBUG] ❌ Failed - whiteboard iframe not available"
              );
              return { success: false, message: "Whiteboard not available" };
            }

            iframe.contentWindow.postMessage(
              {
                type: "acv.whiteboard.command",
                action: "addCollectionItem",
                payload: {
                  fileUrl: file.url,
                  collectionId: collection.id,
                  collectionName: collection.name,
                  fileName: file.id,
                },
              },
              "*"
            );

            toast.success(`Added ${pending.itemName} from collection`);
            console.log(
              "[VOICE-DEBUG] ✅ Successfully sent addCollectionItem to whiteboard"
            );
            return {
              success: true,
              message: `Added ${pending.itemName} from collection to canvas`,
            };
          }
        }
      }
      const sendWhiteboard2 = (action, payload = {}) => {
        const iframe = document.querySelector("iframe.frameTag");
        if (!iframe || !iframe.contentWindow) return false;
        iframe.contentWindow.postMessage(
          { type: "acv.whiteboard.command", action, payload },
          "*"
        );
        return true;
      };
      const getTopTabLabel = (key, lang) => {
        const base = String(lang || "en").toLowerCase().split("-")[0];
        const map = {
          collections: {
            en: "Collections",
            es: "Colecciones",
            pt: "Coleções",
            fr: "Collections",
            de: "Sammlungen",
            hi: "Collections",
            it: "Collezioni",
            ja: "コレクション",
          },
          myLibrary: {
            en: "My Library",
            es: "Mi biblioteca",
            pt: "Minha biblioteca",
            fr: "Ma bibliothèque",
            de: "Meine Bibliothek",
            hi: "मेरी लाइब्रेरी",
            it: "Mia libreria",
            ja: "私のライブラリ",
          },
        };
        const set = map[key] || map.collections;
        return set[base] || set.en;
      };
      const switchLibraryTopTabSafely = (tabName, lang) => {
        const localized = getTopTabLabel(
          tabName === "Collections" ? "collections" : "myLibrary",
          lang,
        );
        sendWhiteboard2("switchLibraryTopTab", { tab: localized });
        setTimeout(() => {
          sendWhiteboard2("switchLibraryTopTab", { tab: tabName });
        }, 25);
        setTimeout(() => {
          sendWhiteboard2("switchLibraryTopTab", { tab: String(tabName).toLowerCase() });
        }, 60);
      };
      

      const awaitReply = (doAction, payload = {}) => {
        return new Promise((resolve) => {
          const timeout = setTimeout(() => {
            window.removeEventListener("message", onMessage);
            console.warn(`[VOICE->WB] ${doAction} timeout after 3 seconds`);
            resolve(false);
          }, 7000); // Increased timeout to 7000ms to accommodate iframe operations
          const onMessage = (e) => {
            const d = e?.data;
            if (!d || d.type !== "acv.whiteboard.reply") return;
            if (d.action !== doAction) return;
            window.removeEventListener("message", onMessage);
            clearTimeout(timeout);
            console.log(`[VOICE->WB] ${doAction} reply received:`, d);
            resolve(!!d.handled);
          };
          window.addEventListener("message", onMessage);
          const sent = sendWhiteboard2(doAction, payload);
          if (!sent) {
            clearTimeout(timeout);
            console.warn(
              `[VOICE->WB] Failed to send ${doAction} - iframe not found`
            );
            resolve(false);
          }
        });
      };
      // Extract audio query (multilingual): e.g., "por favor pon el viento audio"
      const extractAudioQuery = (s) => {
        if (!s) return "";
        const sText = String(s).toLowerCase();
        // Require a leading verb to avoid false positives like "open audio library"
        const verbs = [
          // English
          "add",
          "insert",
          "import",
          "put",
          "place",
          "get",
          "get me",
          "use",
          "bring",
          "bring me",
          "need",
          "want",
          "show",
          "show me",
          "display",
          "give",
          "give me",
          "find",
          "find me",
          "open",
          "play",
          "load",
          "please",
          "please give me",
          "please show me",
          "please bring me",
          "please open",
          "please play",
          "please load",
          "please insert",
          "please add",
          "kindly",
          // Spanish
          "agrega",
          "agregar",
          "añade",
          "añadir",
          "inserta",
          "insertar",
          "importa",
          "importar",
          "pon",
          "poner",
          "coloca",
          "colocar",
          "trae",
          "traer",
          "muestra",
          "mostrar",
          "abre",
          "abrir",
          "reproduce",
          "reproducir",
          "carga",
          "cargar",
          "usa",
          "usar",
          "necesito",
          "quiero",
          "por favor",
          // Portuguese
          "adiciona",
          "adicionar",
          "insere",
          "inserir",
          "importa",
          "importar",
          "põe",
          "por",
          "coloca",
          "colocar",
          "traz",
          "trazer",
          "mostra",
          "mostrar",
          "abre",
          "abrir",
          "reproduz",
          "reproduzir",
          "carrega",
          "carregar",
          "usa",
          "usar",
          "preciso",
          "quero",
          "por favor",
          // French
          "ajoute",
          "ajouter",
          "insere",
          "insérer",
          "importe",
          "importer",
          "mets",
          "mettre",
          "place",
          "placer",
          "apporte",
          "apporter",
          "montre",
          "montrer",
          "ouvre",
          "ouvrir",
          "lire",
          "charge",
          "charger",
          "utilise",
          "utiliser",
          "je veux",
          "j'ai besoin",
          "s'il vous plaît",
          // German
          "hinzufüge",
          "hinzufugen",
          "hinzufügen",
          "einfüge",
          "einfügen",
          "importiere",
          "importieren",
          "stelle",
          "platzieren",
          "bringen",
          "zeige",
          "zeigen",
          "öffne",
          "öffnen",
          "abspielen",
          "lade",
          "laden",
          "verwende",
          "verwenden",
          "ich will",
          "ich möchte",
          "bitte",
          // Hindi
          "जोड़ें",
          "डालें",
          "आयात",
          "रखें",
          "स्थान",
          "लाओ",
          "दिखाओ",
          "खोलो",
          "चलाओ",
          "लोड",
          "इस्तेमाल",
          "मुझे चाहिए",
          "मैं चाहता हूँ",
          "कृपया",
          // Italian
          "aggiungi",
          "inserisci",
          "importa",
          "metti",
          "posa",
          "porta",
          "mostra",
          "aprire",
          "apri",
          "riproduci",
          "carica",
          "usa",
          "ho bisogno",
          "voglio",
          "per favore",
          // Japanese
          "追加",
          "挿入",
          "インポート",
          "置く",
          "配置",
          "持ってきて",
          "見せて",
          "開く",
          "再生",
          "読み込む",
          "使う",
          "欲しい",
          "必要",
          "お願いします",
        ];
        const hasVerb = verbs.some((v) => sText.includes(v));
        if (!hasVerb) return "";
        const audioMarkers = [
          " audio",
          " áudio",
          " audio", // fr/de/it commonly use 'audio'
          " sonido",
          " musique",
          " musik",
          " संगीत",
          " ऑडियो",
          " オーディオ",
          " 音声",
          " 음향", // fallback for ko if encountered
        ];
        let idx = -1;
        let marker = "";
        for (const m of audioMarkers) {
          const i = sText.indexOf(m);
          if (i !== -1) {
            idx = i;
            marker = m.trim();
            break;
          }
        }
        if (idx === -1) return "";
        const before = sText.slice(0, idx).trim();
        // Strip a leading verb phrase
        let query = before;
        for (const v of verbs) {
          const pv = v + " ";
          if (query.startsWith(pv)) {
            query = query.slice(pv.length);
            break;
          }
        }
        // If query is empty OR only an article/determiner, read after the marker using connectors
        const onlyArticles =
          /^(un|una|unos|unas|el|la|los|las|um|uma|uns|umas|o|a|os|as|une|des|le|la|les|du|de la|de l'|il|lo|gli|le|uno|ein|eine|einen|einem|einer|der|die|das|bir|een|het|de|al|ال|الـ)$/i;
        if (!query || onlyArticles.test(query.trim())) {
          const after = sText.slice(idx + marker.length).trim();
          const connectors = [
            "of ", // en
            "de ", // es/pt/fr
            "do ",
            "da ",
            "del ",
            "de la ",
            "de los ",
            "de las ",
            "des ",
            "du ",
            "de l'",
            "d' ",
            "von ", // de
            "का ", // hi (ka/ke/ki are complex; simple heuristic)
            "के ",
            "की ",
            "の ", // ja
            "van ", // nl
            "av ", // sv/no
            "af ", // da
            "من ", // ar
          ];
          let ofIdx = -1;
          for (const c of connectors) {
            const j = after.indexOf(c);
            if (j !== -1) {
              ofIdx = j;
              query = after.slice(j + c.length).trim();
              break;
            }
          }
          if (ofIdx === -1) {
            query = after.trim();
          }
        }
        // Avoid treating library mentions as queries
        const libraryNouns = [
          "library",
          "biblioteca",
          "bibliotheque",
          "bibliothèque",
          "bibliothek",
          "libreria",
          "ライブラリ",
          "लाइब्रेरी",
        ];
        const near = sText.slice(Math.max(0, idx - 20), idx + 20);
        if (libraryNouns.some((w) => near.includes(w))) return "";
        // Cleanup fillers, common verbs, articles/determiners, quotes
        query = query
          .replace(
            /\b(please|kindly|por favor|s'il vous plaît|per favore|bitte)\b/g,
            ""
          )
          .replace(
            /\b(give me|show me|bring me|muéstrame|muestrame|tráeme|traeme)\b/g,
            ""
          )
          .replace(
            /\b(give|show|bring|play|open|load|insert|add|get|abre|abrir|adicionar|inserir|aggiungi|inserisci|zeige|öffne|abspielen|play|open|load)\b/g,
            ""
          )
          .replace(
            /\b(a|an|the|me|la|el|o|a|un|una|unos|unas|um|uma|uns|umas|os|as|une|des|ein|eine|einen|einem|einer|il|lo|gli|le|uno|het|een|bir|ال|الـ)\b/g,
            ""
          )
          .replace(/^["'“”‘’]+|["'“”‘’]+$/g, "")
          .replace(/\b(hi|hello|hey|ok|okay)\b/g, "")
          .replace(/\s+/g, " ")
          .trim();
        return query;
      };

      const handleAudioRequest = async (query) => {
        if (!query) return false;
        const base = query.trim().toLowerCase();
        const ok = await awaitReply("insertAudioByQuery", { query: base });
        if (ok) {
          toast.success(`Added audio: ${base}`);
          return true;
        }
        toast.error(`No matching audio found for "${query}".`);
        return false;
      };

      const audioQuery = extractAudioQuery(rawText2);
      if (audioQuery) {
        const ok = await handleAudioRequest(audioQuery);
        if (ok)
          return { success: true, message: `Inserted audio: ${audioQuery}` };
        return {
          success: false,
          message: `Audio not available: ${audioQuery}`,
        };
      }
      // EARLY: Handle spinner generation BEFORE any library intents to avoid opening library
      const isSpinnerIntent = (text) => {
        if (!text) return false;
        const s = String(text).toLowerCase();
        // Be tolerant of ASR mishearings and add multilingual synonyms
        // English variants
        if (
          /\bspin(?:ning)?\s*(wheel|well|will)\b/.test(s) ||
          /\bspinner\b/.test(s) ||
          /\bspeed\s*(wheel|well|will)\b/.test(s)
        ) {
          return true;
        }
        // Spanish
        if (
          /(?:girar|generar|crear|hacer)\s+(?:la\s+)?(?:ruleta|rueda)\b/.test(
            s
          ) ||
          /\b(ruleta|rueda)\b/.test(s)
        )
          return true;
        // Portuguese
        if (
          /(?:girar|gerar|criar|fazer)\s+(?:a\s+)?(?:roleta|roda)\b/.test(s) ||
          /\b(roleta|roda)\b/.test(s)
        )
          return true;
        // French
        if (
          /(?:tourner|générer|créer|faire)\s+(?:la\s+)?(?:roue|roulette)\b/.test(
            s
          ) ||
          /\b(roue|roulette)\b/.test(s)
        )
          return true;
        // German
        if (
          /(?:drehen|erzeugen|erstellen|machen)\s+(?:das\s+)?(?:rad|glücksrad)\b/.test(
            s
          ) ||
          /\b(rad|glücksrad)\b/.test(s)
        )
          return true;
        // Italian
        if (
          /(?:girare|generare|creare|fare)\s+(?:la\s+)?(?:ruota|roulette)\b/.test(
            s
          ) ||
          /\b(ruota|roulette)\b/.test(s)
        )
          return true;
        // Japanese + Hindi
        if (/(ルーレット|ホイール|スピナー|पहिया)/.test(s)) return true;
        return false;
      };
      const extractSpinnerSegments = (text) => {
        if (!text) return [];
        const s = String(text).toLowerCase();

        let segStr = "";
        const withIdx = s.indexOf(" with ");
        if (withIdx !== -1) {
          segStr = s.slice(withIdx + 6).trim();
        } else {
          const m = s.match(
            /(?:spin\s*(?:wheel|well|will)|spinner|spinning\s*(?:wheel|well|will)|(?:girar|generar|crear|hacer)\s+(?:ruleta|rueda)|(?:girar|gerar|criar|fazer)\s+(?:roleta|roda)|(?:tourner|générer|créer|faire)\s+(?:roue|roulette)|(?:drehen|erzeugen|erstellen|machen)\s+(?:rad|glücksrad)|(?:girare|generare|creare|fare)\s+(?:ruota|roulette)|(?:ルーレット|ホイール|スピナー))\s*(?:with|of|on|for|con|de|para|com|em|en|pour|für|per|の|で|を|に)?\s*(.*)$/
          );
          if (m && m[1]) segStr = m[1].trim();
        }
        if (!segStr) return [];
        segStr = segStr.replace(/\s+and\s+/g, ",");
        const raw = segStr.split(/\s*,\s*/).filter(Boolean);
        const cleaned = raw
          .map((x) =>
            x
              .replace(/^(the|a|an)\s+/i, "")
              .replace(/[\.;:!?]+$/g, "")
              .trim()
          )
          .filter((x) => x.length > 0)
          .map((x) => x.replace(/\b(scies|sci|sci\.)\b/i, "science"));
        const titled = cleaned.map((w) =>
          w.replace(/(^|\s)([a-z])/g, (m, p1, p2) => p1 + p2.toUpperCase())
        );
        return titled;
      };
      if (isSpinnerIntent(rawText2)) {
        const segs = extractSpinnerSegments(rawText2);
        const s = String(rawText2 || "").toLowerCase();
        // Extract candidate subject for AI topics
        let candidate = "";
        const m = s.match(
          /(?:spin\s*(?:wheel|well|will)|spinner|spinning\s*(?:wheel|well|will)|(?:girar|generar|crear|hacer)\s+(?:ruleta|rueda)|(?:girar|gerar|criar|fazer)\s+(?:roleta|roda)|(?:tourner|générer|créer|faire)\s+(?:roue|roulette)|(?:drehen|erzeugen|erstellen|machen)\s+(?:rad|glücksrad)|(?:girare|generare|creare|fare)\s+(?:ruota|roulette)|(?:ルーレット|ホイール|スピナー))\s*(?:with|of|on|for|con|de|para|com|em|en|pour|für|per|の|で|を|に)?\s*(.*)$/
        );
        if (m && m[1]) {
          candidate = m[1]
            .replace(/^(the|a|an)\s+/i, "")
            .replace(/[\.;:!?]+$/g, "")
            .trim();
        }
        // Fallback: if the verb pattern didn't match (e.g., Spanish "genera"),
        // try to capture the phrase after common connectors in multiple languages.
        if (!candidate) {
          const connectors = [
            " with ",
            " of ",
            " on ",
            " for ",
            " con ",
            " de ",
            " para ",
            " com ",
            " em ",
            " en ",
            " pour ",
            " für ",
            " per ",
            " の ",
            " で ",
            " を ",
            " に ",
          ];
          for (const c of connectors) {
            const j = s.lastIndexOf(c);
            if (j !== -1) {
              candidate = s.slice(j + c.length).trim();
              break;
            }
          }
        }
        // Normalize leading articles and common phrases like "el nombre de".
        if (candidate) {
          candidate = candidate
            .replace(/^\s+/, "")
            .replace(/^[\-•]+/, "")
            .replace(/[\.;:!?]+$/g, "")
            .replace(/^(the|a|an)\s+/i, "")
            // Spanish
            .replace(/^(el|la|los|las|un|una|unos|unas)\s+/i, "")
            .replace(/^(el|la)\s+nombre\s+de\s+/i, "")
            // Portuguese
            .replace(/^(o|a|os|as|um|uma|uns|umas)\s+/i, "")
            .replace(/^(o|a)\s+nome\s+de\s+/i, "")
            // French
            .replace(/^(le|la|les|un|une|des|du|de la|de l')\s+/i, "")
            // German
            .replace(/^(der|die|das|ein|eine|einen|einem|einer)\s+/i, "")
            // Italian
            .replace(/^(il|lo|la|i|gli|le|un|una)\s+/i, "")
            // Generic English phrase
            .replace(/^(name\s+of\s+|the\s+name\s+of\s+)/i, "")
            .trim();
        }
        // If user listed multiple segments (comma/and), generate spinner immediately
        if (segs && segs.length > 1) {
          const ok = await awaitReply("generateSpinnerImageToCanvas", {
            segments: segs,
            size: 600,
          });
          if (ok) {
            try {
              window.dispatchEvent(
                new CustomEvent("ACV_SPINWHEEL_STATUS", {
                  detail: { status: "inserted" },
                })
              );
            } catch (e) {}
            toast.success("Generated spinner to canvas.");
            return { success: true, message: "Spinner added to canvas." };
          }
          try {
            window.dispatchEvent(
              new CustomEvent("ACV_SPINWHEEL_STATUS", {
                detail: { status: "error" },
              })
            );
          } catch (e) {}
          toast.error("Could not generate spinner.");
          return { success: false, message: "Spinner generation failed." };
        }
        // Single word/subject (e.g., "food name") → open dialog and auto-generate topics
        this.openSpinWheelDialogWith(candidate, true);
        try {
          window.dispatchEvent(
            new CustomEvent("ACV_SPINWHEEL_STATUS", {
              detail: { status: "generating" },
            })
          );
        } catch (e) {}
        return { success: true, message: "Generating spin wheel…" };
      }
      if (isConfirmIntent(rawText2, langCode2)) {
        const ok = await awaitReply("confirmActiveDialog");
        if (ok) {
          toast.success("Confirmed dialog.");
          return { success: true, message: "Confirmed dialog." };
        } else {
          // Check if iframe exists to provide better error message
          const iframe = document.querySelector("iframe.frameTag");
          if (!iframe || !iframe.contentWindow) {
            toast.error("Whiteboard not loaded.");
            return { success: false, message: "Whiteboard not loaded." };
          } else {
            toast.error("No active dialog to confirm.");
            return { success: false, message: "No active dialog to confirm." };
          }
        }
      }
      if (isCancelIntent(rawText2, langCode2)) {
        // Option C: prioritize delete-frame when text mentions a frame and delete-like verbs
        const s = String(rawText2 || "")
          .toLowerCase()
          .trim();
        const mentionsFrame = /\bframe\b/.test(s);
        const hasDeleteVerb =
          /(\bdelete\b|\bremove\b|\berase\b|\bclear\b)/.test(s);
        // Also detect common ASR mishearing: "from" used instead of "frame",
        // with a number or ordinal following (e.g., "remove from one")
        const looksLikeFromNumber =
          /\bfrom\s+(?:the\s+)?(?:frame\s+)?(\d+|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|thirteen|fourteen|fifteen|sixteen|seventeen|eighteen|nineteen|twenty|thirty|forty|fifty|sixty|seventy|eighty|ninety|first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth|eleventh|twelfth|thirteenth|fourteenth|fifteenth|sixteenth|seventeenth|eighteenth|nineteenth|twentieth)\b/.test(
            s
          );
        if (
          !(mentionsFrame && hasDeleteVerb) &&
          !(hasDeleteVerb && looksLikeFromNumber)
        ) {
          const ok = await awaitReply("cancelActiveDialog");
          if (ok) {
            toast.info("Canceled dialog.");
            return { success: true, message: "Canceled dialog." };
          } else {
            // Fallback: only attempt to close the library when the utterance
            // explicitly references a library/dialog/modal.
            const mentionsLibraryOrDialog =
              /\blibrary\b|\bdialog\b|\bmodal\b/.test(s) ||
              isCloseLibraryIntent(rawText2, langCode2) ||
              isOpenLibraryIntent(rawText2, langCode2);
            if (mentionsLibraryOrDialog) {
              const closed = await awaitReply("closeLibrary");
              if (closed) {
                toast.info("Closed library.");
                return { success: true, message: "Closed library." };
              }
            }
            // Provide a more helpful error if the whiteboard iframe isn't available
            const iframe = document.querySelector("iframe.frameTag");
            if (!iframe || !iframe.contentWindow) {
              toast.error("Whiteboard not loaded.");
              return { success: false, message: "Whiteboard not loaded." };
            }
            // If the utterance doesn't mention library/dialog, treat this as an
            // unrecognized cancel attempt rather than showing a cancel-button error.
            if (!mentionsLibraryOrDialog) {
              toast.error("Command not recognized.");
              return { success: false, message: "Command not recognized." };
            }
            toast.error("No cancel button available.");
            return { success: false, message: "No cancel button available." };
          }
        }
        // If it's a frame deletion utterance, skip cancel so delete-frame handler runs later
      }
      if (isOpenLibraryIntent(rawText2, langCode2)) {
        const targetTopTabEarly = getLibraryTopTabTarget(rawText2, langCode2);
        const wantsTopTabEarly =
          !!targetTopTabEarly && isSwitchLibraryTopTabIntent(rawText2, langCode2);
        if (wantsTopTabEarly) {
          const tabNameEarly =
            targetTopTabEarly === "collections" ? "Collections" : "My Library";
          const ok = await awaitReply("openLibrary");
          if (!ok) sendWhiteboard2("openLibrary");
          setTimeout(() => {
            switchLibraryTopTabSafely(tabNameEarly, langCode2);
            setTimeout(() => switchLibraryTopTabSafely(tabNameEarly, langCode2), 150);
          }, 60);
          return {
            success: true,
            message: `Opened library — ${tabNameEarly}`,
          };
        }
        sendWhiteboard2("openLibrary");
        return { success: true, message: "Opened library." };
      }
      // Removed: editor switching intent; rely on explicit close commands only
      if (isCloseLibraryIntent(rawText2, langCode2)) {
        sendWhiteboard2("closeLibrary");
        return { success: true, message: "Closed library." };
      }
      // Add a new whiteboard page
      if (isAddNewPageIntent(rawText2, langCode2)) {
        const ok = await awaitReply("addNewPage");
        if (ok) {
          toast.success("Added a new page.");
          return { success: true, message: "Added a new page." };
        } else {
          toast.error("Unable to add a page.");
          return { success: false, message: "Unable to add a page." };
        }
      }
      // Change background color or make it transparent (multilingual)
      {
        const bgTarget = getBackgroundChangeTarget(rawText2, langCode2);
        if (bgTarget && isChangeBackgroundIntent(rawText2, langCode2)) {
          const attempts = [];
          if (bgTarget.type === "transparent") {
            attempts.push({
              action: "setBackground",
              payload: { transparent: true },
            });
            attempts.push({ action: "setBackgroundTransparent", payload: {} });
            attempts.push({ action: "backgroundTransparent", payload: {} });
          } else if (bgTarget.type === "color" && bgTarget.value) {
            attempts.push({
              action: "setBackground",
              payload: { color: bgTarget.value },
            });
            attempts.push({
              action: "setBackgroundColor",
              payload: { color: bgTarget.value },
            });
            attempts.push({
              action: "setCanvasBackground",
              payload: { color: bgTarget.value },
            });
            attempts.push({
              action: "backgroundColor",
              payload: { color: bgTarget.value },
            });
          }
          for (const a of attempts) {
            const ok = await awaitReply(a.action, a.payload);
            if (ok) {
              const msg =
                bgTarget.type === "transparent"
                  ? "Made background transparent."
                  : `Changed background to ${bgTarget.value}.`;
              toast.success(msg);
              return { success: true, message: msg };
            }
          }
          toast.error("Unable to change background.");
          return { success: false, message: "Unable to change background." };
        }
      }
      // Guard: if the utterance looks like an export/save/download action,
      // do not treat it as a page switch. This prevents "export page 1 as image"
      // from being intercepted by page-switch logic.
      const looksLikeExport = (() => {
        const sLower = String(rawText2 || "").toLowerCase();
        const hasExportVerb = /(\bexport\b|\bsave\b|\bdownload\b)/.test(sLower);
        const hasFormatMention =
          /(\bas\b|\bis\b)\s+(image|png|svg|picture|file|json|data)/.test(
            sLower
          );
        const hasExportDialog =
          /(open|show)\s+(export|save)\s+(dialog|menu|options)/.test(sLower);
        return hasExportVerb || hasFormatMention || hasExportDialog;
      })();
      // Debug: surface which page intent is being detected and extracted
      try {
        const numIntent = isSwitchPageByNumberIntent(rawText2, langCode2);
        const numTarget = getSwitchPageNumberTarget(rawText2, langCode2);
        const nameIntent = isSwitchPageByNameIntent(rawText2, langCode2);
        const nameTarget = getSwitchPageNameTarget(rawText2, langCode2);
        console.log("[VOICE-DEBUG] page-intent check:", {
          numIntent,
          numTarget,
          nameIntent,
          nameTarget,
          rawText2,
        });
      } catch (e) {
        // noop
      }
      // Delete page by explicit number first
      if (!looksLikeExport && isDeletePageByNumberIntent(rawText2, langCode2)) {
        const targetNum = getSwitchPageNumberTarget(rawText2, langCode2);
        if (Number.isInteger(targetNum)) {
          toast.info(`Deleting page ${targetNum}…`);
          const ok = await awaitReply("deletePageByNumber", { number: targetNum });
          if (ok) {
            toast.success(`Deleted page ${targetNum}.`);
            return { success: true, message: `Deleted page ${targetNum}.` };
          } else {
            toast.error(`Couldn’t delete page ${targetNum}.`);
            return { success: false, message: `Couldn’t delete page ${targetNum}.` };
          }
        }
      }
      // If the utterance clearly intends to copy a numeric page, handle that first
      if (!looksLikeExport && isCopyPageByNumberIntent(rawText2, langCode2)) {
        const targetNum = getSwitchPageNumberTarget(rawText2, langCode2);
        if (Number.isInteger(targetNum)) {
          const ok = await awaitReply("copyPageByNumber", { number: targetNum });
          if (ok) {
            toast.success(`Copied page ${targetNum}.`);
            return { success: true, message: `Copied page ${targetNum}.` };
          } else {
            toast.error(`Couldn’t copy page ${targetNum}.`);
            return { success: false, message: `Couldn’t copy page ${targetNum}.` };
          }
        }
      }
      // Priority order for page actions: copy -> delete -> switch by name -> switch by number
      // Copy page by dynamic name or by number
      if (!looksLikeExport && isCopyPageByNameIntent(rawText2, langCode2)) {
        const targetName = getCopyPageNameTarget(rawText2, langCode2);
        const numericTarget = getSwitchPageNumberTarget(rawText2, langCode2);
        if (Number.isInteger(numericTarget)) {
          const ok = await awaitReply("copyPageByNumber", {
            number: numericTarget,
          });
          if (ok) {
            toast.success(`Copied page ${numericTarget}.`);
            return { success: true, message: `Copied page ${numericTarget}.` };
          }
          // if numeric attempt fails, fall back to name below
        }
        if (targetName) {
          const ok = await awaitReply("copyPageByName", { name: targetName });
          if (ok) {
            toast.success(`Copied page "${targetName}".`);
            return { success: true, message: `Copied page "${targetName}".` };
          } else {
            toast.error(`Couldn’t copy page "${targetName}".`);
            return {
              success: false,
              message: `Couldn’t copy page "${targetName}".`,
            };
          }
        }
      }
      // Delete page by dynamic name
      if (!looksLikeExport && isDeletePageByNameIntent(rawText2, langCode2)) {
        const targetName = getDeletePageNameTarget(rawText2, langCode2);
        if (targetName) {
          toast.info(`Deleting page "${targetName}"…`);
          const ok = await awaitReply("deletePageByName", { name: targetName });
          if (ok) {
            toast.success(`Deleted page "${targetName}".`);
            return { success: true, message: `Deleted page "${targetName}".` };
          } else {
            toast.error(`Couldn’t delete page "${targetName}".`);
            return {
              success: false,
              message: `Couldn’t delete page "${targetName}".`,
            };
          }
        }
      }
      // Switch page by dynamic name (skip if this looks like an export command)
      if (!looksLikeExport && isSwitchPageByNameIntent(rawText2, langCode2)) {
        const targetName = getSwitchPageNameTarget(rawText2, langCode2);
        if (targetName) {
          const ok = await awaitReply("switchPageByName", { name: targetName });
          if (ok) {
            toast.success(`Switched to page "${targetName}".`);
            return {
              success: true,
              message: `Switched to page "${targetName}".`,
            };
          } else {
            toast.error(`Page "${targetName}" not available.`);
            return {
              success: false,
              message: `Page "${targetName}" not available.`,
            };
          }
        }
      }
      // Switch page by explicit number (skip if this looks like an export command)
      if (
        !looksLikeExport &&
        !isCopyPageByNumberIntent(rawText2, langCode2) &&
        !isCopyPageByNameIntent(rawText2, langCode2) &&
        !isDeletePageByNumberIntent(rawText2, langCode2) &&
        !isDeletePageByNameIntent(rawText2, langCode2) &&
        !isSwitchPageByNameIntent(rawText2, langCode2) &&
        isSwitchPageByNumberIntent(rawText2, langCode2)
      ) {
        const targetNum = getSwitchPageNumberTarget(rawText2, langCode2);
        if (Number.isInteger(targetNum)) {
          const ok = await awaitReply("switchPageByNumber", {
            number: targetNum,
          });
          if (ok) {
            toast.success(`Switched to page ${targetNum}.`);
            return { success: true, message: `Switched to page ${targetNum}.` };
          } else {
            toast.error(`Page ${targetNum} not available.`);
            return {
              success: false,
              message: `Page ${targetNum} not available.`,
            };
          }
        }
      }
      // Fallback: attempt numeric switch only if not copy/delete/name-switch was detected
      {
        if (
          !looksLikeExport &&
          !isCopyPageByNumberIntent(rawText2, langCode2) &&
          !isCopyPageByNameIntent(rawText2, langCode2) &&
          !isDeletePageByNumberIntent(rawText2, langCode2) &&
          !isDeletePageByNameIntent(rawText2, langCode2) &&
          !isSwitchPageByNameIntent(rawText2, langCode2)
        ) {
          const targetNumFallback = getSwitchPageNumberTarget(
            rawText2,
            langCode2
          );
          if (Number.isInteger(targetNumFallback)) {
            const ok = await awaitReply("switchPageByNumber", {
              number: targetNumFallback,
            });
            if (ok) {
              toast.success(`Switched to page ${targetNumFallback}.`);
              return {
                success: true,
                message: `Switched to page ${targetNumFallback}.`,
              };
            }
          }
        }
      }
      // If the user clearly mentioned a page but no valid number/name was resolved, surface a page-specific error
      try {
        const mentionsPage =
          /\b(page|pages|pagina|página|seite|pagine|ページ)\b/i.test(
            rawText2 || ""
          );
        const hasNum = Number.isInteger(
          getSwitchPageNumberTarget(rawText2, langCode2)
        );
        const hasName = !!getSwitchPageNameTarget(rawText2, langCode2);
        // Do not emit a page error if this looks like an export/save/download command
        if (!looksLikeExport && mentionsPage && !hasNum && !hasName) {
          toast.error("Page not available.");
          return { success: false, message: "Page not available." };
        }
      } catch (_) {}
      // Prefer switching sidebar/category first if a precise target exists
      const sidebarTarget = getLibrarySidebarTarget(rawText2, langCode2);
      let didSwitchSidebar = false;
      let switchMessage = null;
      if (
        sidebarTarget &&
        isSwitchLibrarySidebarTabIntent(rawText2, langCode2)
      ) {
        const topTabName =
          sidebarTarget.topTab === "collections"
            ? "Collections"
            : sidebarTarget.topTab === "myLibrary"
            ? "My Library"
            : undefined;
        const qLower = (sidebarTarget.query || "").toLowerCase();
        const isCollectionCategory = [
          "template",
          "stock image",
          "my collection",
          "my collections",
          "images",
          "videos",
          "audios",
          "under review",
          "liked",
          "bookmark",
        ].some((k) => qLower.includes(k));
        const shouldGoCollections =
          topTabName === "Collections" || isCollectionCategory;
        const actionName = shouldGoCollections
          ? "switchCollectionSidebarTab"
          : "switchLibrarySidebarTab";
        const payload = {
          tab: sidebarTarget.query,
          ...(topTabName ? { topTab: topTabName } : {}),
        };
        sendWhiteboard2(actionName, payload);
        didSwitchSidebar = true;
        switchMessage = `Switched ${
          shouldGoCollections ? "collections" : "library"
        } sidebar${topTabName ? ` in ${topTabName}` : ""} to "${
          sidebarTarget.query
        }".`;
      }
      const targetTopTab = getLibraryTopTabTarget(rawText2, langCode2);
      if (targetTopTab && isSwitchLibraryTopTabIntent(rawText2, langCode2)) {
        const tabName =
          targetTopTab === "collections" ? "Collections" : "My Library";
        const ok = await awaitReply("openLibrary");
        if (!ok) sendWhiteboard2("openLibrary");
        setTimeout(() => {
          switchLibraryTopTabSafely(tabName, langCode2);
          setTimeout(() => switchLibraryTopTabSafely(tabName, langCode2), 150);
        }, 60);
        didSwitchSidebar = true;
        switchMessage = `Opened library — ${tabName}`;
      }
      // Use/export intents via verbs; sanitize names to avoid trailing fillers
      const sText = rawText2 || "";
      if (isExportSelectedCollectionIntent(sText, langCode2)) {
        sendWhiteboard2("exportSelectedCategories");
        return {
          success: true,
          message: "Exporting selected collection to canvas.",
        };
      }
      const wantsUse = isUseTemplateIntent(sText, langCode2);
      const wantsExport = isExportToCanvasIntent(sText, langCode2);
      let templateName = getUseTemplateTarget(sText, langCode2);
      const target = getExportTarget(sText, langCode2);
      let exportTargetName = target?.templateName || "";

      const mentionsCollection =
        /(collection|collections|library|libraries|category|categories)/i.test(
          sText
        );
      const mentionsTemplate = /(template|templates)/i.test(sText);
      const mentionsSelected = /(selected|current|marked|chosen)/i.test(sText);

      // Fallback for "export selected collection" even without canvas mention
      if (
        !templateName &&
        !exportTargetName &&
        mentionsSelected &&
        mentionsCollection
      ) {
        sendWhiteboard2("exportSelectedCategories");
        return {
          success: true,
          message: "Exporting selected collection to canvas.",
        };
      }

      const sanitize = (n) =>
        (n || "")
          .replace(/^\s*(the|a|an)\s+/i, "")
          // Keep nouns and numbers in the actual name (e.g., "New collection", "Collection 5"); only strip filler words
          .replace(
            /\s+(now|please|today|tonight|currently|right\s*now)\s*$/i,
            ""
          )
          .replace(/[\.,;:!?]+$/, "")
          .trim();

      templateName = sanitize(templateName);
      exportTargetName = sanitize(exportTargetName);

      0; // 3.4) Video request intent: local-only (no stock video API)
      const extractVideoQuery = (text) => {
        if (!text) return "";
        const s = String(text).toLowerCase();
        // Require verbs to avoid false positives
        const verbs = [
          "add",
          "insert",
          "import",
          "put",
          "place",
          "get",
          "get me",
          "use",
          "bring",
          "bring me",
          "need",
          "want",
          "show",
          "show me",
          "display",
          "give",
          "give me",
          "find",
          "find me",
          "open",
          "play",
          "load",
          "please",
          "please give me",
          "please show me",
          "please bring me",
          "please open",
          "please play",
          "please load",
          "please insert",
          "please add",
          "kindly",
          // es/pt/fr/de/it/hi/ja
          "agrega",
          "agregar",
          "añade",
          "añadir",
          "inserta",
          "insertar",
          "importa",
          "pon",
          "poner",
          "coloca",
          "trae",
          "muestra",
          "mostrar",
          "abre",
          "abrir",
          "reproduce",
          "reproducir",
          "carga",
          "cargar",
          "usa",
          "usar",
          "necesito",
          "quiero",
          "por favor",
          "adiciona",
          "adicionar",
          "insere",
          "inserir",
          "importa",
          "por",
          "coloca",
          "traz",
          "mostrar",
          "mostra",
          "abre",
          "abrir",
          "reproduz",
          "reproduzir",
          "carrega",
          "carregar",
          "usa",
          "usar",
          "preciso",
          "quero",
          "por favor",
          "ajoute",
          "ajouter",
          "insere",
          "insérer",
          "importe",
          "mettre",
          "place",
          "placer",
          "apporte",
          "montrer",
          "ouvre",
          "ouvrir",
          "lire",
          "charge",
          "charger",
          "utilise",
          "utiliser",
          "je veux",
          "s'il vous plaît",
          "hinzufügen",
          "einfügen",
          "importieren",
          "stellen",
          "platzieren",
          "bringen",
          "zeigen",
          "öffne",
          "öffnen",
          "abspielen",
          "lade",
          "laden",
          "verwende",
          "verwenden",
          "bitte",
          "जोड़ें",
          "डालें",
          "आयात",
          "रखें",
          "स्थान",
          "लाओ",
          "दिखाओ",
          "खोलो",
          "चलाओ",
          "लोड",
          "इस्तेमाल",
          "मुझे चाहिए",
          "मैं चाहता हूँ",
          "कृपया",
          "aggiungi",
          "inserisci",
          "importa",
          "metti",
          "posa",
          "porta",
          "mostra",
          "apri",
          "aprire",
          "riproduci",
          "carica",
          "usa",
          "voglio",
          "per favore",
          "追加",
          "挿入",
          "インポート",
          "置く",
          "配置",
          "持ってきて",
          "見せて",
          "開く",
          "再生",
          "読み込む",
          "使う",
          "お願いします",
        ];
        const hasVerb = verbs.some((v) => s.includes(v));
        if (!hasVerb) return "";
        const markers = [
          " video",
          " vídeo",
          " vidéo",
          " video", // de/it
          " ビデオ",
          " 動画",
          " वीيديو",
          " वीڈیو", // handle possible ASR transliterations
          " clip",
          " footage",
        ];
        let idx = -1;
        let marker = "";
        for (const m of markers) {
          const i = s.indexOf(m);
          if (i !== -1) {
            idx = i;
            marker = m.trim();
            break;
          }
        }
        if (idx === -1) return "";
        const before = s.slice(0, idx).trim();
        // Strip a leading verb phrase
        let query = before;
        for (const v of verbs) {
          const pv = v + " ";
          if (query.startsWith(pv)) {
            query = query.slice(pv.length);
            break;
          }
        }
        // If query is only an article/determiner (e.g., "un", "una", "um", "une", "ein"), treat as empty to use connectors after the marker
        const onlyArticles =
          /^(un|una|unos|unas|el|la|los|las|um|uma|o|a|os|as|une|des|le|la|les|il|lo|gli|le|uno|eine|ein|einen|einem|einer|der|die|das)$/i;
        if (!query || onlyArticles.test(query.trim())) {
          const after = s.slice(idx + marker.length).trim();
          const connectors = [
            "of ",
            "de ",
            "do ",
            "da ",
            "del ",
            "de la ",
            "des ",
            "du ",
            "von ",
            "का ",
            "के ",
            "की ",
            "の ",
          ];
          let found = false;
          for (const c of connectors) {
            const j = after.indexOf(c);
            if (j !== -1) {
              query = after.slice(j + c.length).trim();
              found = true;
              break;
            }
          }
          if (!found) query = after.trim();
        }
        // Avoid library nouns near the marker
        const libraryNouns = [
          "library",
          "biblioteca",
          "bibliotheque",
          "bibliothèque",
          "bibliothek",
          "libreria",
          "ライブラリ",
          "लाइब्रेरी",
        ];
        const near = s.slice(Math.max(0, idx - 20), idx + 20);
        if (libraryNouns.some((w) => near.includes(w))) return "";
        // Cleanup
        query = query
          .replace(
            /\b(please|kindly|por favor|s'il vous plaît|per favore|bitte)\b/g,
            ""
          )
          .replace(
            /\b(give me|show me|bring me|muéstrame|muestrame|tráeme|traeme)\b/g,
            ""
          )
          .replace(
            /\b(give|show|bring|play|open|load|insert|add|get|abre|abrir|adicionar|inserir|aggiungi|inserisci|zeige|öffne|abspielen)\b/g,
            ""
          )
          .replace(
            /\b(a|an|the|me|la|el|o|a|un|una|unos|unas|um|uma|os|as|une|des|ein|eine|einen|einem|einer|il|lo|gli|le|uno)\b/g,
            ""
          )
          .replace(/\b(hi|hello|hey|ok|okay)\b/g, "")
          .replace(/\s+/g, " ")
          .trim();
        return query;
      };

      // 3.5) Image request intent: treat "insert/añadir/adicionar image [query]" as insertImageByQuery
      const extractImageQuery = (text) => {
        if (!text) return "";
        const s = String(text).toLowerCase();
        const verbs = [
          "add",
          "insert",
          "import",
          "put",
          "place",
          "use",
          "bring",
          "show",
          "display",
          "give",
          "find",
          "open",
          "load",
          "please",
          "kindly",
          "agrega",
          "agregar",
          "añade",
          "añadir",
          "inserta",
          "insertar",
          "importa",
          "pon",
          "poner",
          "coloca",
          "trae",
          "muestra",
          "mostrar",
          "abre",
          "abrir",
          "carga",
          "cargar",
          "usa",
          "usar",
          "por favor",
          "adiciona",
          "adicionar",
          "insere",
          "inserir",
          "importa",
          "por",
          "coloca",
          "traz",
          "mostrar",
          "mostra",
          "abre",
          "abrir",
          "carrega",
          "carregar",
          "usa",
          "usar",
          "por favor",
          "ajoute",
          "ajouter",
          "insere",
          "insérer",
          "importe",
          "mettre",
          "place",
          "placer",
          "apporte",
          "montrer",
          "ouvre",
          "ouvrir",
          "charge",
          "charger",
          "utilise",
          "utiliser",
          "s'il vous plaît",
          "hinzufügen",
          "einfügen",
          "importieren",
          "stellen",
          "platzieren",
          "bringen",
          "zeigen",
          "öffne",
          "öffnen",
          "lade",
          "laden",
          "verwende",
          "verwenden",
          "bitte",
          "जोड़ें",
          "डालें",
          "आयात",
          "रखें",
          "स्थान",
          "लाओ",
          "दिखाओ",
          "खोलो",
          "लोड",
          "इस्तेमाल",
          "कृपया",
          "aggiungi",
          "inserisci",
          "importa",
          "metti",
          "posa",
          "porta",
          "mostra",
          "apri",
          "aprire",
          "carica",
          "usa",
          "per favore",
          "追加",
          "挿入",
          "インポート",
          "置く",
          "配置",
          "持ってきて",
          "見せて",
          "開く",
          "読み込む",
          "使う",
          "お願いします",
        ];
        const hasVerb = verbs.some((v) => s.includes(v));
        if (!hasVerb) return "";
        const markers = [
          " image",
          " imagen",
          " imagem",
          " immagine",
          " bild",
          " 画像",
          " छवि",
          " चित्र",
        ];
        let idx = -1;
        let marker = "";
        for (const m of markers) {
          const i = s.indexOf(m);
          if (i !== -1) {
            idx = i;
            marker = m.trim();
            break;
          }
        }
        if (idx === -1) return "";
        const before = s.slice(0, idx).trim();
        let query = before;
        for (const v of verbs) {
          const pv = v + " ";
          if (query.startsWith(pv)) {
            query = query.slice(pv.length);
            break;
          }
        }
        // If query is empty OR only an article/determiner, read after the marker using connectors
        const onlyArticles =
          /^(un|una|unos|unas|el|la|los|las|um|uma|uns|umas|o|a|os|as|une|des|le|la|les|du|de la|de l'|il|lo|gli|le|uno|ein|eine|einen|einem|einer|der|die|das|bir|een|het|al|ال|الـ)$/i;
        if (!query || onlyArticles.test(query.trim())) {
          const after = s.slice(idx + marker.length).trim();
          const connectors = [
            "of ",
            "de ",
            "do ",
            "da ",
            "del ",
            "de la ",
            "de los ",
            "de las ",
            "des ",
            "du ",
            "de l'",
            "d' ",
            "von ",
            "का ",
            "के ",
            "की ",
            "の ",
            "van ",
            "av ",
            "af ",
            "من ",
          ];
          let found = false;
          for (const c of connectors) {
            const j = after.indexOf(c);
            if (j !== -1) {
              query = after.slice(j + c.length).trim();
              found = true;
              break;
            }
          }
          if (!found) query = after.trim();
        }
        // Avoid library mentions
        const near = s.slice(Math.max(0, idx - 20), idx + 20);
        const libraryNouns = [
          "library",
          "biblioteca",
          "bibliotheque",
          "bibliothèque",
          "bibliothek",
          "libreria",
          "ライブラリ",
          "लाइब्रेरी",
        ];
        if (libraryNouns.some((w) => near.includes(w))) return "";
        return query
          .replace(
            /\b(please|kindly|por favor|s'il vous plaît|per favore|bitte)\b/g,
            ""
          )
          .replace(
            /\b(give me|show me|bring me|muéstrame|muestrame|tráeme|traeme)\b/g,
            ""
          )
          .replace(
            /\b(give|show|bring|open|load|insert|add|get|abre|abrir|adicionar|inserir|aggiungi|inserisci|zeige|öffne)\b/g,
            ""
          )
          .replace(
            /\b(a|an|the|me|la|el|o|a|un|una|unos|unas|um|uma|uns|umas|os|as|une|des|ein|eine|einen|einem|einer|il|lo|gli|le|uno|het|een|bir|ال|الـ)\b/g,
            ""
          )
          .replace(/^["'“”‘’]+|["'“”‘’]+$/g, "")
          .replace(/\s+/g, " ")
          .trim();
      };

      const handleImageRequest = async (query) => {
        if (!query) return false;
        const base = query.trim();
        const ok = await awaitReply("insertImageByQuery", { query: base });
        if (ok) {
          toast.success(`Added image: ${base}`);
          return true;
        }
        toast.error(`No matching image found for "${query}".`);
        return false;
      };

      const handleVideoRequest = async (query) => {
        if (!query) return false;
        // Use whiteboard-supported action to search local videos by query
        const base = query.trim().toLowerCase();
        const ok = await awaitReply("insertVideoByQuery", { query: base });
        if (ok) {
          toast.success(`Added video: ${base}`);
          return true;
        }
        toast.error(`No matching video found for "${query}".`);
        return false;
      };

      const videoQuery = extractVideoQuery(sText);
      if (videoQuery) {
        const ok = await handleVideoRequest(videoQuery);
        if (ok)
          return { success: true, message: `Inserted video: ${videoQuery}` };
        // For video, do not attempt any generic or stock fallback; return error
        return {
          success: false,
          message: `Video not available: ${videoQuery}`,
        };
      }

      const imageQuery = extractImageQuery(sText);
      if (imageQuery) {
        const ok = await handleImageRequest(imageQuery);
        if (ok)
          return { success: true, message: `Inserted image: ${imageQuery}` };
        return {
          success: false,
          message: `Image not available: ${imageQuery}`,
        };
      }

      // (moved) Spinner intent handled earlier to avoid opening library

      // 1) Explicit "use" -> use template by name
      if (wantsUse || (mentionsTemplate && templateName)) {
        const templateToUse = sanitize(templateName || exportTargetName);
        if (templateToUse) {
          const doAction = "useTemplate";
          return await new Promise((resolve) => {
            const timeout = setTimeout(() => {
              window.removeEventListener("message", onMessage);
              toast.info(`Trying template: ${templateToUse}`);
              resolve({
                success: true,
                message: `Trying template: ${templateToUse}`,
              });
            }, 2000);
            const onMessage = (e) => {
              const d = e?.data;
              if (!d || d.type !== "acv.whiteboard.reply") return;
              if (d.action !== doAction) return;
              window.removeEventListener("message", onMessage);
              clearTimeout(timeout);
              if (d.handled) {
                toast.success(`Applied template: ${templateToUse}`);
                resolve({
                  success: true,
                  message: `Applied template: ${templateToUse}`,
                });
              } else {
                toast.error(`Template not found: ${templateToUse}`);
                resolve({
                  success: false,
                  message: `Template not found: ${templateToUse}`,
                });
              }
            };
            window.addEventListener("message", onMessage);
            sendWhiteboard2(doAction, { templateName: templateToUse });
          });
        }
      }

      // 2) Explicit "export" -> export collection by name if noun implies collection, otherwise treat as template-to-canvas
      if (wantsExport) {
        const nameForAction = sanitize(exportTargetName || templateName);
        if (mentionsCollection && nameForAction) {
          const doAction = "exportCollectionByName";
          return await new Promise((resolve) => {
            const timeout = setTimeout(() => {
              window.removeEventListener("message", onMessage);
              toast.info(`Exporting collection: ${nameForAction}`);
              resolve({
                success: true,
                message: `Exporting collection: ${nameForAction}`,
              });
            }, 2000);
            const onMessage = (e) => {
              const d = e?.data;
              if (!d || d.type !== "acv.whiteboard.reply") return;
              if (d.action !== doAction) return;
              window.removeEventListener("message", onMessage);
              clearTimeout(timeout);
              if (d.handled) {
                toast.success(`Exported collection: ${nameForAction}`);
                resolve({
                  success: true,
                  message: `Exported collection: ${nameForAction}`,
                });
              } else {
                toast.error(`Collection not found: ${nameForAction}`);
                resolve({
                  success: false,
                  message: `Collection not found: ${nameForAction}`,
                });
              }
            };
            window.addEventListener("message", onMessage);
            sendWhiteboard2(doAction, { name: nameForAction });
          });
        }
        // Export verb but noun looks like a template -> use it (export to canvas)
        const templateToUse = sanitize(templateName || exportTargetName);
        if (templateToUse) {
          const doAction = "useTemplate";
          return await new Promise((resolve) => {
            const timeout = setTimeout(() => {
              window.removeEventListener("message", onMessage);
              toast.info(`Trying template: ${templateToUse}`);
              resolve({
                success: true,
                message: `Trying template: ${templateToUse}`,
              });
            }, 2000);
            const onMessage = (e) => {
              const d = e?.data;
              if (!d || d.type !== "acv.whiteboard.reply") return;
              if (d.action !== doAction) return;
              window.removeEventListener("message", onMessage);
              clearTimeout(timeout);
              if (d.handled) {
                toast.success(`Applied template: ${templateToUse}`);
                resolve({
                  success: true,
                  message: `Applied template: ${templateToUse}`,
                });
              } else {
                toast.error(`Template not found: ${templateToUse}`);
                resolve({
                  success: false,
                  message: `Template not found: ${templateToUse}`,
                });
              }
            };
            window.addEventListener("message", onMessage);
            sendWhiteboard2(doAction, { templateName: templateToUse });
          });
        }
      }

      // 3) No explicit verb but we have a name; choose by noun
      const fallbackName = sanitize(templateName || exportTargetName);
      if (fallbackName) {
        if (mentionsCollection) {
          const doAction = "exportCollectionByName";
          return await new Promise((resolve) => {
            const timeout = setTimeout(() => {
              window.removeEventListener("message", onMessage);
              toast.info(`Exporting collection: ${fallbackName}`);
              resolve({
                success: true,
                message: `Exporting collection: ${fallbackName}`,
              });
            }, 2000);
            const onMessage = (e) => {
              const d = e?.data;
              if (!d || d.type !== "acv.whiteboard.reply") return;
              if (d.action !== doAction) return;
              window.removeEventListener("message", onMessage);
              clearTimeout(timeout);
              if (d.handled) {
                toast.success(`Exported collection: ${fallbackName}`);
                resolve({
                  success: true,
                  message: `Exported collection: ${fallbackName}`,
                });
              } else {
                toast.error(`Collection not found: ${fallbackName}`);
                resolve({
                  success: false,
                  message: `Collection not found: ${fallbackName}`,
                });
              }
            };
            window.addEventListener("message", onMessage);
            sendWhiteboard2(doAction, { name: fallbackName });
          });
        } else {
          const doAction = "useTemplate";
          return await new Promise((resolve) => {
            const timeout = setTimeout(() => {
              window.removeEventListener("message", onMessage);
              toast.info(`Trying template: ${fallbackName}`);
              resolve({
                success: true,
                message: `Trying template: ${fallbackName}`,
              });
            }, 2000);
            const onMessage = (e) => {
              const d = e?.data;
              if (!d || d.type !== "acv.whiteboard.reply") return;
              if (d.action !== doAction) return;
              window.removeEventListener("message", onMessage);
              clearTimeout(timeout);
              if (d.handled) {
                toast.success(`Applied template: ${fallbackName}`);
                resolve({
                  success: true,
                  message: `Applied template: ${fallbackName}`,
                });
              } else {
                toast.error(`Template not found: ${fallbackName}`);
                resolve({
                  success: false,
                  message: `Template not found: ${fallbackName}`,
                });
              }
            };
            window.addEventListener("message", onMessage);
            sendWhiteboard2(doAction, { templateName: fallbackName });
          });
        }
      }
      // If still not handled, try smart free-form insert on whiteboard side
      if (rawText2) {
        // CRITICAL: Check for collection prompt response FIRST before sending to whiteboard
        // This prevents "I want from collection" from being processed as insertByText
        if (this.pendingCollectionPrompt) {
          const normalizedCmd = String(rawText2 || "")
            .toLowerCase()
            .trim();
          const isCollectionResponse =
            /^(yes|collection|from collection|use collection|add from collection|use it|add it|from the collection|i want from collection|want from collection)$/i.test(
              normalizedCmd
            ) ||
            /(?:i\s+)?(?:want|need|get|use|add|put|show|bring)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
              normalizedCmd
            ) ||
            /(?:use|get|add|put|show)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
              normalizedCmd
            );

          if (isCollectionResponse) {
            console.log(
              "[VOICE-DEBUG] ✅✅✅ Collection response detected in voice handler EARLY, intercepting:",
              normalizedCmd
            );
            const pending = this.pendingCollectionPrompt;
            this.pendingCollectionPrompt = null;

            if (pending.collectionMatch) {
              const { collection, file } = pending.collectionMatch;
              console.log("[VOICE-DEBUG] Adding collection item to canvas:", {
                collectionName: collection.name,
                fileUrl: file.url,
                itemName: pending.itemName,
              });

              const ok = sendWhiteboard2("addCollectionItem", {
                fileUrl: file.url,
                collectionId: collection.id,
                collectionName: collection.name,
                fileName: file.id,
              });

              if (ok) {
                toast.success(`Added ${pending.itemName} from collection`);
                console.log(
                  "[VOICE-DEBUG] ✅ Successfully sent addCollectionItem to whiteboard"
                );
                return {
                  success: true,
                  message: `Added ${pending.itemName} from collection to canvas`,
                };
              } else {
                console.error(
                  "[VOICE-DEBUG] ❌ Failed to send addCollectionItem - whiteboard not available"
                );
                return { success: false, message: "Whiteboard not available" };
              }
            }
          }
        }

        // Check if this is an export command FIRST - don't treat export commands as insert commands
        const isExportCommand =
          /\bexport\s+(?:the\s+)?(?:page|pages?)\b/i.test(rawText2) ||
          /\bexport\s+(?:the\s+)?(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\s+(?:as|is)\s+image\b/i.test(
            rawText2
          ) ||
          /\bexport\s+(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\s+(?:as|is)\s+image\b/i.test(
            rawText2
          );

        if (!isExportCommand) {
          const looksLikeMediaOrTemplate =
            /(image|images|photo|photos|picture|pictures|video|audio|template|collection)/i.test(
              rawText2
            );
          if (looksLikeMediaOrTemplate) {
            // Don't send to whiteboard if it's a collection response
            if (!this.pendingCollectionPrompt) {
              const handled = await awaitReply("insertByText", {
                text: rawText2,
              });
              if (handled) {
                return { success: true, message: "Inserted on canvas." };
              }
              // if not handled, fall through to drawing branch below
            }
          }
        }
      }

      // Fallback: if we only switched the sidebar/top tab, report that now
      if (didSwitchSidebar && switchMessage) {
        return { success: true, message: switchMessage };
      }
    } catch {}
    const { showLesson, selectedLesson } = this.state;

    // Only gate lesson navigation commands on lessons availability;
    // allow Undo/Redo and canvas commands even when lessons are absent.
    // (We already handled voice Undo/Redo above; drawing fallbacks proceed below.)

    const normalize = (s) => (s || "").toString().toLowerCase().trim();

    const findBestMatch = (name) => {
      if (!name) return { match: null, score: 0 };
      const target = normalize(name);
      let best = null;
      let bestScore = 0;
      const codeMatch = target.match(/\b(\d+)\b/);
      const lessonCode = codeMatch ? codeMatch[1] : null;
      showLesson.forEach((lsn) => {
        const title = normalize(lsn.Title);
        const className = normalize(lsn.ClassName);
        let score = 0;
        if (className === target || title === target) score = 1.0;
        if (!score && lessonCode) {
          const re = new RegExp(`\\b${lessonCode}\\b`);
          if (re.test(className) || re.test(title)) score = 0.9;
          else if (className.includes(lessonCode) || title.includes(lessonCode))
            score = 0.3;
        }
        if (!score) {
          if (className.includes(target) || target.includes(className))
            score =
              0.7 *
              (Math.min(target.length, className.length) /
                Math.max(target.length, className.length));
          if (title.includes(target) || target.includes(title)) {
            const tScore =
              0.6 *
              (Math.min(target.length, title.length) /
                Math.max(target.length, title.length));
            score = Math.max(score, tScore);
          }
        }
        if (score > bestScore) {
          bestScore = score;
          best = lsn;
        }
      });
      return { match: best, score: bestScore };
    };

    if (type === "navigateLesson" || type === "goToLesson") {
      if (!lessonName) {
        return { success: false, message: "No lesson name specified." };
      }
      const { match, score } = findBestMatch(lessonName);
      if (match && score > 0.25) {
        // Push undo entry for lesson change
        try {
          if (!this.isPerformingUndo) {
            const prevId =
              selectedLesson?.LessonId ?? selectedLesson?.Title ?? null;
            const nextId = match?.LessonId ?? match?.Title ?? null;
            this._pushUndoAction({
              type: "lesson",
              previous: prevId,
              previousKey: this.getLessonDomKey(selectedLesson),
              next: nextId,
              nextKey: this.getLessonDomKey(match),
            });
          }
        } catch (e) {}
        this.setState({ selectedLesson: match }, () => {
          this.fetchRecordsByLesson(match);
        });
        return {
          success: true,
          message: `Opening lesson: ${match.ClassName || match.Title}`,
        };
      }
      return { success: false, message: `Lesson "${lessonName}" not found.` };
    }

    if (type === "nextLesson" || type === "previousLesson") {
      let currentIndex = -1;
      if (selectedLesson) {
        currentIndex = showLesson.findIndex(
          (l) => l.LessonId === selectedLesson.LessonId
        );
      }
      if (currentIndex === -1) currentIndex = 0;
      const newIndex =
        type === "nextLesson"
          ? (currentIndex + 1) % showLesson.length
          : (currentIndex - 1 + showLesson.length) % showLesson.length;
      const target = showLesson[newIndex];
      // Push undo entry for lesson change
      try {
        if (!this.isPerformingUndo) {
          const prevId =
            selectedLesson?.LessonId ?? selectedLesson?.Title ?? null;
          const nextId = target?.LessonId ?? target?.Title ?? null;
          this._pushUndoAction({
            type: "lesson",
            previous: prevId,
            previousKey: this.getLessonDomKey(selectedLesson),
            next: nextId,
            nextKey: this.getLessonDomKey(target),
          });
        }
      } catch (e) {}
      this.setState({ selectedLesson: target }, () =>
        this.fetchRecordsByLesson(target)
      );
      return {
        success: true,
        message: `Opening ${
          type === "nextLesson" ? "next" : "previous"
        } lesson: ${target.ClassName || target.Title}`,
      };
    }

    // ----- Drawing tools via postMessage to embedded whiteboard -----
    const iframe = document.querySelector("iframe.frameTag");
    const postToWhiteboard = (action, payload = {}) => {
      if (!iframe || !iframe.contentWindow) return false;
      iframe.contentWindow.postMessage(
        { type: "acv.whiteboard.command", action, payload },
        "*"
      );
      return true;
    };

    // Export command parser
    const parseExportCommand = (text) => {
      if (!text) return null;
      const s = String(text).toLowerCase().trim();

      // Special case: "export [query] image" should be treated as "insert image [query]"
      // BUT NOT if it's clearly about exporting a page (e.g., "export the page one as image")
      // Pattern matches: "please export [query] image", "export [query] image", etc.
      // But excludes: "export [the] page [one/1/number] [as/is] image"
      const originalText = String(text).trim();

      // First check if it's clearly a page export command - if so, skip insert detection
      // Handle both "as" and "is" (speech recognition sometimes transcribes "as" as "is")
      const normalizedForCheck = originalText.replace(
        /\bis\s+image\b/gi,
        " as image"
      );
      const isPageExport =
        /\bexport\s+(?:the\s+)?(?:page|pages?)\s+(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\s+(?:as|is)\s+image\b/i.test(
          originalText
        ) ||
        /\bexport\s+(?:the\s+)?(?:page|pages?)\b/i.test(originalText) ||
        /\bexport\s+(?:the\s+)?(?:page|pages?)\s+(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\b/i.test(
          originalText
        ) ||
        /\bexport\s+(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\s+(?:as|is)\s+image\b/i.test(
          originalText
        );

      // Only treat as insert if it's NOT a page export command
      if (!isPageExport) {
        // Also normalize "is" to "as" for pattern matching
        const normalizedText = originalText.replace(
          /\bis\s+image\b/gi,
          " as image"
        );
        const insertImagePatterns = [
          /^(?:please\s+)?export\s+(.+?)\s+(?:as|is)\s+image$/i,
          /^(?:please\s+)?export\s+(.+?)\s+image$/i,
          /^(?:please\s+)?export\s+image\s+(.+)$/i, // "export image [query]"
        ];

        for (const pattern of insertImagePatterns) {
          const insertMatch = normalizedText.match(pattern);
          if (insertMatch) {
            const query = insertMatch[1].trim();
            // Make sure the query doesn't start with "page", "the page", or contain page numbers
            if (
              !/^(?:the\s+)?(?:page|pages?)(?:\s+(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+))?\s/i.test(
                query
              )
            ) {
              // Preserve original case for the query as it might contain proper nouns or specific terms
              // Convert to insertImageByQuery action
              return {
                action: "insertImageByQuery",
                payload: { query: query },
              };
            }
          }
        }
      }

      // Patterns for export commands
      // Export as image (PNG/SVG) - handle both "as" and "is" (speech recognition variation)
      const exportImagePatterns = [
        // English
        /(?:export|save|download)\s+(?:the\s+)?(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\s+(?:as|is)\s+(?:image|png|svg|picture)/i,
        /(?:export|save|download)\s+(?:the\s+)?(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\s+(?:image|png|svg|picture)/i,
        /(?:export|save|download)\s+(?:the\s+)?(?:this\s+)?page\s+(?:as|is)\s+(?:image|png|svg|picture)/i,
        /(?:export|save|download)\s+(?:as|is)\s+(?:image|png|svg|picture)\s+(?:the\s+)?(?:this\s+)?page/i,
        /(?:export|save|download)\s+(?:the\s+)?(?:this\s+)?page/i,
        /export\s+(?:as|is)\s+(?:image|png|svg)(?!\s+(?:page|the|one|two|three|four|five|six|seven|eight|nine|ten|\d+))/i,
        /save\s+(?:as|is)\s+(?:image|png|svg)(?!\s+(?:page|the|one|two|three|four|five|six|seven|eight|nine|ten|\d+))/i,
        // Spanish
        /(?:exportar|guardar|descargar)\s+(?:la\s+)?(?:página|páginas?)\s+(?:como|en)\s+(?:imagen|png|svg|foto)/i,
        /(?:exportar|guardar|descargar)\s+(?:como|en)\s+(?:imagen|png|svg|foto)\s+(?:la\s+)?(?:página|páginas?)/i,
        // Portuguese
        /(?:exportar|salvar|baixar)\s+(?:a\s+)?(?:página|páginas?)\s+(?:como|em)\s+(?:imagem|png|svg|foto)/i,
        /(?:exportar|salvar|baixar)\s+(?:como|em)\s+(?:imagem|png|svg|foto)\s+(?:a\s+)?(?:página|páginas?)/i,
        // French
        /(?:exporter|enregistrer|télécharger)\s+(?:la\s+)?(?:page|pages?)\s+(?:en)\s+(?:image|png|svg|photo)/i,
        // German
        /(?:exportieren|speichern|herunterladen)\s+(?:die\s+)?(?:seite|seiten?)\s+(?:als)\s+(?:bild|png|svg|foto)/i,
        // Italian
        /(?:esporta|salva|scarica)\s+(?:la\s+)?(?:pagina|pagine?)\s+(?:come|in)\s+(?:immagine|png|svg|foto)/i,
        // Japanese
        /(?:エクスポート|保存|ダウンロード)\s*(?:ページ|ページを)?\s*(?:画像|png|svg)/,
      ];

      // Export as file (JSON)
      const exportFilePatterns = [
        /(?:export|save|download)\s+(?:this\s+)?page\s+(?:as\s+)?(?:file|json|data)/i,
        /(?:export|save|download)\s+(?:as\s+)?(?:file|json|data)\s+(?:this\s+)?page/i,
        /export\s+(?:as\s+)?(?:file|json|data)/i,
        /save\s+(?:as\s+)?(?:file|json|data)/i,
        // Spanish
        /(?:exportar|guardar|descargar)\s+(?:la\s+)?(?:página|páginas?)\s+(?:como|en)\s+(?:archivo|json|datos)/i,
        /(?:exportar|guardar|descargar)\s+(?:como|en)\s+(?:archivo|json|datos)\s+(?:la\s+)?(?:página|páginas?)/i,
        // Portuguese
        /(?:exportar|salvar|baixar)\s+(?:a\s+)?(?:página|páginas?)\s+(?:como|em)\s+(?:arquivo|json|dados)/i,
        // French
        /(?:exporter|enregistrer|télécharger)\s+(?:la\s+)?(?:page|pages?)\s+(?:en)\s+(?:fichier|json|données)/i,
        // German
        /(?:exportieren|speichern|herunterladen)\s+(?:die\s+)?(?:seite|seiten?)\s+(?:als)\s+(?:datei|json|daten)/i,
        // Italian
        /(?:esporta|salva|scarica)\s+(?:la\s+)?(?:pagina|pagine?)\s+(?:come|in)\s+(?:file|json|dati)/i,
      ];

      // Export all pages - handle "all pages", "all the pages", etc.
      const exportAllPatterns = [
        // English
        /(?:export|save|download)\s+(?:all\s+)?(?:the\s+)?pages?\s+(?:as|is)\s+(?:image|png|svg|picture)/i,
        /(?:export|save|download)\s+(?:as|is)\s+(?:image|png|svg|picture)\s+(?:all\s+)?(?:the\s+)?pages?/i,
        /(?:export|save|download)\s+(?:all\s+)?(?:the\s+)?pages?\s+(?:as|is)\s+(?:file|json|data)/i,
        /(?:export|save|download)\s+(?:as|is)\s+(?:file|json|data)\s+(?:all\s+)?(?:the\s+)?pages?/i,
        /(?:export|save|download)\s+(?:all\s+)?(?:the\s+)?pages?/i,
        /export\s+(?:all\s+)?(?:the\s+)?pages?/i,
        /save\s+(?:all\s+)?(?:the\s+)?pages?/i,
        // Spanish
        /(?:exportar|guardar|descargar)\s+(?:todas\s+)?(?:las\s+)?páginas?(?:\s+(?:como|en)\s+(?:imagen|png|svg|foto|archivo|json|datos))?/i,
        // Portuguese
        /(?:exportar|salvar|baixar)\s+(?:todas\s+)?(?:as\s+)?páginas?(?:\s+(?:como|em)\s+(?:imagem|png|svg|foto|arquivo|json|dados))?/i,
        // French
        /(?:exporter|enregistrer|télécharger)\s+(?:toutes\s+)?(?:les\s+)?pages?(?:\s+(?:en)\s+(?:image|png|svg|photo|fichier|json|données))?/i,
        // German
        /(?:exportieren|speichern|herunterladen)\s+(?:alle\s+)?seiten?(?:\s+(?:als)\s+(?:bild|png|svg|foto|datei|json|daten))?/i,
        // Italian
        /(?:esporta|salva|scarica)\s+(?:tutte\s+)?(?:le\s+)?pagine?(?:\s+(?:come|in)\s+(?:immagine|png|svg|foto|file|json|dati))?/i,
      ];

      // Export specific page(s) - handle single or multiple pages (e.g., "export page one and page two")
      // Map text numbers to digits
      // Handle both "as" and "is" (speech recognition variation)
      const textToNumber = {
        one: "1",
        two: "2",
        three: "3",
        four: "4",
        five: "5",
        six: "6",
        seven: "7",
        eight: "8",
        nine: "9",
        ten: "10",
      };

      // Check for multiple pages first (e.g., "page one and page two")
      const multiplePagesPattern =
        /(?:export|save|download)\s+(?:the\s+)?(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)\s+(?:and\s+)?(?:the\s+)?(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)/i;
      const multiplePagesMatch = originalText.match(multiplePagesPattern);

      if (multiplePagesMatch) {
        // Extract all page numbers from the text
        const pageMatches = originalText.match(
          /(?:page\s+)?(?:one|two|three|four|five|six|seven|eight|nine|ten|\d+)/gi
        );
        if (pageMatches && pageMatches.length > 1) {
          const pageNumbers = [];
          for (const match of pageMatches) {
            const cleaned = match
              .replace(/page\s+/gi, "")
              .trim()
              .toLowerCase();
            const pageNum = textToNumber[cleaned] || cleaned;
            if (pageNum) pageNumbers.push(pageNum);
          }

          if (pageNumbers.length > 0) {
            const isImage =
              /(?:as|is)\s+(?:image|png|svg|picture)/.test(s) ||
              /(?:image|png|svg|picture)/.test(s);
            const isFile =
              /(?:as|is)\s+(?:file|json|data)/.test(s) ||
              /(?:file|json|data)/.test(s);
            const format = isImage ? "image" : isFile ? "file" : "image";
            return {
              action: "exportMultiplePages",
              payload: { pages: pageNumbers, format },
            };
          }
        }
      }

      // Single page export patterns
      const exportPagePatternText =
        /(?:export|save|download)\s+(?:the\s+)?(?:page\s+)?(one|two|three|four|five|six|seven|eight|nine|ten)(?:\s+(?:as|is)\s+(?:image|png|svg|file|json))?/i;
      const exportPagePatternNum =
        /(?:export|save|download)\s+(?:the\s+)?(?:page\s+)?(\d+)(?:\s+(?:as|is)\s+(?:image|png|svg|file|json))?/;

      // Normalize "is image" to "as image" for matching (speech recognition variation)
      const normalizedS = s.replace(/\bis\s+image\b/g, " as image");

      // Try text pattern first (on normalized text)
      const textMatch = normalizedS.match(exportPagePatternText);
      if (textMatch) {
        const pageText = textMatch[1].toLowerCase();
        const pageNum = textToNumber[pageText] || textMatch[1];
        const isImage =
          /(?:as|is)\s+(?:image|png|svg|picture)/.test(normalizedS) ||
          /(?:image|png|svg|picture)/.test(s);
        const isFile =
          /(?:as|is)\s+(?:file|json|data)/.test(normalizedS) ||
          /(?:file|json|data)/.test(s);
        const format = isImage ? "image" : isFile ? "file" : "image";
        return {
          action: "exportPage",
          payload: { page: pageNum, format },
        };
      }

      // Then try numeric pattern (on normalized text)
      const numMatch = normalizedS.match(exportPagePatternNum);
      if (numMatch) {
        const pageNum = numMatch[1];
        const isImage =
          /(?:as|is)\s+(?:image|png|svg|picture)/.test(normalizedS) ||
          /(?:image|png|svg|picture)/.test(s);
        const isFile =
          /(?:as|is)\s+(?:file|json|data)/.test(normalizedS) ||
          /(?:file|json|data)/.test(s);
        const format = isImage ? "image" : isFile ? "file" : "image";
        return {
          action: "exportPage",
          payload: { page: pageNum, format },
        };
      }

      // Open export dialog
      const openExportDialogPatterns = [
        /(?:open|show)\s+(?:export|save)\s+(?:dialog|menu)/,
        /export\s+(?:options|menu|dialog)/,
      ];

      // Check for export all pages (check this BEFORE single page patterns)
      for (const pattern of exportAllPatterns) {
        if (pattern.test(s)) {
          // Check format - use case-insensitive matching
          const isImage =
            /(?:as|is)\s+(?:image|png|svg|picture)|(?:image|png|svg|picture)/i.test(
              s
            );
          const isFile =
            /(?:as|is)\s+(?:file|json|data)|(?:file|json|data)/i.test(s);
          // Default to file if "as file" is mentioned, otherwise image
          const format = isFile ? "file" : isImage ? "image" : "file"; // Default to file if ambiguous
          return {
            action: "exportAllPages",
            payload: { format },
          };
        }
      }

      // Export specific page patterns are already checked above (lines 1285-1310)

      // Check for export current page as image
      for (const pattern of exportImagePatterns) {
        if (pattern.test(s)) {
          return {
            action: "exportCurrentPage",
            payload: { format: "image" },
          };
        }
      }

      // Check for export current page as file
      for (const pattern of exportFilePatterns) {
        if (pattern.test(s)) {
          return {
            action: "exportCurrentPage",
            payload: { format: "file" },
          };
        }
      }

      // Check for open export dialog
      for (const pattern of openExportDialogPatterns) {
        if (pattern.test(s)) {
          return {
            action: "openExportDialog",
            payload: {},
          };
        }
      }

      return null;
    };

    // Background change parser (multilingual)
    const parseBackgroundCommand = (text) => {
      if (!text) return null;
      const sOrig = String(text).trim();
      const s = sOrig.toLowerCase();
      // Verbs and nouns across languages
      const verbs = [
        "set",
        "change",
        "make",
        "establecer",
        "cambiar",
        "poner",
        "hacer",
        "definir",
        "mudar",
        "alterar",
        "trocar",
        "fazer",
        "definir",
        "définir",
        "changer",
        "mettre",
        "faire",
        "setzen",
        "ändern",
        "wechseln",
        "machen",
        "impostare",
        "cambiare",
        "mettere",
        "fare",
        "सेट",
        "बदलें",
        "करें",
        "बनाएं",
        "設定",
        "変更",
        "にする",
        "作る",
      ];
      const nouns = [
        "background",
        "canvas",
        "fondo",
        "lienzo",
        "fundo",
        "tela",
        "arriere plan",
        "arrière plan",
        "toile",
        "hintergrund",
        "leinwand",
        "sfondo",
        "tela",
        "पृष्ठभूमि",
        "कैनवास",
        "背景",
        "キャンバス",
      ];
      const transparents = [
        "transparent",
        "transparente",
        "transparent",
        "trasparente",
        "पारदर्शी",
        "透明",
      ];
      const colorNames = {
        // English
        white: "#ffffff",
        black: "#000000",
        red: "#ff0000",
        blue: "#0000ff",
        green: "#00ff00",
        yellow: "#ffff00",
        orange: "#ffa500",
        purple: "#800080",
        violet: "#8a2be2",
        pink: "#ffc0cb",
        grey: "#808080",
        gray: "#808080",
        // Spanish
        blanco: "#ffffff",
        negro: "#000000",
        rojo: "#ff0000",
        azul: "#0000ff",
        verde: "#00ff00",
        amarillo: "#ffff00",
        naranja: "#ffa500",
        morado: "#800080",
        violeta: "#8a2be2",
        rosa: "#ffc0cb",
        gris: "#808080",
        // Portuguese
        branco: "#ffffff",
        preto: "#000000",
        vermelho: "#ff0000",
        azul: "#0000ff",
        verde: "#00ff00",
        amarelo: "#ffff00",
        laranja: "#ffa500",
        roxo: "#800080",
        violeta: "#8a2be2",
        rosa: "#ffc0cb",
        cinza: "#808080",
        // French
        blanc: "#ffffff",
        noir: "#000000",
        rouge: "#ff0000",
        bleu: "#0000ff",
        vert: "#00ff00",
        jaune: "#ffff00",
        orange: "#ffa500",
        violet: "#8a2be2",
        rose: "#ffc0cb",
        gris: "#808080",
        // German
        weiß: "#ffffff",
        weiss: "#ffffff",
        schwarz: "#000000",
        rot: "#ff0000",
        blau: "#0000ff",
        grün: "#00ff00",
        gruen: "#00ff00",
        gelb: "#ffff00",
        orange_de: "#ffa500",
        violett: "#8a2be2",
        rosa_de: "#ffc0cb",
        grau: "#808080",
        // Italian
        bianco: "#ffffff",
        nero: "#000000",
        rosso: "#ff0000",
        blu: "#0000ff",
        verde: "#00ff00",
        giallo: "#ffff00",
        arancione: "#ffa500",
        viola: "#800080",
        rosa_it: "#ffc0cb",
        grigio: "#808080",
        // Hindi
        सफ़ेद: "#ffffff",
        सफेद: "#ffffff",
        काला: "#000000",
        लाल: "#ff0000",
        नीला: "#0000ff",
        हरा: "#00ff00",
        पीला: "#ffff00",
        नारंगी: "#ffa500",
        बैंगनी: "#800080",
        गुलाबी: "#ffc0cb",
        धूसर: "#808080",
        // Japanese
        白: "#ffffff",
        黒: "#000000",
        赤: "#ff0000",
        青: "#0000ff",
        緑: "#00ff00",
        黄色: "#ffff00",
        オレンジ: "#ffa500",
        紫: "#800080",
        ピンク: "#ffc0cb",
        灰色: "#808080",
      };

      const esc = (w) => w.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      const verbsRe = new RegExp(`\\b(${verbs.map(esc).join("|")})\\b`, "i");
      const nounsRe = new RegExp(`\\b(${nouns.map(esc).join("|")})\\b`, "i");
      const transpRe = new RegExp(
        `\\b(${transparents.map(esc).join("|")})\\b`,
        "i"
      );

      // Transparent background
      if (verbsRe.test(s) && nounsRe.test(s) && transpRe.test(s)) {
        return { action: "setBackgroundTransparent" };
      }
      // Hex match
      const hexMatch = s.match(/#([0-9a-f]{3}|[0-9a-f]{6})\b/i);
      if (verbsRe.test(s) && nounsRe.test(s)) {
        if (hexMatch) {
          return {
            action: "setBackgroundColor",
            payload: { color: hexMatch[0] },
          };
        }
        // Named colors
        for (const [name, hex] of Object.entries(colorNames)) {
          const re = new RegExp(`\\b${esc(name)}\\b`, "i");
          if (re.test(s)) {
            return { action: "setBackgroundColor", payload: { color: hex } };
          }
        }
      }
      return null;
    };

    // Basic regex parser for drawing controls
    const parseDrawCommand = (text) => {
      if (!text) return null;
      const s = String(text).toLowerCase();
      const has = (re) => re.test(s);
      if (/\bundo\b/.test(s)) return { action: "undo" };
      if (/\bredo\b/.test(s)) return { action: "redo" };
      // Clear canvas: EN + ES + PT + FR + DE + IT + HI + JA (expanded verbs and nouns)
      if (
        /(clear|erase\s*all|reset|limpiar|borrar\s*todo|borra\s*todo|reiniciar|despeja|despeje|despejar|limpar|apagar\s*tudo|resetar|effacer|tout\s*effacer|réinitialiser|löschen|alles\s*löschen|zurücksetzen|pulire|cancella\s*tutto|reimposta|साफ़\s*करो|सब\s*मिटाओ|रीसेट|クリア|全消去|リセット)(.*\b(board|canvas|pizarra|lienzo|tablero|quadro|tela|tableau|toile|tafel|leinwand|lavagna|キャンバス)\b)?/.test(
          s
        )
      )
        return { action: "clear" };
      if (/zoom in/.test(s))
        return { action: "zoom", payload: { direction: "in" } };
      if (/zoom out/.test(s))
        return { action: "zoom", payload: { direction: "out" } };
      if (/fit (to )?screen/.test(s))
        return { action: "zoom", payload: { direction: "fit" } };

      // Tool selection: English + ES + PT + FR + DE + IT + HI + JA
      if (
        /(select|seleccionar|selecciona|selecionar|seleciona|sélectionner|sélectionne|choisir|auswählen|wähle|wählen|seleziona|selezionare|चयन करो|चुनें|選択|選んで)\s+(pen|pencil|pluma|lápiz|lapiz|caneta|lápis|lapis|stylo|crayon|stift|bleistift|penna|matita|पेन|पेंसिल|ペン|鉛筆)/.test(
          s
        )
      )
        return { action: "setTool", payload: { tool: "pen" } };
      if (
        /(select|seleccionar|selecciona|selecionar|seleciona|sélectionner|sélectionne|choisir|auswählen|wähle|wählen|seleziona|selezionare|चयन करो|चुनें|選択|選んで)\s+(eraser|borrador|borracha|gomme|radierer|gomma|इरेज़र|रबर|消しゴム)/.test(
          s
        )
      )
        return { action: "setTool", payload: { tool: "eraser" } };
      if (
        /(select|seleccionar|selecciona|selecionar|seleciona|sélectionner|sélectionne|choisir|auswählen|wähle|wählen|seleziona|selezionare|चयन करो|चुनें|選択|選んで)\s+(rectangle|square|rect(engle|angle)?|rectángulo|rectangulo|cuadrado|retângulo|retangulo|quadrado|carré|rechteck|quadrat|rettangolo|quadrato|आयत|आयताकार|वर्ग|長方形|四角形|正方形)/.test(
          s
        )
      )
        return { action: "drawShape", payload: { shape: "rectangle" } };
      if (
        /(select|seleccionar|selecciona|selecionar|seleciona|sélectionner|sélectionne|choisir|auswählen|wähle|wählen|seleziona|selezionare|चयन करो|चुनें|選択|選んで)\s+(diamond|diamante|rombo|losango|losange|raute|ひし形|菱形|हीरा)/.test(
          s
        )
      )
        return { action: "drawShape", payload: { shape: "diamond" } };
      if (
        /(select|seleccionar|selecciona|selecionar|seleciona|sélectionner|sélectionne|choisir|auswählen|wähle|wählen|seleziona|selezionare|चयन करो|चुनें|選択|選んで)\s+(circle|ellipse|round|círculo|circulo|elipse|círculo|cercle|rond|kreis|rund|cerchio|ellisse|वृत्त|गोल|अंडाकार|円|楕円)/.test(
          s
        )
      )
        return { action: "drawShape", payload: { shape: "ellipse" } };
      if (
        /(select|seleccionar|selecciona|selecionar|seleciona|sélectionner|sélectionne|choisir|auswählen|wähle|wählen|seleziona|selezionare|चयन करो|चुनें|選択|選んで)\s+(arrow|flecha|seta|flèche|pfeil|freccia|तीर|矢印)/.test(
          s
        )
      )
        return { action: "drawShape", payload: { shape: "arrow" } };
      if (
        /(select|seleccionar|selecciona|selecionar|seleciona|sélectionner|sélectionne|choisir|auswählen|wähle|wählen|seleziona|selezionare|चयन करो|चुनें|選択|選んで)\s+(line|línea|linea|linha|ligne|linie|रेखा|線)/.test(
          s
        )
      )
        return { action: "drawShape", payload: { shape: "line" } };

      const c = s.match(/(color|colour)\s+(to\s+)?([a-z#0-9]+)/);
      if (c) return { action: "setColor", payload: { color: c[3] } };

      const w = s.match(/(thickness|size|width)\s+(to\s+)?(\d{1,2})/);
      if (w) return { action: "setSize", payload: { size: Number(w[3]) } };

      // Draw intents (EN + ES + PT + FR + DE + IT + HI + JA; tolerate optional polite prefixes)
      const drawVerb =
        /((please\s+)?draw|(?:por\s+favor\s+)?(?:dibuja|dibujar)|(?:por\s+favor\s+)?(?:desenhe|desenhar)|(?:s'il\s+te\s+plaît\s+)?(?:dessine|dessiner)|(?:bitte\s+)?(?:zeichne|zeichnen)|(?:per\s+favore\s+)?(?:disegna|disegnare)|(?:कृपया\s+)?(?:बनाओ|बनाएं|ड्रॉ)|(?:お願いします\s*。?\s*)?(?:描いて|描く))/;
      const isDraw = (shapePattern) => {
        const optionalDet = "(?:\\s+(?:the|a|an|el|la|los|las|un|una|o|a|os|as|il|lo|la|i|gli|le))?";
        return has(new RegExp(drawVerb.source + optionalDet + "\\s+" + shapePattern));
      };
      const rectPattern =
        "(rectangle|square|rect(engle|angle)?|rectángulo|rectangulo|cuadrado|retângulo|retangulo|quadrado|carré|rechteck|quadrat|rettangolo|quadrato|आयत|आयताकार|वर्ग|長方形|四角形|正方形)";
      const diamondPattern =
        "(diamond|diamante|rombo|losango|losange|raute|ひし形|菱形|हीरा)";
      const ellipsePattern =
        "(circle|ellipse|round|círculo|circulo|elipse|cercle|rond|kreis|rund|cerchio|ellisse|वृत्त|गोल|अंडाकार|円|楕円)";
      const arrowPattern = "(arrow|flecha|seta|flèche|pfeil|freccia|तीर|矢印)";
      const linePattern = "(line|línea|linea|linha|ligne|linie|रेखा|線)";
      // If the sentence mentions a frame, prioritize frame handling below over shape-only draws
      const frameNounPattern =
        "(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)";
      const hasFrameMention = new RegExp("\\b" + frameNounPattern + "\\b").test(
        s
      );

      if (!hasFrameMention && isDraw(rectPattern))
        return { action: "drawShape", payload: { shape: "rectangle" } };
      if (!hasFrameMention && isDraw(diamondPattern))
        return { action: "drawShape", payload: { shape: "diamond" } };
      if (!hasFrameMention && isDraw(ellipsePattern))
        return { action: "drawShape", payload: { shape: "ellipse" } };
      if (!hasFrameMention && isDraw(arrowPattern))
        return { action: "drawShape", payload: { shape: "arrow" } };
      if (!hasFrameMention && isDraw(linePattern))
        return { action: "drawShape", payload: { shape: "line" } };

      // Frame commands (regular frame and magic/smart frame), and optional "with <elements>"
      // Support phrases like:
      // - draw frame
      // - add frame 800x600
      // - create magic frame width 400 height 300
      // - smart frame
      // - draw frame with rectangle
      // - create magic frame with rectangle and arrow
      // Extract optional dimensions (e.g., 800x600 or width/height tokens) — multilingual
      // Supported width labels: EN(width/w), ES(ancho), PT(largura), FR(largeur), DE(breite), IT(larghezza), HI(चौड़ाई), JA(幅)
      // Supported height labels: EN(height/h), ES(alto), PT(altura), FR(hauteur), DE(höhe), IT(altezza), HI(ऊंचाई), JA(高さ)
      const sizeMatchXY = s.match(/\b(\d{2,4})\s*[xX]\s*(\d{2,4})\b/);
      const widthMatch = s.match(
        /\b(width|w|ancho|largura|largeur|breite|larghezza|चौड़ाई|幅)\s*(\d{2,4})\b/
      );
      const heightMatch = s.match(
        /\b(height|h|alto|altura|hauteur|höhe|altezza|ऊंचाई|高さ)\s*(\d{2,4})\b/
      );
      const widthToken = sizeMatchXY
        ? Number(sizeMatchXY[1])
        : widthMatch
        ? Number(widthMatch[2])
        : 0;
      const heightToken = sizeMatchXY
        ? Number(sizeMatchXY[2])
        : heightMatch
        ? Number(heightMatch[2])
        : 0;
      const framePayload = {};
      if (widthToken && heightToken) {
        framePayload.width = widthToken;
        framePayload.height = heightToken;
      }

      // Optional: parse "with <elements>" list after frame intent (robust, tolerant of spacing/misspellings)
      const parseWithElements = (str) => {
        // segment after connectors like "with/containing" (multilingual)
        // EN: with|containing, ES/IT: con, PT: com, FR: avec, DE: mit, HI: के साथ|साथ, JA: で|と
        const withMatch = str.match(
          /\b(with|containing|con|com|avec|mit|के\s+साथ|साथ|で|と)\b\s+(.+)$/
        );
        if (!withMatch) return null;
        const tailOrig = withMatch[2] || "";
        const tail = tailOrig.toLowerCase();
        // If user said "with <frame>" it means just a frame, no elements
        if (
          /^(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)\b/.test(
            tail
          )
        )
          return null;

        // shape synonym map (multilingual: EN, ES, PT, FR, DE, IT, HI, JA)
        const shapeSynonyms = [
          {
            re: /\b(rectangle|square|rect(?:angle|engle)?|rect\s+angle|erect\s+angle|rectángulo|rectangulo|cuadrado|retângulo|retangulo|quadrado|carré|rechteck|quadrat|rettangolo|quadrato|長方形|四角形|正方形|आयत|आयताकार|वर्ग)\b/g,
            shape: "rectangle",
          },
          {
            re: /\b(diamond|rhombus|diamante|rombo|losango|losange|raute|ひし形|菱形|हीरा)\b/g,
            shape: "diamond",
          },
          {
            re: /\b(ellipse|circle|round|oval|círculo|circulo|elipse|cercle|rond|kreis|rund|cerchio|ellisse|円|楕円|वृत्त|गोल|अंडाकार)\b/g,
            shape: "ellipse",
          },
          {
            re: /\b(arrow|flecha|seta|flèche|pfeil|freccia|矢印|तीर)\b/g,
            shape: "arrow",
          },
          {
            re: /\b(line|línea|linea|linha|ligne|linie|線|रेखा)\b/g,
            shape: "line",
          },
          { re: /\b(text)\b/g, shape: "text" },
          { re: /\b(formula|equation|latex)\b/g, shape: "formula" },
        ];

        // Collect matches in order of appearance
        const elements = [];
        const pushes = [];
        for (const syn of shapeSynonyms) {
          let m;
          while ((m = syn.re.exec(tail)) !== null) {
            pushes.push({ idx: m.index, shape: syn.shape });
          }
        }
        // sort by index to preserve spoken order
        pushes.sort((a, b) => a.idx - b.idx);
        for (const p of pushes) elements.push({ shape: p.shape });

        // Dimensions: allow simple sizes right after a matched word (e.g., "rectangle 200x100")
        // This is a best-effort parse: scan tail for "<shape> <w>x<h>" patterns and decorate
        const sizePattern =
          /(rectangle|square|rect(?:angle|engle)?|rect\s+angle|erect\s+angle|diamond|rhombus|ellipse|circle|round|oval|arrow|line|text|formula|equation|latex)\s+(\d{2,4})\s*[xX]\s*(\d{2,4})/g;
        let sm;
        while ((sm = sizePattern.exec(tail)) !== null) {
          const norm = (() => {
            const w = sm[1];
            if (
              /^rectangle|square|rect/.test(w) ||
              /rect\s+angle/.test(w) ||
              /erect\s+angle/.test(w)
            )
              return "rectangle";
            if (/diamond|rhombus/.test(w)) return "diamond";
            if (/ellipse|circle|round|oval/.test(w)) return "ellipse";
            if (/arrow/.test(w)) return "arrow";
            if (/line/.test(w)) return "line";
            if (/text/.test(w)) return "text";
            return "formula";
          })();
          const w = Number(sm[2]);
          const h = Number(sm[3]);
          // decorate the first matching element of that type
          const target = elements.find((e) => e.shape === norm);
          if (target) {
            target.width = w;
            target.height = h;
          }
        }

        return elements.length ? elements : null;
      };

      // Extract shapes anywhere in the sentence (not limited to after "with")
      const extractElementsFromText = (str) => {
        if (!str) return null;
        const sLower = String(str).toLowerCase();
        const shapeSynonyms = [
          {
            re: /\b(rectangle|square|rect(?:angle|engle)?|rect\s+angle|erect\s+angle|rectángulo|rectangulo|cuadrado|retângulo|retangulo|quadrado|carré|rechteck|quadrat|rettangolo|quadrato|長方形|四角形|正方形|आयत|आयताकार|वर्ग)\b/g,
            shape: "rectangle",
          },
          {
            re: /\b(diamond|rhombus|diamante|rombo|losango|losange|raute|ひし形|菱形|हीरा)\b/g,
            shape: "diamond",
          },
          {
            re: /\b(ellipse|circle|round|oval|círculo|circulo|elipse|cercle|rond|kreis|rund|cerchio|ellisse|円|楕円|वृत्त|गोल|अंडाकार)\b/g,
            shape: "ellipse",
          },
          {
            re: /\b(arrow|flecha|seta|flèche|pfeil|freccia|矢印|तीर)\b/g,
            shape: "arrow",
          },
          {
            re: /\b(line|línea|linea|linha|ligne|linie|線|रेखा)\b/g,
            shape: "line",
          },
          { re: /\b(text)\b/g, shape: "text" },
          { re: /\b(formula|equation|latex)\b/g, shape: "formula" },
        ];
        const hits = [];
        for (const syn of shapeSynonyms) {
          let m;
          while ((m = syn.re.exec(sLower)) !== null) {
            hits.push({ idx: m.index, shape: syn.shape });
          }
        }
        hits.sort((a, b) => a.idx - b.idx);
        // De-dupe while preserving order
        const seen = new Set();
        const elements = [];
        for (const h of hits) {
          if (seen.has(h.shape)) continue;
          seen.add(h.shape);
          elements.push({ shape: h.shape });
        }
        // Size hints like "rectangle 200x100"
        const sizePattern =
          /(rectangle|square|rect(?:angle|engle)?|rect\s+angle|erect\s+angle|diamond|rhombus|ellipse|circle|round|oval|arrow|line|text|formula|equation|latex)\s+(\d{2,4})\s*[xX]\s*(\d{2,4})/g;
        let sm;
        while ((sm = sizePattern.exec(sLower)) !== null) {
          const norm = (() => {
            const w = sm[1];
            if (
              /^rectangle|square|rect/.test(w) ||
              /rect\s+angle/.test(w) ||
              /erect\s+angle/.test(w)
            )
              return "rectangle";
            if (/diamond|rhombus/.test(w)) return "diamond";
            if (/ellipse|circle|round|oval/.test(w)) return "ellipse";
            if (/arrow/.test(w)) return "arrow";
            if (/line/.test(w)) return "line";
            if (/text/.test(w)) return "text";
            return "formula";
          })();
          const w = Number(sm[2]);
          const h = Number(sm[3]);
          const target = elements.find((e) => e.shape === norm);
          if (target) {
            target.width = w;
            target.height = h;
          }
        }
        return elements.length ? elements : null;
      };

      // If user mentions shapes and also "with frame", create frame with those shapes
      // Detect "with <frame>" suffix across languages
      const hasWithFrameSuffix =
        /\b(with|containing|con|com|avec|mit|के\s+साथ|साथ|で|と)\s+(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)\b/.test(
          s
        );
      if (hasWithFrameSuffix) {
        const anyElements = extractElementsFromText(s);
        if (anyElements && anyElements.length) {
          return {
            action: "drawFrame",
            payload: { type: "frame", ...framePayload, elements: anyElements },
          };
        }
      }

      // Magic frame aliases: multilingual for verbs and adjectives
      // Verbs: EN(draw|add|create|insert), ES(dibujar|agregar|añadir|crear|insertar), PT(desenhar|adicionar|criar|inserir),
      // FR(dessiner|ajouter|créer|insérer), DE(zeichnen|hinzufügen|erstellen|einfügen), IT(disegnare|aggiungere|creare|inserire),
      // HI(ड्रॉ|आंकना|जोड़ें|बनाएं|डालें), JA(描く|追加|作成|挿入)
      // Magic/Smart adjectives: EN(magic|smart), ES(mágico|inteligente), PT(mágico|inteligente), FR(magique|intelligent),
      // DE(zauber|magisch|intelligent), IT(magico|intelligente), HI(जादुई|स्मार्ट), JA(マジック|スマート)
      // Frame nouns: EN(frame), ES(marco), PT(quadro|moldura), FR(cadre), DE(rahmen), IT(cornice), HI(फ्रेम|फ़्रेम), JA(フレーム|枠)
      if (
        has(
          /(please\s+)?(draw|add|create|insert|dibujar|agregar|añadir|crear|insertar|desenhar|adicionar|criar|inserir|dessiner|ajouter|créer|insérer|zeichnen|hinzufügen|erstellen|einfügen|ड्रॉ|आंकना|जोड़ें|बनाएं|डालें|disegnare|aggiungere|creare|inserire|描く|追加|作成|挿入)\s+(magic|smart|mágico|magico|magique|zauber|magisch|जादुई|स्मार्ट|inteligente|intelligent|intelligente|マジック|スマート)\s+(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)/
        ) ||
        has(
          /\b(magic|smart|mágico|magico|magique|zauber|magisch|जादुई|स्मार्ट|inteligente|intelligent|intelligente|マジック|スマート)\s+(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)\b/
        )
      ) {
        const elements = parseWithElements(s) || extractElementsFromText(s);
        return {
          action: "drawFrame",
          payload: {
            type: "magicframe",
            ...framePayload,
            ...(elements ? { elements } : {}),
          },
        };
      }
      // Regular frame intents
      if (
        has(
          /(please\s+)?(draw|add|create|insert|dibujar|agregar|añadir|crear|insertar|desenhar|adicionar|criar|inserir|dessiner|ajouter|créer|insérer|zeichnen|hinzufügen|erstellen|einfügen|ड्रॉ|आंकना|जोड़ें|बनाएं|डालें|disegnare|aggiungere|creare|inserire|描く|追加|作成|挿入)\s+(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)/
        ) ||
        has(
          /\b(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)\b/
        ) // single-word fallback
      ) {
        const elements = parseWithElements(s) || extractElementsFromText(s);
        return {
          action: "drawFrame",
          payload: {
            type: "frame",
            ...framePayload,
            ...(elements ? { elements } : {}),
          },
        };
      }

      // single-word fallbacks
      if (has(/\b(rectangle|square|rect(engle|angle)?)\b/))
        return { action: "drawShape", payload: { shape: "rectangle" } };
      if (has(/\b(diamond)\b/))
        return { action: "drawShape", payload: { shape: "diamond" } };
      if (has(/\b(circle|ellipse|round)\b/))
        return { action: "drawShape", payload: { shape: "ellipse" } };
      if (has(/\barrow\b/))
        return { action: "drawShape", payload: { shape: "arrow" } };
      if (has(/\bline\b/))
        return { action: "drawShape", payload: { shape: "line" } };

      // Insert text commands (quoted or unquoted), multilingual verbs and noun
      // Examples:
      // - "add text hello" | "add text: hello"
      // - "please add a text with hello"
      // - "insert text \"Hello World\""
      // Multilingual verbs: EN(add|insert|write), ES(agregar|añadir|insertar|escribir),
      // PT(adicionar|inserir|escrever), FR(ajouter|insérer|écrire|ecrire),
      // DE(hinzufügen|einfügen|schreiben), IT(aggiungere|inserire|scrivere),
      // HI(जोड़ें|डालें|लिखें), JA(追加|挿入|書く|書いて)
      // Noun "text": EN(text), ES/PT(texto), FR(texte), DE(Text), IT(testo), HI(पाठ), JA(テキスト)
      const t = s.match(
        /(?:please\s+)?(?:add|insert|write|agregar|añadir|insertar|escribir|adicionar|inserir|escrever|ajouter|insérer|écrire|ecrire|hinzufügen|einfügen|schreiben|aggiungere|inserire|scrivere|जोड़ें|डालें|लिखें|追加|挿入|書く|書いて)\s+(?:the\s+|a\s+|an\s+)?(?:text|texto|texte|testo|पाठ|テキスト)(?:\s*[:,-])?(?:\s+(?:with|saying|that\s+says|containing|of|con|que\s+diga|que\s+dice|que\s+contiene|de|com|que\s+diz|que\s+contém|qui\s+dit|qui\s+contient|mit|der\s+sagt|der\s+enthält|che\s+dice|che\s+contiene|के\s+साथ|जो\s+कहता\s+है|जो\s+शामिल\s+है)?\s+)?(?:["']([^"']+)["']|(.+))$/i
      );
      if (t) {
        const textValue = (t[1] || t[2] || "").trim();
        if (textValue)
          return { action: "addText", payload: { text: textValue } };
      }

      // Insert formula/equation commands (LaTeX or plain). If no content is
      // provided, still trigger addFormula and let Whiteboard use a default.
      // Accept variations like "add a latex formula", "insert the equation", etc.
      const f = s.match(
        /(?:add|insert|write)\s+(?:the\s+|a\s+|an\s+)?(?:latex\s+)?(?:formula|equation)\s+(?:["']([^"']+)["']|(.+))$/i
      );
      if (f) {
        const formula = (f[1] || f[2] || "").trim();
        if (formula) return { action: "addFormula", payload: { formula } };
        return { action: "addFormula" };
      }
      if (
        /(?:add|insert|write)\s+(?:the\s+|a\s+|an\s+)?(?:latex\s+)?(?:formula|equation)\b/i.test(
          s
        )
      ) {
        return { action: "addFormula" };
      }
      return null;
    };

    // Parse lesson plan generation requests
    const parseLessonPlanCommand = (text) => {
      if (!text) return null;
      const s = String(text).toLowerCase().trim();
      // Try to detect explicit target language mentioned in the command
      const detectExplicitLanguage = (t) => {
        const str = String(t || "").toLowerCase();
        const map = {
          // English mentions
          english: "en",
          spanish: "es",
          portuguese: "pt",
          french: "fr",
          german: "de",
          hindi: "hi",
          italian: "it",
          japanese: "ja",
          // Spanish mentions
          español: "es",
          portugués: "pt",
          francés: "fr",
          alemán: "de",
          hindi: "hi",
          italiano: "it",
          japonés: "ja",
          inglés: "en",
          // Portuguese mentions
          português: "pt",
          espanhol: "es",
          francês: "fr",
          alemão: "de",
          inglês: "en",
          // French mentions
          français: "fr",
          espagnol: "es",
          portugais: "pt",
          allemand: "de",
          anglais: "en",
          // German mentions
          deutsch: "de",
          englisch: "en",
          französisch: "fr",
          spanisch: "es",
          portugiesisch: "pt",
          // Hindi mentions (Devanagari and transliterations)
          हिंदी: "hi",
          अंग्रेज़ी: "en",
          स्पेनिश: "es",
          // Italian mentions
          italiano: "it",
          inglese: "en",
          spagnolo: "es",
          // Japanese mentions
          日本語: "ja",
          英語: "en",
        };
        // Patterns like "in <language>", "en <idioma>", "em <idioma>", "auf <sprache>", "में <भाषा>"
        const prepositions = [
          "in",
          "en",
          "em",
          "auf",
          "में",
          "de",
          "por",
          "para",
        ];
        for (const [name, code] of Object.entries(map)) {
          const direct = str.includes(name);
          const withPrep = prepositions.some((p) =>
            str.includes(`${p} ${name}`)
          );
          if (direct || withPrep) return code;
        }
        return null;
      };
      const explicitLang = detectExplicitLanguage(s);
      // If the phrase contains lesson plan, extract topic keywords
      // Multilingual verbs
      const verbs = [
        // English
        "create",
        "generate",
        "make",
        "build",
        "prepare",
        "plan",
        // Spanish
        "crear",
        "generar",
        "hacer",
        "elaborar",
        "preparar",
        "planificar",
        // Portuguese
        "criar",
        "gerar",
        "fazer",
        "elaborar",
        "preparar",
        "planejar",
        // French
        "créer",
        "generer",
        "générer",
        "faire",
        "élaborer",
        "preparer",
        "préparer",
        "planifier",
        // German
        "erstellen",
        "generieren",
        "machen",
        "vorbereiten",
        "planen",
        // Hindi (common transliterations)
        "बनाओ",
        "बनाना",
        "तैयार",
        "तैयारी",
        "योजना",
        "योजन",
        // Italian
        "crea",
        "generare",
        "fare",
        "preparare",
        "elaborare",
        "pianificare",
        // Japanese
        "作成",
        "生成",
        "作る",
        "準備",
        "計画",
      ];
      // Lesson plan phrases across languages
      const planPhrases = [
        "lesson plan",
        "plan de clase",
        "plan de lección",
        "plano de aula",
        "plano de lição",
        "plan de leçon",
        "plan de cours",
        "unterrichtsplan",
        "lektionsplan",
        "पाठ योजना",
        "piano di lezione",
        "授業計画",
        "レッスンプラン",
      ];
      const hasVerb = verbs.some((v) => s.includes(v));
      const hasPlanPhrase = planPhrases.some((p) => s.includes(p));
      // Connectors across languages
      const connectors = [
        "with ",
        "about ",
        "on ",
        "for ",
        "con ",
        "sobre ",
        "en ",
        "para ",
        "de ",
        "com ",
        "sobre ",
        "em ",
        "para ",
        "de ",
        "avec ",
        "sur ",
        "en ",
        "pour ",
        "de ",
        "mit ",
        "über ",
        "für ",
        "के बारे में ",
        "पर ",
        "के लिए ",
        "के साथ ",
        "で ",
        "について ",
        "の ",
        "ために ",
        "と ",
      ];
      // Try to detect explicit intent first using plan phrases
      const intent =
        hasPlanPhrase && (hasVerb || true)
          ? { match: true }
          : s.match(
              /\b(create|generate|make|build|prepare|plan)\b.*\blesson\s+plan\b(.*)/
            );
      if (intent) {
        let tail = "";
        // If we matched by contains, extract tail after the plan phrase
        if (intent.match) {
          // Find the last occurrence of any plan phrase and take what's after
          let idx = -1;
          for (const p of planPhrases) {
            const i = s.lastIndexOf(p);
            if (i !== -1 && i + p.length > idx) idx = i + p.length;
          }
          tail = idx !== -1 ? s.slice(idx).trim() : "";
        } else {
          tail = (intent[2] || "").trim();
        }
        // Remove leading connectors in multiple languages
        let topic = tail;
        for (const c of connectors) {
          if (topic.startsWith(c)) {
            topic = topic.slice(c.length).trim();
            break;
          }
        }
        const langCode =
          explicitLang || getLanguageCode(this.state?.currentLanguage || "en");
        return {
          action: "generateLessonPlan",
          payload: { query: topic || text, language: langCode },
        };
      }
      // Also handle direct mentions like "lesson plan with <topic>"
      const direct = s.match(
        /(?:lesson\s+plan|plan\s+de\s+(?:clase|lección)|plano\s+de\s+(?:aula|liç[ãa]o)|plan\s+de\s+(?:leçon|cours)|(?:unterrichts|lektions)plan|पाठ\s+योजना|piano\s+di\s+lezione|授業計画|レッスンプラン)\s+(?:with|about|on|for|con|sobre|en|para|de|com|sur|pour|mit|über|für|के बारे में|पर|के लिए|で|について|の|ために|と)\s+(.+)/
      );
      if (direct) {
        const topic = (direct[2] || "").trim();
        const langCode =
          explicitLang || getLanguageCode(this.state?.currentLanguage || "en");
        return {
          action: "generateLessonPlan",
          payload: { query: topic || text, language: langCode },
        };
      }
      // NEW: Support phrases without the word "plan", e.g., "create lesson with <topic>"
      const lessonNouns = [
        "lesson",
        "clase",
        "lección",
        "aula",
        "lição",
        "leçon",
        "cours",
        "lektion",
        "unterricht",
        "पाठ",
        "कक्षा",
        "lezione",
        "授業",
        "レッスン",
      ];
      const simple =
        hasVerb && lessonNouns.some((n) => s.includes(n))
          ? {
              groups: [
                null,
                null,
                null,
                (() => {
                  // Try to get after connectors
                  let after = "";
                  let base = s;
                  for (const c of connectors) {
                    const i = base.indexOf(c);
                    if (i !== -1) {
                      after = base.slice(i + c.length).trim();
                      break;
                    }
                  }
                  return after;
                })(),
              ],
            }
          : s.match(
              /\b(create|generate|make|build|prepare|plan)\b.*\blesson\b(?:\s+(with|about|on|for)\s+(.+))?/
            );
      if (simple) {
        const topic = (
          simple.groups ? simple.groups[3] : simple[3] || ""
        ).trim();
        const langCode =
          explicitLang || getLanguageCode(this.state?.currentLanguage || "en");
        return {
          action: "generateLessonPlan",
          payload: { query: topic || text, language: langCode },
        };
      }
      // NEW: Bare "lesson with <topic>" without leading verb
      const bare = s.match(
        /(?:lesson|clase|lección|aula|lição|leçon|cours|lektion|unterricht|पाठ|कक्षा|lezione|授業|レッスン)\s+(?:with|about|on|for|con|sobre|en|para|de|com|sur|pour|mit|über|für|के बारे में|पर|के लिए|で|について|の|ために|と)\s+(.+)/
      );
      if (bare) {
        const topic = ((bare[1] ? bare[1] : "") + " " + (bare[2] || ""))
          .trim()
          .replace(
            /^(with|about|on|for|con|sobre|en|para|de|com|sur|pour|mit|über|für|के बारे में|पर|के लिए|で|について|の|ために|と)\s+/i,
            ""
          );
        const langCode =
          explicitLang || getLanguageCode(this.state?.currentLanguage || "en");
        return {
          action: "generateLessonPlan",
          payload: { query: topic || text, language: langCode },
        };
      }
      return null;
    };

    // Utility to sanitize URLs that may be wrapped with backticks or spaces
    const sanitizeUrl = (u) => (u ? String(u).replace(/`/g, "").trim() : "");

    // Collection search function - searches collections by matching item names with titles
    // Also, be tolerant of collections without pre-populated files; we can still use
    // their ACV source to add elements and only fall back to images if available.
    const searchCollections = async (itemName) => {
      if (!itemName) return null;

      const normalizedItem = String(itemName).toLowerCase().trim();
      const itemHasLibraryWord =
        /\b(library|collection|pack|bundle|set|kit)s?\b/i.test(normalizedItem);
      const normalize = (s) =>
        (s || "")
          .toString()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, " ")
          .trim();
      const stemWord = (w) => {
        if (!w) return w;
        let x = w.replace(/ies$/i, "y");
        x = x.replace(/(ing|ed|es|s)$/i, "");
        return x.length >= 2 ? x : w;
      };
      const tokenize = (s) =>
        normalize(s).split(/\s+/).filter(Boolean).map(stemWord);
      const joinTokens = (arr) => arr.join(" ");
      // Guard against generic-only asks like "new library" that lack a specific name
      try {
        const GENERIC_WORDS = new Set([
          "library",
          "collection",
          "pack",
          "bundle",
          "set",
          "kit",
          // common fillers/adjectives that don’t identify a specific collection
          "new",
          "latest",
          "recent",
          "fresh",
          "complete",
          "full",
          "whole",
          "all",
        ]);
        const reqTokens = tokenize(normalizedItem);
        const reqCoreTokens = reqTokens.filter((t) => !GENERIC_WORDS.has(t));
        if (itemHasLibraryWord && reqCoreTokens.length === 0) {
          console.log(
            "[VOICE-DEBUG] 🚫 Collection match skipped: generic-only library request:",
            normalizedItem
          );
          return null;
        }
      } catch (e) {
        // non-fatal; continue with normal flow
      }
      const levenshtein = (a, b) => {
        const m = a.length,
          n = b.length;
        if (m === 0) return n;
        if (n === 0) return m;
        const dp = Array(n + 1);
        for (let j = 0; j <= n; j++) dp[j] = j;
        for (let i = 1; i <= m; i++) {
          let prev = dp[0];
          dp[0] = i;
          for (let j = 1; j <= n; j++) {
            const temp = dp[j];
            dp[j] = Math.min(
              dp[j] + 1,
              dp[j - 1] + 1,
              prev + (a[i - 1] === b[j - 1] ? 0 : 1)
            );
            prev = temp;
          }
        }
        return dp[n];
      };

      // Try to get collections from cache or fetch them
      let collections = this.collectionsCache;
      if (!collections) {
        try {
          // Fetch collections from API using the same pattern as other collection endpoints
          const END_POINT = process.env.REACT_APP_EP_URL;
          const slug = this.props?.user?.slug || "";

          // Try to get all published collections
          const response = await axios.get(
            `${END_POINT}/api/library/status-wise-collection${slug}&status=Published&limit=1000&offset=0&sort=createdAt`
          );

          if (response.data) {
            // Handle different response formats
            if (Array.isArray(response.data.result)) {
              collections = response.data.result;
            } else if (
              response.data.result &&
              Array.isArray(response.data.result.collections)
            ) {
              collections = response.data.result.collections;
            } else if (Array.isArray(response.data.result)) {
              collections = response.data.result;
            } else if (Array.isArray(response.data)) {
              collections = response.data;
            } else {
              collections = [];
            }
            this.collectionsCache = collections; // Cache for future use
          } else {
            console.warn("No collections data received");
            return null;
          }
        } catch (error) {
          console.warn("Error fetching collections:", error);
          // If fetch fails, try to get from whiteboard iframe if available
          // This could be passed as a prop or retrieved from iframe
          return null;
        }
      }

      if (!collections || collections.length === 0) {
        return null;
      }

      // Build token frequency across all titles to downweight generic tokens dynamically
      let allTitlesTokens = [];
      try {
        if (collections && collections.length) {
          for (const collection of collections) {
            let localTitles = [];
            if (collection.title) {
              try {
                const parsed = JSON.parse(collection.title);
                localTitles = Array.isArray(parsed)
                  ? parsed
                  : [collection.title];
              } catch {
                localTitles = [collection.title];
              }
            }
            if (collection.name) localTitles.push(collection.name);
            for (const t of localTitles) {
              const toks = tokenize(t);
              if (toks.length) allTitlesTokens.push(...toks);
            }
          }
        }
      } catch {}
      const freq = new Map();
      for (const tk of allTitlesTokens) freq.set(tk, (freq.get(tk) || 0) + 1);
      const weight = (tk) => 1 / (1 + (freq.get(tk) || 0));

      // Search through collections
      const matches = [];

      for (const collection of collections) {
        try {
          // Parse title - it can be a JSON array or a plain string
          let titles = [];
          let isTitleArray = false;
          if (collection.title) {
            try {
              // Try to parse as JSON array
              const parsed = JSON.parse(collection.title);
              if (Array.isArray(parsed)) {
                titles = parsed;
                isTitleArray = true;
              } else {
                titles = [collection.title];
              }
            } catch (e) {
              // If not JSON, treat as plain string
              titles = [collection.title];
            }
          }

          // Also check collection name (but don't treat it as array-indexed)
          const collectionNameIndex = titles.length;
          if (collection.name) {
            titles.push(collection.name);
          }

          // Check each title for matches
          for (let titleIndex = 0; titleIndex < titles.length; titleIndex++) {
            const title = titles[titleIndex];
            const normalizedTitle = String(title).toLowerCase().trim();
            const itemToMatch = normalizedItem.startsWith("the ")
              ? normalizedItem.substring(4).trim()
              : normalizedItem;
            const titleToMatch = normalizedTitle.startsWith("the ")
              ? normalizedTitle.substring(4).trim()
              : normalizedTitle;

            // Stemming + dynamic token weighting
            const titleTokens = tokenize(titleToMatch);
            const itemTokens = tokenize(itemToMatch);
            const GENERIC_TOKENS = new Set([
              "library",
              "collection",
              "pack",
              "bundle",
              "set",
              "kit",
            ]);
            const itemCoreTokens = itemTokens.filter(
              (t) => !GENERIC_TOKENS.has(t)
            );
            const titleStr = joinTokens(titleTokens);
            const itemStr = joinTokens(itemTokens);

            let matchScore = 0;
            if (titleStr === itemStr && titleStr.length) {
              matchScore = 100;
            } else {
              // Weighted overlap with small edit tolerance per token
              const itemWeightsSum =
                itemTokens.reduce((sum, tk) => sum + weight(tk), 0) || 1;
              let overlapWeight = 0;
              for (const it of itemTokens) {
                const wIt = weight(it);
                const exact = titleTokens.includes(it);
                if (exact) {
                  overlapWeight += wIt;
                } else {
                  const near = titleTokens.some(
                    (tt) => levenshtein(it, tt) <= 1
                  );
                  if (near) overlapWeight += wIt * 0.8; // slightly discount fuzzy
                }
              }
              const coverage = overlapWeight / itemWeightsSum; // 0..1
              matchScore = Math.round(100 * coverage);
              // inclusion boost after stemming
              if (
                itemStr &&
                titleStr &&
                (itemStr.includes(titleStr) || titleStr.includes(itemStr))
              ) {
                matchScore = Math.max(matchScore, 92);
              }
              // small global edit-distance boost
              const edit = levenshtein(itemStr, titleStr);
              if (edit <= 2) matchScore = Math.max(matchScore, 85);
            }

            // Special preference: if user said "... library/collection" and this title
            // is the collection name, strongly prefer near-equal name matches.
            const isCollectionNameTitle = titleIndex >= collectionNameIndex;
            if (isCollectionNameTitle && itemHasLibraryWord) {
              const nameTokens = tokenize(collection.name || "");
              const nameStem = joinTokens(nameTokens);
              const itemCoreStem = joinTokens(itemCoreTokens);
              // Tight near-equality: exact or short-name startsWith only
              const shortStartsWith =
                nameTokens.length <= Math.max(2, itemCoreTokens.length + 1) &&
                nameStem.startsWith(itemCoreStem);
              const nearEqual =
                itemCoreStem && (itemCoreStem === nameStem || shortStartsWith);
              // Compute overlap coverage ignoring generic words; penalize long extra words
              let coreOverlap = 0;
              const itemCoreSet = new Set(itemCoreTokens);
              for (const t of nameTokens) if (itemCoreSet.has(t)) coreOverlap++;
              const covItem = itemCoreTokens.length
                ? coreOverlap / itemCoreTokens.length
                : 0;
              const covName = nameTokens.length
                ? coreOverlap / nameTokens.length
                : 0;
              const cov = Math.min(covItem, covName); // require overlap on both sides
              if (nearEqual) {
                matchScore = Math.max(matchScore, 100);
              } else if (cov >= 0.75) {
                matchScore = Math.max(matchScore, 95);
              } else if (cov >= 0.5) {
                matchScore = Math.max(matchScore, 88);
              }
              // Small name-preference only if there is meaningful two-sided overlap
              if (cov >= 0.5) matchScore = Math.min(100, matchScore + 2);
            }

            // If we have a reasonable match (score >= 50)
            if (matchScore >= 50) {
              // Determine a display file when available, but do not require one.
              let fileToUse = null;
              if (collection.files && collection.files.length > 0) {
                // If title is from a JSON array and we're within the array bounds, use the corresponding file index
                if (isTitleArray && titleIndex < collection.files.length) {
                  fileToUse = collection.files[titleIndex];
                  console.log(
                    "[VOICE-DEBUG] Using file at index",
                    titleIndex,
                    "for title at index",
                    titleIndex,
                    "title:",
                    title
                  );
                } else if (titleIndex >= collectionNameIndex) {
                  // This is the collection name, not a title from the array - use first file
                  fileToUse = collection.files[0];
                  console.log(
                    "[VOICE-DEBUG] Using first file for collection name match:",
                    title
                  );
                } else {
                  // Title array but index out of bounds - use first file as fallback
                  fileToUse = collection.files[0];
                  console.log(
                    "[VOICE-DEBUG] Title index",
                    titleIndex,
                    "out of bounds, using first file as fallback"
                  );
                }
              }
              // Push the match even if there's no file – element insertion can still proceed via ACV source.
              matches.push({
                collection,
                matchedTitle: title,
                file: fileToUse
                  ? { ...fileToUse, url: sanitizeUrl(fileToUse.url) }
                  : null,
                matchScore,
                _weightedCoverage: matchScore,
                _isTitleArray: isTitleArray,
                _titleIndex: titleIndex,
              });
              break; // Found a match in this collection, no need to check other titles
            }
          }
        } catch (error) {
          console.warn("Error processing collection:", error);
          continue;
        }
      }

      // Return the best match (highest score)
      if (matches.length > 0) {
        // Sort by match score descending
        matches.sort((a, b) => (b.matchScore || 0) - (a.matchScore || 0));
        return matches[0];
      }
      return null;
    };

    // Free draw command parser for natural language drawing requests
    const parseFreeDrawCommand = (text) => {
      if (!text) {
        return null;
      }
      const s = String(text).toLowerCase().trim();
      console.log("[VOICE-DEBUG] parseFreeDrawCommand input:", s);

      // Avoid misrouting spinner commands to free draw due to ASR misspellings
      // e.g., "spin well", "spin will", or "speed wheel" should trigger spinner flow
      const spinnerHint =
        /\bspin(?:ning)?\s*(wheel|well|will)\b|\bspinner\b|\bspeed\s*(wheel|well|will)\b|\b(ruleta|rueda|roleta|roda|roue|roulette|rad|glücksrad|ruota)\b|(?:girar|generar|crear|hacer)\s+(?:la\s+)?(?:ruleta|rueda)\b|(?:girar|gerar|criar|fazer)\s+(?:a\s+)?(?:roleta|roda)\b|(?:tourner|générer|créer|faire)\s+(?:la\s+)?(?:roue|roulette)\b|(?:drehen|erzeugen|erstellen|machen)\s+(?:das\s+)?(?:rad|glücksrad)\b|(?:girare|generare|creare|fare)\s+(?:la\s+)?(?:ruota|roulette)\b|(?:ルーレット|ホイール|スピナー)/;
      if (spinnerHint.test(s)) {
        return null;
      }

      // Match patterns like "I want elephant", "I need elephant", "show me elephant", etc.
      // Also handles "give me the...", "get me...", "bring me...", "fetch me...", etc.
      const wantPatterns = [
        // English
        /(?:I\s+)?(?:want|need|would\s+like|show\s+me|show|display)\s+(?:an?\s+|the\s+)?(.+)/,
        /(?:please\s+)?(?:give\s+me|get\s+me|bring\s+me|fetch\s+me|grab\s+me|hand\s+me|pass\s+me)\s+(?:an?\s+|the\s+)?(.+)/,
        /(?:can\s+you\s+)?(?:give|get|bring|fetch|grab|hand|pass|show|display)\s+(?:me\s+)?(?:an?\s+|the\s+)?(.+)/,
        /(?:I\s+)?(?:would\s+like|wish\s+for|ask\s+for|request)\s+(?:an?\s+|the\s+)?(.+)/,
        /(?:please\s+)?(?:create|make|draw|sketch|generate|produce)\s+(?:an?\s+|the\s+|me\s+an?\s+)?(.+)/,
        /(?:let\s+me\s+have|help\s+me\s+get|find\s+me)\s+(?:an?\s+|the\s+)?(.+)/,
        /(?:please\s+)?(?:add|put|insert|place)\s+(?:an?\s+|the\s+)?(.+)/,
        // Spanish
        /(?:por\s+favor\s+)?(?:muestrame|muéstrame|muestra|mostrar|enséñame|ensename)\s+(?:un\s+|una\s+|el\s+|la\s+)?(.+)/,
        /(?:por\s+favor\s+)?(?:dame|entregame)\s+(?:un\s+|una\s+|el\s+|la\s+)?(.+)/,
        /(?:yo\s+)?(?:quiero|necesito)\s+(?:un\s+|una\s+|el\s+|la\s+)?(.+)/,
        /(?:por\s+favor\s+)?(?:crea|haz|genera|produce|dibuja|inserta|coloca|añade|agrega)\s+(?:un\s+|una\s+|el\s+|la\s+)?(.+)/,
      ];

      for (const pattern of wantPatterns) {
        const match = s.match(pattern);
        if (match && match[1]) {
          let itemName = match[1].trim();
          console.log(
            "[VOICE-DEBUG] Pattern matched, itemName before cleanup:",
            itemName
          );

          // Remove common trailing phrases and words
          itemName = itemName
            .replace(
              /\s+(please|thanks|thank\s+you|now|here|for\s+me|to\s+me)$/i,
              ""
            )
            .trim();

          // Don't remove "the" from multi-word names like "the star eyes emoji"
          // Only remove if it's a single word after "the"
          const words = itemName.split(/\s+/);
          if (words.length === 1 && /^(the|a|an)$/i.test(words[0])) {
            itemName = "";
          } else {
            // Keep "the" if it's part of a multi-word name
            // Only remove leading "the/a/an" if followed by a single word
            if (words.length > 1 && /^(the|a|an)$/i.test(words[0])) {
              // Keep it - it's part of the name
            } else if (words.length === 2 && /^(the|a|an)$/i.test(words[0])) {
              // Remove single leading article
              itemName = itemName.replace(/^(the|a|an)\s+/i, "").trim();
            }
          }

          // Remove common filler words at the end
          itemName = itemName
            .replace(
              /\s+(on\s+the\s+canvas|on\s+canvas|to\s+the\s+canvas|to\s+canvas|here|now)$/i,
              ""
            )
            .trim();

          console.log("[VOICE-DEBUG] itemName after cleanup:", itemName);

          if (itemName && itemName.length > 1) {
            return {
              action: "freedraw",
              payload: {
                description: itemName,
                type: "freedraw",
                isWantCommand: true,
              },
            };
          }
        }
      }

      // Match patterns like "please draw this...", "draw a...", "sketch...", "create...", etc.
      // These will also check collections first before drawing
      const freeDrawPatterns = [
        // English
        /(please\s+)?draw\s+(a\s+)?(.+)/,
        /(please\s+)?sketch\s+(a\s+)?(.+)/,
        /(please\s+)?create\s+(a\s+)?(.+)/,
        /(please\s+)?make\s+(a\s+)?(.+)/,
        /(please\s+)?draw\s+(this|a|an|some|any|whatever|anything|something)/,
        /(please\s+)?sketch\s+(this|a|an|some|any|whatever|anything|something)/,
        /(please\s+)?create\s+(this|a|an|some|any|whatever|anything|something)/,
        /(please\s+)?make\s+(this|a|an|some|any|whatever|anything|something)/,
        /free\s+draw/,
        /freehand/,
        /draw\s+freely/,
        // Spanish
        /(por\s+favor\s+)?dibuja\s+(un\s+|una\s+)?(.+)/,
        /(por\s+favor\s+)?crea\s+(un\s+|una\s+)?(.+)/,
        /(por\s+favor\s+)?haz\s+(un\s+|una\s+)?(.+)/,
        /(por\s+favor\s+)?genera\s+(un\s+|una\s+)?(.+)/,
        /(por\s+favor\s+)?dibuja\s+(esto|un|una|unos|unas|algo|cualquier\s+cosa)/,
        /(por\s+favor\s+)?crea\s+(esto|un|una|unos|unas|algo|cualquier\s+cosa)/,
        /(por\s+favor\s+)?haz\s+(esto|un|una|unos|unas|algo|cualquier\s+cosa)/,
        /(por\s+favor\s+)?genera\s+(esto|un|una|unos|unas|algo|cualquier\s+cosa)/,
      ];

      for (const pattern of freeDrawPatterns) {
        const match = s.match(pattern);
        if (match) {
          // Extract the drawing description if available
          // For patterns like /(please\s+)?draw\s+(a\s+)?(.+)/, match[3] contains the object
          // For patterns like /(please\s+)?draw\s+(this|a|an|...)/, match[2] contains the generic word
          let description = match[3] || match[2] || "free drawing";

          // Clean up the description similar to wantPatterns
          description = description
            .replace(
              /\s+(please|thanks|thank\s+you|now|here|for\s+me|to\s+me)$/i,
              ""
            )
            .trim();
          description = description.replace(/^(the|a|an)\s+/i, "").trim();
          description = description
            .replace(
              /\s+(on\s+the\s+canvas|on\s+canvas|to\s+the\s+canvas|to\s+canvas|here|now)$/i,
              ""
            )
            .trim();

          // Only return if we have a meaningful description (not just generic words)
          if (
            description &&
            description.length > 1 &&
            !/^(this|a|an|some|any|whatever|anything|something)$/i.test(
              description
            )
          ) {
            return {
              action: "freedraw",
              payload: {
                description: description,
                type: "freedraw",
                isWantCommand: true, // Mark as want command so it checks collections
              },
            };
          }
        }
      }

      return null;
    };

    // First handle undo/redo with preference for lesson navigation history
    if (type === "undo" || type === "redo") {
      try {
        const topUndo = this.undoStack?.[this.undoStack.length - 1] || null;
        const topRedo = this.redoStack?.[this.redoStack.length - 1] || null;
        const hasLessonUndo =
          type === "undo" &&
          ((topUndo && topUndo.type === "lesson") ||
            (this.lastAction && this.lastAction.type === "lesson"));
        const hasLessonRedo =
          type === "redo" && topRedo && topRedo.type === "lesson";

        if (hasLessonUndo) {
          const result = await this._undoLastAction();
          if (result?.message) {
            if (result.success) toast.success(result.message);
            else toast.error(result.message);
          }
          return result;
        }
        if (hasLessonRedo) {
          const result = await this._redoLastAction();
          if (result?.message) {
            if (result.success) toast.success(result.message);
            else toast.error(result.message);
          }
          return result;
        }
      } catch (e) {
        // If lesson undo/redo fails, continue to whiteboard command
      }

      const ok = postToWhiteboard(type);
      if (ok) {
        const result = { success: true, message: `Whiteboard: ${type}` };
        toast.success(result.message);
        return result;
      }
      // Fallback to local stacks even if they don't contain lesson actions
      try {
        let result;
        if (type === "undo") {
          result = await this._undoLastAction();
        } else {
          result = await this._redoLastAction();
        }
        if (result?.message) {
          if (result.success) toast.success(result.message);
          else toast.error(result.message);
        }
        return result;
      } catch (e) {
        toast.error(`Unable to ${type}.`);
        return { success: false, message: `Unable to ${type}.` };
      }
    }

    // CRITICAL: Check for collection prompt response FIRST, before ANY other command parsers
    // This prevents "I want from collection" from being processed as insertByText or insertCollectionByTitle
    // MUST be checked at the very beginning, before any command processing
    if (this.pendingCollectionPrompt) {
      const normalizedCmd = String(originalCommand || "")
        .toLowerCase()
        .trim();
      console.log(
        "[VOICE-DEBUG] ⚠️ Pending collection prompt exists, checking if command is a response:",
        normalizedCmd
      );

      const isCollectionResponse =
        /^(yes|collection|from collection|use collection|add from collection|use it|add it|from the collection|i want from collection|want from collection)$/i.test(
          normalizedCmd
        ) ||
        /(?:i\s+)?(?:want|need|get|use|add|put|show|bring)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
          normalizedCmd
        ) ||
        /(?:use|get|add|put|show)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
          normalizedCmd
        );

      if (isCollectionResponse) {
        console.log(
          "[VOICE-DEBUG] ✅✅✅ Collection response detected EARLY, intercepting BEFORE any other processing:",
          normalizedCmd
        );
        const pending = this.pendingCollectionPrompt;
        this.pendingCollectionPrompt = null;

        if (pending.collectionMatch) {
          const { collection, file } = pending.collectionMatch;
          console.log("[VOICE-DEBUG] Adding collection item to canvas:", {
            collectionName: collection.name,
            fileUrl: file.url,
            itemName: pending.itemName,
          });

          const ok = postToWhiteboard("addCollectionItem", {
            fileUrl: file.url,
            collectionId: collection.id,
            collectionName: collection.name,
            fileName: file.id,
          });

          if (ok) {
            toast.success(`Added ${pending.itemName} from collection`);
            console.log(
              "[VOICE-DEBUG] ✅ Successfully sent addCollectionItem to whiteboard"
            );
            return {
              success: true,
              message: `Added ${pending.itemName} from collection to canvas`,
            };
          } else {
            console.error(
              "[VOICE-DEBUG] ❌ Failed to send addCollectionItem - whiteboard not available"
            );
            return { success: false, message: "Whiteboard not available" };
          }
        }
      } else {
        console.log(
          "[VOICE-DEBUG] ⚠️ Command is NOT a collection response, will continue with normal processing:",
          normalizedCmd
        );
      }
    }

    // Check for export commands first (but also handles "export [query] image" as insert)
    const exportParsed = parseExportCommand(originalCommand);
    if (exportParsed) {
      // If this is actually an insert command (export [query] image), handle it differently
      if (exportParsed.action === "insertImageByQuery") {
        const ok = postToWhiteboard(exportParsed.action, exportParsed.payload);
        return ok
          ? {
              success: true,
              message: `Inserting image: ${exportParsed.payload.query}`,
            }
          : { success: false, message: "Whiteboard not available" };
      }
      // Otherwise, it's a real export command
      const ok = postToWhiteboard(exportParsed.action, exportParsed.payload);
      return ok
        ? { success: true, message: `Export: ${exportParsed.action}` }
        : { success: false, message: "Whiteboard not available" };
    }

    // Handle background color commands
    const bgParsed = parseBackgroundCommand(originalCommand);
    if (bgParsed) {
      const ok = postToWhiteboard(bgParsed.action, bgParsed.payload);
      return ok
        ? { success: true, message: "Canvas background updated." }
        : { success: false, message: "Whiteboard not available" };
    }
    // Then handle lesson plan commands before free draw to avoid misrouting
    // Local helper to await a reply from the whiteboard iframe for a given action
    const awaitReply = (doAction, payload = {}) => {
      return new Promise((resolve) => {
        const timeout = setTimeout(() => {
          window.removeEventListener("message", onMessage);
          console.warn(`[VOICE->WB] ${doAction} timeout after 30 seconds`);
          resolve(false);
        }, 30000);
        const onMessage = (e) => {
          const d = e?.data;
          if (!d || d.type !== "acv.whiteboard.reply") return;
          if (d.action !== doAction) return;
          window.removeEventListener("message", onMessage);
          clearTimeout(timeout);
          console.log(`[VOICE->WB] ${doAction} reply received:`, d);
          resolve(!!d.handled);
        };
        window.addEventListener("message", onMessage);
        const sent = postToWhiteboard(doAction, payload);
        if (!sent) {
          clearTimeout(timeout);
          console.warn(
            `[VOICE->WB] Failed to send ${doAction} - iframe not found`
          );
          resolve(false);
        }
      });
    };

    // (List frames logic removed per request)

    // Handle delete-frame by name commands (multilingual)
    const parseDeleteFrameCommand = (text) => {
      if (!text) return null;
      const s = String(text).toLowerCase().trim();
      // Multilingual delete/remove verbs
      const deleteVerbs = [
        // English
        "delete",
        "remove",
        "erase",
        "clear",
        // Spanish
        "eliminar",
        "remover",
        "quitar",
        "borrar",
        // Portuguese
        "excluir",
        "remover",
        "apagar",
        // French
        "supprimer",
        "enlever",
        "effacer",
        // German
        "löschen",
        "entfernen",
        "loeschen",
        // Italian
        "elimina",
        "rimuovi",
        "cancella",
        // Hindi
        "हटाओ",
        "हटाएं",
        "मिटाओ",
        "मिटाएं",
        // Japanese
        "削除",
        "消去",
        "消す",
      ];
      const frameNouns = [
        // English
        "frame",
        "frames",
        // Spanish
        "marco",
        "marcos",
        // Portuguese
        "quadro",
        "quadros",
        // French
        "cadre",
        "cadres",
        // German
        "rahmen",
        "rahmens",
        // Italian
        "cornice",
        "cornici",
        // Hindi
        "फ्रेम",
        "फ़्रेम",
        // Japanese
        "フレーム",
      ];

      const verbRe = new RegExp(
        `\\b(${deleteVerbs
          .map((v) => v.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"))
          .join("|")})\\b`,
        "i"
      );
      const nounRe = new RegExp(
        `\\b(${frameNouns
          .map((v) => v.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"))
          .join("|")})\\b`,
        "i"
      );

      const hasDelete = verbRe.test(s);
      // Accept "frame" or common mishearing "from" when followed by a target
      const hasFrameToken = nounRe.test(s);
      const hasFromTarget = /\bfrom\b\s+([a-z0-9\-\s]+)/.test(s);
      if (!hasDelete || !(hasFrameToken || hasFromTarget)) return null;
      // Dynamically convert number words/ordinals to digits so
      // "frame twenty one" -> "frame 21", "third" -> "3", etc.
      const normalizeNumberWords = (input) => {
        if (!input) return input;
        const text = String(input)
          .toLowerCase()
          .replace(/-/g, " ")
          .replace(/\band\b/g, " ");
        const units = {
          zero: 0,
          one: 1,
          two: 2,
          three: 3,
          four: 4,
          five: 5,
          six: 6,
          seven: 7,
          eight: 8,
          nine: 9,
          ten: 10,
          eleven: 11,
          twelve: 12,
          thirteen: 13,
          fourteen: 14,
          fifteen: 15,
          sixteen: 16,
          seventeen: 17,
          eighteen: 18,
          nineteen: 19,
        };
        const tens = {
          twenty: 20,
          thirty: 30,
          forty: 40,
          fifty: 50,
          sixty: 60,
          seventy: 70,
          eighty: 80,
          ninety: 90,
        };
        const unitOrdinals = {
          first: 1,
          second: 2,
          third: 3,
          fourth: 4,
          fifth: 5,
          sixth: 6,
          seventh: 7,
          eighth: 8,
          ninth: 9,
          tenth: 10,
          eleventh: 11,
          twelfth: 12,
          thirteenth: 13,
          fourteenth: 14,
          fifteenth: 15,
          sixteenth: 16,
          seventeenth: 17,
          eighteenth: 18,
          nineteenth: 19,
        };
        const tensOrdinals = {
          twentieth: 20,
          thirtieth: 30,
          fortieth: 40,
          fiftieth: 50,
          sixtieth: 60,
          seventieth: 70,
          eightieth: 80,
          ninetieth: 90,
        };
        const scales = { hundred: 100, thousand: 1000, million: 1000000 };

        const isNumberWord = (w) =>
          units[w] != null ||
          tens[w] != null ||
          unitOrdinals[w] != null ||
          tensOrdinals[w] != null ||
          scales[w] != null ||
          w === "and";

        const tokens = text.split(/\s+/).filter(Boolean);
        let bestStart = -1,
          bestEnd = -1;
        // Find the last contiguous number-word sequence to convert
        for (let i = 0; i < tokens.length; i++) {
          if (!isNumberWord(tokens[i])) continue;
          let j = i;
          while (j < tokens.length && isNumberWord(tokens[j])) j++;
          bestStart = i;
          bestEnd = j - 1;
          i = j - 1;
        }
        if (bestStart === -1) return input; // nothing to convert

        const seq = tokens.slice(bestStart, bestEnd + 1);
        // Parse the sequence into a number
        let result = 0;
        let current = 0;
        for (const w of seq) {
          if (units[w] != null) current += units[w];
          else if (tens[w] != null) current += tens[w];
          else if (unitOrdinals[w] != null) current += unitOrdinals[w];
          else if (tensOrdinals[w] != null) current += tensOrdinals[w];
          else if (scales[w] != null) {
            const scale = scales[w];
            if (scale === 100) {
              current = current === 0 ? 100 : current * 100;
            } else {
              current = current === 0 ? scale : current * scale;
              result += current;
              current = 0;
            }
          } else if (w === "and") {
            // ignore
          }
        }
        result += current;
        const numberStr = String(result);
        // Replace the sequence with the computed number
        const outTokens = tokens.slice();
        outTokens.splice(bestStart, bestEnd - bestStart + 1, numberStr);
        return outTokens.join(" ");
      };
      // Try to extract an explicit name when present
      let name = null;
      const byName = s.match(
        /frame[s]?\s+(?:named|called)?\s+([a-z0-9\-\s]+)/i
      );
      if (byName && byName[1]) name = normalizeNumberWords(byName[1].trim());
      // Also support patterns like: "remove from NAME" due to ASR mishearing 'frame' as 'from'
      if (!name) {
        const fromName = s.match(/\bfrom\b\s+([a-z0-9\-\s]+)/i);
        if (fromName && fromName[1]) {
          name = normalizeNumberWords(fromName[1].trim());
        }
      }
      // Handle ordering like: "frame NAME remove" by grabbing text between noun and the delete verb
      if (!name) {
        const frameRe = nounRe;
        const deleteRe = verbRe;
        const fMatch = frameRe.exec(s);
        const dMatch = deleteRe.exec(s);
        if (fMatch && dMatch) {
          if (fMatch.index < dMatch.index) {
            const between = s
              .slice(fMatch.index + fMatch[0].length, dMatch.index)
              .replace(/["'“”‘’]/g, "")
              .trim();
            if (between) name = normalizeNumberWords(between);
          } else {
            // Also support: "remove/delete frame NAME"
            const after = s
              .slice(fMatch.index + fMatch[0].length)
              .replace(deleteRe, "")
              .replace(/["'“”‘’]/g, "")
              .trim();
            if (after) name = normalizeNumberWords(after);
          }
        }
      }
      const quoted = s.match(/["'“”‘’]([^"'“”‘’]+)["'“”‘’]/);
      if (!name && quoted && quoted[1])
        name = normalizeNumberWords(quoted[1].trim());
      return {
        action: "deleteFrameByName",
        payload: {
          originalCommand: text,
          name: name || null,
        },
      };
    };

    const delParsed = parseDeleteFrameCommand(originalCommand);
    if (delParsed) {
      const ok = await awaitReply(delParsed.action, delParsed.payload);
      return ok
        ? { success: true, message: "Frame(s) deleted." }
        : { success: false, message: "No matching frame found to delete." };
    }

    // Helper: extract multiple shapes from a sentence (multilingual)
    const extractShapesFromSentence = (str) => {
      if (!str) return null;
      const sLower = String(str).toLowerCase();
      const shapeSynonyms = [
        {
          re: /\b(rectangle|square|rect(?:angle|engle)?|rect\s+angle|erect\s+angle|rectángulo|rectangulo|cuadrado|retângulo|retangulo|quadrado|carré|rechteck|quadrat|rettangolo|quadrato|長方形|四角形|正方形|आयत|आयताकार|वर्ग)\b/g,
          shape: "rectangle",
        },
        {
          re: /\b(diamond|rhombus|diamante|rombo|losango|losange|raute|ひし形|菱形|हीरा)\b/g,
          shape: "diamond",
        },
        {
          re: /\b(ellipse|circle|round|oval|círculo|circulo|elipse|cercle|rond|kreis|rund|cerchio|ellisse|円|楕円|वृत्त|गोल|अंडाकार)\b/g,
          shape: "ellipse",
        },
        {
          re: /\b(arrow|flecha|seta|flèche|pfeil|freccia|矢印|तीर)\b/g,
          shape: "arrow",
        },
        {
          re: /\b(line|línea|linea|linha|ligne|linie|線|रेखा)\b/g,
          shape: "line",
        },
      ];
      const hits = [];
      for (const syn of shapeSynonyms) {
        let m;
        while ((m = syn.re.exec(sLower)) !== null) {
          hits.push({ idx: m.index, shape: syn.shape });
        }
      }
      if (!hits.length) return null;
      hits.sort((a, b) => a.idx - b.idx);
      const seen = new Set();
      const elements = [];
      for (const h of hits) {
        if (seen.has(h.shape)) continue;
        seen.add(h.shape);
        elements.push(h.shape);
      }
      return elements.length ? elements : null;
    };

    const parsed = parseDrawCommand(originalCommand);
    if (parsed) {
      // Always include the raw command so the iframe can parse multi-shape intents
      // like "draw rectangle circle diamond" and handle synonyms/misspellings.
      const payloadWithText = { ...parsed.payload, originalCommand };
      // If the sentence mentions multiple shapes, proactively send them one-by-one
      // BUT ONLY when this is NOT a frame intent. For frame intents, we attach shapes as elements inside the frame.
      const shapes = extractShapesFromSentence(originalCommand);
      const hasFrameNoun =
        /\b(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)\b/.test(
          String(originalCommand).toLowerCase()
        );
      const isFrameIntent = parsed.action === "drawFrame" || hasFrameNoun;
      if (shapes && shapes.length > 1 && !isFrameIntent) {
        let anySent = false;
        for (const sh of shapes) {
          const okEach = postToWhiteboard("drawShape", {
            shape: sh,
            originalCommand,
          });
          anySent = anySent || !!okEach;
        }
        return anySent
          ? {
              success: true,
              message: `Whiteboard: drew ${shapes.length} shapes.`,
            }
          : { success: false, message: "Whiteboard not available" };
      }
      // For clear, wait for explicit reply from iframe so success shows after completion
      if (parsed.action === "clear") {
        return await new Promise((resolve) => {
          const doAction = "clear";
          const timeout = setTimeout(() => {
            window.removeEventListener("message", onMessage);
            console.warn(`[VOICE->WB] ${doAction} timeout after 30 seconds`);
            resolve({ success: false, message: "Failed to clear canvas." });
          }, 30000);
          const onMessage = (e) => {
            const d = e?.data;
            if (!d || d.type !== "acv.whiteboard.reply") return;
            if (d.action !== doAction) return;
            window.removeEventListener("message", onMessage);
            clearTimeout(timeout);
            console.log(`[VOICE->WB] ${doAction} reply received:`, d);
            if (d.handled) {
              resolve({ success: true, message: "Canvas cleared." });
            } else {
              resolve({ success: false, message: "Failed to clear canvas." });
            }
          };
          window.addEventListener("message", onMessage);
          const sent = postToWhiteboard(doAction, payloadWithText);
          if (!sent) {
            clearTimeout(timeout);
            window.removeEventListener("message", onMessage);
            console.warn(
              `[VOICE->WB] Failed to send ${doAction} - iframe not found`
            );
            resolve({ success: false, message: "Whiteboard not available" });
          }
        });
      }
      const ok = postToWhiteboard(parsed.action, payloadWithText);
      return ok
        ? { success: true, message: `Whiteboard: ${parsed.action}` }
        : { success: false, message: "Whiteboard not available" };
    }

    // If no single-shape parse, try multi-shape extraction.
    // If a frame noun is present, create a frame and attach the extracted shapes as elements.
    const shapesFallback = extractShapesFromSentence(originalCommand);
    if (shapesFallback && shapesFallback.length) {
      const hasFrameNoun =
        /\b(frame|marco|quadro|moldura|cadre|rahmen|cornice|फ्रेम|फ़्रेम|フレーム|枠)\b/.test(
          String(originalCommand).toLowerCase()
        );
      if (hasFrameNoun) {
        const elements = shapesFallback.map((shape) => ({ shape }));
        const ok = postToWhiteboard("drawFrame", {
          type: "frame",
          elements,
          originalCommand,
        });
        return ok
          ? { success: true, message: "Whiteboard: drawFrame with elements" }
          : { success: false, message: "Whiteboard not available" };
      }
      let anySent = false;
      for (const sh of shapesFallback) {
        const okEach = postToWhiteboard("drawShape", {
          shape: sh,
          originalCommand,
        });
        anySent = anySent || !!okEach;
      }
      return anySent
        ? {
            success: true,
            message: `Whiteboard: drew ${shapesFallback.length} shapes.`,
          }
        : { success: false, message: "Whiteboard not available" };
    }

    const lessonParsed = parseLessonPlanCommand(originalCommand);
    if (lessonParsed) {
      // Directly wait for whiteboard to generate the lesson; modal shows progress
      const ok = await awaitReply(lessonParsed.action, lessonParsed.payload);
      return ok
        ? { success: true, message: "Lesson plan inserted." }
        : { success: false, message: "Failed to generate lesson plan." };
    }

    // Try diagram commands next (Mermaid-based charts)
    const parseDiagramCommand = (text) => {
      if (!text) return null;
      const s = String(text).toLowerCase().trim();
      // Local language detector (same mapping used for lesson plans)
      const detectExplicitLanguageLocal = (str) => {
        const map = {
          // English mentions
          english: "en",
          spanish: "es",
          portuguese: "pt",
          french: "fr",
          german: "de",
          hindi: "hi",
          italian: "it",
          japanese: "ja",
          // Spanish mentions
          español: "es",
          portugués: "pt",
          francés: "fr",
          alemán: "de",
          hindi: "hi",
          italiano: "it",
          japonés: "ja",
          inglés: "en",
          // Portuguese mentions
          português: "pt",
          espanhol: "es",
          francês: "fr",
          alemão: "de",
          inglês: "en",
          // French mentions
          français: "fr",
          espagnol: "es",
          portugais: "pt",
          allemand: "de",
          anglais: "en",
          // German mentions
          deutsch: "de",
          englisch: "en",
          französisch: "fr",
          spanisch: "es",
          portugiesisch: "pt",
          // Hindi mentions (Devanagari and transliterations)
          हिंदी: "hi",
          अंग्रेज़ी: "en",
          स्पेनिश: "es",
          // Italian mentions
          italiano: "it",
          inglese: "en",
          spagnolo: "es",
          // Japanese mentions
          日本語: "ja",
          英語: "en",
        };
        const prepositions = [
          "in",
          "en",
          "em",
          "auf",
          "में",
          "de",
          "por",
          "para",
        ];
        for (const [name, code] of Object.entries(map)) {
          const direct = str.includes(name);
          const withPrep = prepositions.some((p) =>
            str.includes(`${p} ${name}`)
          );
          if (direct || withPrep) return code;
        }
        return null;
      };
      const explicitLang = detectExplicitLanguageLocal(s);
      const langCode =
        explicitLang || getLanguageCode(this.state?.currentLanguage || "en");

      // Supported diagram type keywords mapped to Mermaid starters
      const types = [
        ["flowchart", "flowchart TD"],
        ["sequence diagram", "sequenceDiagram"],
        ["sequence", "sequenceDiagram"],
        ["class diagram", "classDiagram"],
        ["class", "classDiagram"],
        ["mindmap", "mindmap"],
        ["timeline", "timeline"],
        ["pie chart", "pie"],
        ["pie", "pie"],
        // Multilingual chart synonyms
        ["gráfico de pastel", "pie"],
        ["gráfico circular", "pie"],
        ["grafico a torta", "pie"],
        ["kreisdiagramm", "pie"],
        ["diagramme en secteurs", "pie"],
        ["camembert", "pie"],
        ["円グラフ", "pie"],
        ["bar chart", "bar"],
        ["gráfico de barras", "bar"],
        ["grafico a barre", "bar"],
        ["balkendiagramm", "bar"],
        ["diagramme en barres", "bar"],
        ["棒グラフ", "bar"],
        ["line chart", "line"],
        ["gráfico de líneas", "line"],
        ["grafico a linee", "line"],
        ["liniendiagramm", "line"],
        ["diagramme linéaire", "line"],
        ["折れ線グラフ", "line"],
        ["gantt chart", "gantt"],
        ["gantt", "gantt"],
        ["state diagram", "stateDiagram"],
        ["state", "stateDiagram"],
        ["entity relationship diagram", "erDiagram"],
        ["er diagram", "erDiagram"],
        ["journey diagram", "journey"],
        ["journey", "journey"],
        ["git graph", "gitGraph"],
        ["gitgraph", "gitGraph"],
      ];

      const verbs = [
        "create",
        "generate",
        "make",
        "build",
        "draw",
        "design",
        // Spanish
        "crear",
        "generar",
        "hacer",
        "dibujar",
        "diseñar",
        // Portuguese
        "criar",
        "gerar",
        "fazer",
        "desenhar",
        "projetar",
        // French
        "créer",
        "générer",
        "faire",
        "dessiner",
        "concevoir",
        // German
        "erstellen",
        "generieren",
        "machen",
        "zeichnen",
        "entwerfen",
        // Hindi
        "बनाओ",
        "बनाना",
        "तैयार",
        "चित्र बनाओ",
        "डिज़ाइन",
        // Italian
        "crea",
        "generare",
        "fare",
        "disegnare",
        "progettare",
        // Japanese
        "作成",
        "生成",
        "作る",
        "描く",
        "設計",
      ];

      // Find a mentioned diagram type in the string
      const matched = types.find(([name]) => s.includes(name));
      const typeName = matched ? matched[0] : null;
      const starter = matched ? matched[1] : null;

      // Require an explicit diagram keyword or type mention to avoid false positives
      const hasVerb = verbs.some((v) => s.includes(v));
      const hasDiagramWord =
        /\b(diagram|chart|graph|diagrama|gráfico|gráfica|diagramme|graphique|diagramm|grafik|आरेख|चार्ट|ग्राफ|diagramma|grafico|ダイアグラム|チャート|グラフ)\b/.test(
          s
        );
      const mentionsDiagram = hasDiagramWord || !!matched;
      if (!mentionsDiagram) {
        // No diagram keywords or known types found; do not treat as diagram request
        return null;
      }

      // Decide starter: use the matched type if present, otherwise default to flowchart
      const finalStarter = starter || "flowchart TD";

      // Extract topic after the type or common connectors
      let topic = s;
      if (matched && typeName) {
        const idx = s.indexOf(typeName);
        topic = s.slice(idx + typeName.length);
      }
      topic = topic.replace(/^(diagram|chart|graph)\b/, "").trim();
      topic = topic
        .replace(
          /^(for|about|on|de|para|sobre|con|pour|sur|für|über|के बारे में|पर|で|について|の)\s+/i,
          ""
        )
        .trim();
      // If topic ended up empty, use original input
      if (!topic) {
        topic = String(text).trim();
      }

      return {
        action: "generateDiagram",
        payload: { query: topic, type: finalStarter, language: langCode },
      };
    };

    const diagramParsed = /\blesson\b/i.test(originalCommand || "")
      ? null
      : parseDiagramCommand(originalCommand);
    if (diagramParsed) {
      const ok = await awaitReply(diagramParsed.action, diagramParsed.payload);
      return ok
        ? { success: true, message: "Diagram inserted." }
        : { success: false, message: "Failed to generate diagram." };
    }

    // Check if user is responding to a collection prompt
    // This MUST be checked BEFORE parsing new commands to avoid conflicts
    const normalizedCommand = String(originalCommand || "")
      .toLowerCase()
      .trim();

    // Check if this is a response to a pending collection prompt
    if (this.pendingCollectionPrompt) {
      // Check for collection response patterns
      const isCollectionResponse =
        /^(yes|collection|from collection|use collection|add from collection|use it|add it|from the collection|i want from collection|want from collection)$/i.test(
          normalizedCommand
        ) ||
        /(?:i\s+)?(?:want|need|get|use|add|put|show|bring)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
          normalizedCommand
        ) ||
        /(?:use|get|add|put|show)\s+(?:it\s+)?(?:from\s+)?(?:the\s+)?collection/i.test(
          normalizedCommand
        );

      const isDrawResponse =
        /^(no|draw|free draw|draw it|sketch|draw manually|draw it manually)$/i.test(
          normalizedCommand
        ) ||
        /(?:draw|sketch|create)\s+(?:it|manually|by hand)/i.test(
          normalizedCommand
        );

      if (isCollectionResponse || isDrawResponse) {
        console.log("[VOICE-DEBUG] User responding to collection prompt:", {
          isCollectionResponse,
          isDrawResponse,
          command: normalizedCommand,
        });
        const pending = this.pendingCollectionPrompt;
        this.pendingCollectionPrompt = null; // Clear the pending prompt

        if (isCollectionResponse && pending.collectionMatch) {
          // User wants to use collection - add it to canvas
          const { collection, file } = pending.collectionMatch;

          console.log("[VOICE-DEBUG] Adding collection item to canvas:", {
            collectionName: collection.name,
            fileUrl: file.url,
          });

          // Send collection file to whiteboard
          const ok = postToWhiteboard("addCollectionItem", {
            fileUrl: file.url,
            collectionId: collection.id,
            collectionName: collection.name,
            fileName: file.id,
          });

          if (ok) {
            toast.success(`Added ${pending.itemName} from collection`);
            console.log(
              "[VOICE-DEBUG] Successfully sent addCollectionItem to whiteboard"
            );
            return {
              success: true,
              message: `Added ${pending.itemName} from collection to canvas`,
            };
          } else {
            console.error(
              "[VOICE-DEBUG] Failed to send addCollectionItem - whiteboard not available"
            );
            return { success: false, message: "Whiteboard not available" };
          }
        } else if (isDrawResponse) {
          // User wants to draw - proceed with free draw
          console.log(
            "[VOICE-DEBUG] User wants to draw, starting free draw for:",
            pending.itemName
          );
          const ok = postToWhiteboard("freedraw", {
            description: pending.itemName,
            type: "freedraw",
          });
          return ok
            ? {
                success: true,
                message: `Whiteboard: Starting free draw - ${pending.itemName}`,
              }
            : { success: false, message: "Whiteboard not available" };
        }
      } else {
        // Not a recognized response, but we have a pending prompt
        // Clear it and continue with normal command processing
        console.log(
          "[VOICE-DEBUG] Unrecognized response to collection prompt, clearing prompt and continuing"
        );
        this.pendingCollectionPrompt = null;
      }
    }

    // Then try free draw commands
    const freeDrawParsed = /\blesson\b/i.test(originalCommand || "")
      ? null
      : parseFreeDrawCommand(originalCommand);

    // If originalCommand is null but we have a command object, try to extract description from it
    if (!freeDrawParsed && !originalCommand && command) {
      const fallbackParsed = parseFreeDrawCommand(JSON.stringify(command));
      if (fallbackParsed) {
        const ok = postToWhiteboard(
          fallbackParsed.action,
          fallbackParsed.payload
        );
        return ok
          ? {
              success: true,
              message: `Whiteboard: Starting free draw - ${fallbackParsed.payload.description}`,
            }
          : { success: false, message: "Whiteboard not available" };
      }
    }

    if (freeDrawParsed) {
      const itemName = freeDrawParsed.payload.description;
      const originalText = String(originalCommand || "")
        .toLowerCase()
        .trim();

      console.log(
        "[VOICE-DEBUG] freeDrawParsed found, itemName:",
        itemName,
        "originalText:",
        originalText
      );

      // Check if user explicitly mentioned "from collection" or "collection" in the command
      const wantsCollectionDirectly =
        /(?:from|in|use|get|add|show)\s+(?:the\s+)?(?:collection|collections)/i.test(
          originalText
        );

      console.log("[VOICE-DEBUG] Searching collections for:", itemName);
      // Before executing free draw, check if item exists in collections
      // Also try searching without "the" if it starts with "the"
      let searchTerms = [itemName];
      if (itemName.toLowerCase().startsWith("the ")) {
        searchTerms.push(itemName.substring(4).trim());
      }

      let collectionMatch = null;
      for (const searchTerm of searchTerms) {
        collectionMatch = await searchCollections(searchTerm);
        if (collectionMatch) break;
      }

      console.log("[VOICE-DEBUG] Collection match result:", collectionMatch);

      if (collectionMatch) {
        const { collection, file, matchedTitle, matchScore } = collectionMatch;
        try {
          // Use collection.source directly to fetch the ACV JSON with libraryItems
          const acvUrl = (collection?.source || "").toString();
          if (!acvUrl) throw new Error("Missing collection source");

          const res = await fetch(acvUrl);
          if (!res.ok)
            throw new Error(
              `Failed to fetch collection source (${res.status})`
            );
          const json = await res.json();
          const items = Array.isArray(json?.libraryItems)
            ? json.libraryItems
            : [];

          // Normalize, stem, and score matches without static word lists
          const normalize = (s) =>
            (s || "")
              .toString()
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, " ")
              .trim();
          const stemWord = (w) => {
            if (!w) return w;
            let x = w.replace(/ies$/i, "y");
            x = x.replace(/(ing|ed|es|s)$/i, "");
            return x.length >= 2 ? x : w;
          };
          const tokenize = (s) =>
            normalize(s).split(/\s+/).filter(Boolean).map(stemWord);
          const joinTokens = (arr) => arr.join(" ");
          const levenshtein = (a, b) => {
            const m = a.length,
              n = b.length;
            if (m === 0) return n;
            if (n === 0) return m;
            const dp = Array(n + 1);
            for (let j = 0; j <= n; j++) dp[j] = j;
            for (let i = 1; i <= m; i++) {
              let prev = dp[0];
              dp[0] = i;
              for (let j = 1; j <= n; j++) {
                const temp = dp[j];
                dp[j] = Math.min(
                  dp[j] + 1,
                  dp[j - 1] + 1,
                  prev + (a[i - 1] === b[j - 1] ? 0 : 1)
                );
                prev = temp;
              }
            }
            return dp[n];
          };

          // If user asked for the whole collection by name, add ALL items' elements
          const requestedRaw = (itemName || matchedTitle || "").toString();
          // Loosen whole-collection detection: allow pluralization, near-equality, and phrases like
          // "library", "pack", "collection", "bundle", "set", "kit", or "whole/all".
          const reqStem = joinTokens(tokenize(requestedRaw));
          const nameStem = joinTokens(tokenize(collection?.name || ""));
          const hasLibraryWord =
            /(\b(all|entire|full|whole)\b|\b(library|collection|pack|bundle|set|kit)s?\b)/i.test(
              requestedRaw
            );
          const nearEqual =
            reqStem === nameStem ||
            reqStem.startsWith(nameStem) ||
            nameStem.startsWith(reqStem);
          // Token-overlap coverage to tolerate minor differences
          const tokenOverlapCoverage = (() => {
            const reqTokens = tokenize(requestedRaw);
            const nameTokens = tokenize(collection?.name || "");
            if (!reqTokens.length || !nameTokens.length) return 0;
            const reqSet = new Set(reqTokens);
            let overlap = 0;
            for (const t of nameTokens) {
              if (reqSet.has(t)) overlap++;
            }
            const covReq = overlap / reqTokens.length;
            const covName = overlap / nameTokens.length;
            return Math.max(covReq, covName);
          })();
          const askedForWholeCollection = hasLibraryWord
            ? nearEqual || tokenOverlapCoverage >= 0.7
            : nearEqual;
          if (askedForWholeCollection && items.length) {
            let added = 0;
            const allNeededIds = new Set();
            items.forEach((it) => {
              if (Array.isArray(it?.elements)) {
                it.elements.forEach((el) => {
                  const id = el && typeof el === "object" ? el.fileId : null;
                  if (id) allNeededIds.add(id);
                });
              }
            });
            const filesFromCollectionAll = (
              Array.isArray(collection.files) ? collection.files : []
            )
              .filter((f) => allNeededIds.has(f.id))
              .map((f) => ({
                id: f.id,
                url: (f.url || "").toString(),
                mimeType: f.mimeType,
                created: f.created,
                isPublished: !!f.isPublished,
              }));

            for (const it of items) {
              if (Array.isArray(it?.elements) && it.elements.length) {
                const okEach = postToWhiteboard("addLibraryItemElements", {
                  elements: it.elements,
                  filesFromCollection: filesFromCollectionAll,
                  position: "center",
                });
                if (okEach) added++;
              }
            }

            if (added > 0) {
              toast.success(`Added ${added} items from ${collection.name}`);
              return {
                success: true,
                message: `Added ${added} items from ${collection.name} to canvas`,
              };
            }
            // If no element sets available, fall back to inserting ALL files from the collection
            const allFiles = Array.isArray(collection.files)
              ? collection.files
              : [];
            let filesInserted = 0;
            for (const f of allFiles) {
              const okFile = postToWhiteboard("addCollectionItem", {
                fileUrl: f.url,
                collectionId: collection.id,
                collectionName: collection.name,
                fileName: f.id,
              });
              if (okFile) filesInserted++;
            }
            if (filesInserted > 0) {
              toast.info(
                `Collection has no element sets; inserted ${filesInserted} file(s) from ${collection.name}`
              );
              return {
                success: true,
                message: `Inserted ${filesInserted} file(s) from ${collection.name}`,
              };
            }
            toast.error("Whiteboard not available");
            return { success: false, message: "Whiteboard not available" };
          }

          // Prioritize user-spoken itemName over backend matchedTitle
          const targetRaw = (itemName || matchedTitle || "").toString();
          const targetTokens = tokenize(targetRaw);
          const targetStemStr = joinTokens(targetTokens);
          const words = targetTokens;
          const scoreName = (candidateRaw) => {
            const candTokens = tokenize(candidateRaw);
            if (!candTokens.length) return 0;
            const candStemStr = joinTokens(candTokens);
            if (candStemStr === targetStemStr) return 100;
            if (
              candStemStr.replace(/\s+/g, "") ===
              targetStemStr.replace(/\s+/g, "")
            )
              return 98;
            if (candStemStr.startsWith(targetStemStr)) return 92;
            if (
              candStemStr.includes(targetStemStr) ||
              targetStemStr.includes(candStemStr)
            )
              return 90;

            // Token overlap allowing small edit differences
            const targetSet = new Set(targetTokens);
            let overlap = 0;
            for (const t of candTokens) {
              if (targetSet.has(t)) {
                overlap++;
              } else {
                const near = targetTokens.some((tw) => levenshtein(t, tw) <= 1);
                if (near) overlap++;
              }
            }
            if (!overlap) return 0;
            const coverageTarget = overlap / targetTokens.length;
            const coverageCand = overlap / candTokens.length;
            let score = Math.round(
              100 * Math.max(coverageTarget, coverageCand)
            );
            score = Math.min(score, 95);
            const edit = levenshtein(candStemStr, targetStemStr);
            if (edit <= 2) score = Math.max(score, 88);
            return score;
          };

          let bestItem = null;
          let bestScore = -1;
          for (const it of items) {
            const nm = it?.name || it?.title || "";
            const s = scoreName(nm);
            if (s > bestScore) {
              bestScore = s;
              bestItem = it;
            }
          }

          // If backend provided matchedTitle with high confidence, prefer that item if found
          if (matchedTitle) {
            const direct = items.find(
              (it) =>
                normalize(it?.name || it?.title) === normalize(matchedTitle)
            );
            if (direct && (matchScore ?? 0) >= 90) {
              bestItem = direct;
              bestScore = 100;
            }
          }

          // Require strong match (exact or high similarity)
          const MIN_ACCEPT_SCORE = 85;
          if (
            bestItem &&
            bestScore >= MIN_ACCEPT_SCORE &&
            Array.isArray(bestItem.elements) &&
            bestItem.elements.length
          ) {
            // Build files mapping for elements' fileIds using collection.files
            const neededIds = new Set(
              bestItem.elements
                .map((el) => (el && typeof el === "object" ? el.fileId : null))
                .filter(Boolean)
            );
            const filesFromCollection = (
              Array.isArray(collection.files) ? collection.files : []
            )
              .filter((f) => neededIds.has(f.id))
              .map((f) => ({
                id: f.id,
                url: (f.url || "").toString(),
                mimeType: f.mimeType,
                created: f.created,
                isPublished: !!f.isPublished,
              }));

            const ok = postToWhiteboard("addLibraryItemElements", {
              elements: bestItem.elements,
              filesFromCollection,
              position: "center",
            });

            if (ok) {
              toast.success(
                `Added ${
                  matchedTitle || bestItem?.name || itemName
                } from collection`
              );
              return {
                success: true,
                message: `Added ${
                  matchedTitle || bestItem?.name || itemName
                } from collection to canvas`,
              };
            }
            throw new Error("Whiteboard not available");
          }

          // Fallback: if a strong element match not found, insert the matched file as image
          const okFallback = postToWhiteboard("addCollectionItem", {
            fileUrl: file.url,
            collectionId: collection.id,
            collectionName: collection.name,
            fileName: file.id,
          });
          if (okFallback) {
            toast.success(`Added ${matchedTitle || itemName} from collection`);
            return {
              success: true,
              message: `Added ${
                matchedTitle || itemName
              } from collection to canvas`,
            };
          }
          return { success: false, message: "Whiteboard not available" };
        } catch (err) {
          console.error(
            "[VOICE-ERROR] add by elements failed, fallback to image:",
            err
          );
          const ok = postToWhiteboard("addCollectionItem", {
            fileUrl: file.url,
            collectionId: collection.id,
            collectionName: collection.name,
            fileName: file.id,
          });
          if (ok) {
            toast.success(`Added ${matchedTitle || itemName} from collection`);
            return {
              success: true,
              message: `Added ${
                matchedTitle || itemName
              } from collection to canvas`,
            };
          }
          return { success: false, message: "Whiteboard not available" };
        }
      }

      // No match found - proceed with free draw
      const ok = postToWhiteboard(
        freeDrawParsed.action,
        freeDrawParsed.payload
      );
      return ok
        ? {
            success: true,
            message: `Whiteboard: Starting free draw - ${freeDrawParsed.payload.description}`,
          }
        : { success: false, message: "Whiteboard not available" };
    }

    const s = String(originalCommand || "").toLowerCase();
    const looksLikeDrawVerb = /\b(draw|sketch|create|make|dibuja|dibujar|desenhar|dessine|zeichnen|disegna|描いて|描く|बनाओ|बनाएं)\b/.test(s);
    const looksLikeShapeWord = /\b(rectangle|square|rectángulo|rectangulo|cuadrado|retângulo|quadrato|rechteck|circle|ellipse|círculo|circulo|elipse|cercle|kreis|cerchio|ellisse|arrow|flecha|pfeil|freccia|line|línea|linea|linha|text|texto|texte|testo|formula|equation|fórmula|ecuación|équation|gleichung|latex)\b/.test(s);
    if (looksLikeDrawVerb || looksLikeShapeWord) {
      const ok = postToWhiteboard("freedraw", {
        type: "freedraw",
        description: "free drawing",
      });
      if (ok) {
        return {
          success: true,
          message: "Whiteboard: Starting free draw - free drawing",
        };
      }
    }
    return { success: false, message: "Command not recognized. Please try again." };
  };
  // checkForChildren_ = () => {
  //   const workspaceDiv = document.getElementById("my-workspace");
  //   const msg = JSON.parse(localStorage.getItem("msg"));
  //   this.props.getDb();
  //   if (
  //     workspaceDiv &&
  //     workspaceDiv.children.length > 0 &&
  //     !msg.isOpenWorkSpace
  //   ) {
  //     this.setState({ isMyWorkSpace: true, isReloadingWorkspace: false });
  //     localStorage.setItem(
  //       "msg",
  //       JSON.stringify({
  //         ...msg,
  //         isOpenWorkSpace: true,
  //         isReloadingWorkspace: false,
  //         access_token: this.props.user.accessToken,
  //         user: this.props.user,
  //         i18nextLng: localStorage.getItem("i18nextLng"),
  //       })
  //     );
  //   } else {
  //     this.setState({ isMyWorkSpace: false });
  //     localStorage.setItem(
  //       "msg",
  //       JSON.stringify({
  //         ...msg,
  //         isOpenWorkSpace: false,
  //         isReloadingWorkspace: false,
  //         access_token: this.props.user.accessToken,
  //         user: this.props.user,
  //         i18nextLng: localStorage.getItem("i18nextLng"),
  //       })
  //     );
  //   }
  // };

  checkForChildren_ = () => {
    const workspaceDiv = document.getElementById("my-workspace");
    const msg = JSON.parse(localStorage.getItem("msg"));
    this.props.getDb();
    if (workspaceDiv && workspaceDiv.children.length > 0) {
      this.setState({
        isReloadingWorkspace: this.state.mutationObserverWithWorkspace
          ? true
          : false,
      });
      localStorage.setItem(
        "msg",
        JSON.stringify({
          ...msg,
          isOpenWorkSpace: true,
          isReloadingWorkspace: this.state.mutationObserverWithWorkspace
            ? true
            : false,
          access_token: this.props.user.accessToken,
          user: this.props.user,
          i18nextLng: localStorage.getItem("i18nextLng"),
        })
      );
    } else {
      this.setState({ isReloadingWorkspace: false });
      localStorage.setItem(
        "msg",
        JSON.stringify({
          ...msg,
          isOpenWorkSpace: false,
          isReloadingWorkspace: false,
          access_token: this.props.user.accessToken,
          user: this.props.user,
          i18nextLng: localStorage.getItem("i18nextLng"),
        })
      );
    }
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (
      this.props.user.slug === "?slug=acvpreprod" ||
      this.props.user.slug === "?slug=acvapp"
    ) {
      if (prevState.selectedDate !== this.state.selectedDate) {
        const wiseDay = this.state?.getSelectedData?.getDay();
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        this.setState({ selectedDay: days[wiseDay] });
      }
    }

    if (prevProps.user.slug !== this.props.user.slug) {
      await this.fetchLessons();
    }

    if (prevProps.i18n.language !== prevState.currentLanguage) {
      this.setState({
        ...this.state,
        currentLanguage: this.props.i18n.language,
      });
    }

    if (
      prevState.isLoading !== this.state.isLoading ||
      prevState.isImageUploading !== this.state.isImageUploading ||
      prevState.currentLsn !== this.state.currentLsn
    ) {
      this.handleChangeLsn();
    }

    if (prevState.isFullscreen !== this.state.isFullscreen) {
      if (this.state.isFullscreen) {
        this.setState({
          ...this.state,
          isCompactMode: true,
        });
      }
    }
    if (prevState.selectedLesson !== this.state.selectedLesson) {
      if (this.state.selectedLesson) {
        this.setState({
          ...this.state,
          isCompactMode: true,
        });
      }
    }
  };

  bindEvent = (element, eventName, eventHandler) => {
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
      element.attachEvent("on" + eventName, eventHandler);
    }
  };

  sendMessage = (msg) => {
    localStorage.setItem("msg", JSON.stringify(msg));
    const iframeEl = document.getElementsByClassName("frameTag");
    // Make sure you are sending a string, and to stringify JSON
    iframeEl[0]?.contentWindow?.postMessage(
      {
        source: "whiteboard",
        message: msg,
      },
      process.env.REACT_APP_EP_WHITEBOARD
    );
  };

  sendWhiteboardCommand = (action, payload = {}) => {
    const iframe = document.querySelector("iframe.frameTag");
    if (!iframe || !iframe.contentWindow) return false;
    iframe.contentWindow.postMessage(
      { type: "acv.whiteboard.command", action, payload },
      "*"
    );
    return true;
  };

  awaitWhiteboardReply = (action, payload = {}, timeoutMs = 7000) => {
    return new Promise((resolve) => {
      const onMessage = (e) => {
        const d = e?.data;
        if (!d || d.type !== "acv.whiteboard.reply") return;
        if (d.action !== action) return;
        window.removeEventListener("message", onMessage);
        clearTimeout(timer);
        resolve(!!d.handled);
      };
      const timer = setTimeout(() => {
        window.removeEventListener("message", onMessage);
        resolve(false);
      }, timeoutMs);
      window.addEventListener("message", onMessage);
      const sent = this.sendWhiteboardCommand(action, payload);
      if (!sent) {
        clearTimeout(timer);
        window.removeEventListener("message", onMessage);
        resolve(false);
      }
    });
  };

  generateSpinnerImageToCanvas = async (segments, size = 600) => {
    const segs = Array.isArray(segments) ? segments : [];
    if (!segs.length) {
      toast.error("Spinner needs at least one segment.");
      return { success: false, message: "No segments provided" };
    }
    const ok = await this.awaitWhiteboardReply("generateSpinnerImageToCanvas", {
      segments: segs,
      size,
    });
    if (ok) {
      return { success: true, message: "Spinner image added to canvas" };
    }
    toast.error("Failed to generate spinner image.");
    return { success: false, message: "Spinner image generation failed" };
  };

  // --- Spin Wheel (AI topics) helpers ---
  openSpinWheelDialogWith = (topicCandidate = "", autoGenerate = false) => {
    this.setState(
      {
        isSpinWheelDialogOpen: true,
        spinWheelTopic: topicCandidate || this.state.spinWheelTopic || "",
        spinWheelError: "",
      },
      () => {
        if (autoGenerate && topicCandidate) {
          // Generate immediately after state is applied to avoid race conditions
          this.generateSpinWheelTopicsAI(topicCandidate);
        }
      }
    );
  };

  closeSpinWheelDialog = () => {
    this.setState({ isSpinWheelDialogOpen: false, spinWheelError: "" });
  };

  generateSpinWheelTopicsAI = async (subjectOverride = "") => {
    const subject = (subjectOverride || this.state.spinWheelTopic || "").trim();
    const limit = Number(this.state.spinWheelLimit) || 8;
    if (!subject) {
      this.setState({ spinWheelError: "Please enter a topic/subject." });
      return;
    }
    this.setState({ isGeneratingSpinWheelTopics: true, spinWheelError: "" });
    try {
      window.dispatchEvent(
        new CustomEvent("ACV_SPINWHEEL_STATUS", {
          detail: { status: "generating" },
        })
      );
    } catch (e) {}
    try {
      // Build prompt and params per wb endpoint requirements
      const languageCode = this.state?.currentLanguage
        ? String(this.state.currentLanguage).split("-")[0].toLowerCase()
        : "en";
      const languageMap = {
        en: "English",
        es: "Spanish",
        pt: "Portuguese",
        fr: "French",
        de: "German",
        it: "Italian",
        ja: "Japanese",
        hi: "Hindi",
      };
      const language = languageMap[languageCode] || "English";
      const topicGenerationLimit = limit;
      const promptMessage = `I would like to generate ${topicGenerationLimit} names related to ${subject}, Please give me the ${subject} name. please list the topics in a new line but don't use numbers, bullet points, hyphens or any other special characters. Can you please share content in only ${language} language. Also do not add any additional suggestions, greetings or instructions.`;

      const params = {
        messages: [{ role: "user", content: promptMessage }],
        max_tokens: 2000,
        temperature: 0.7,
        key: topicGenerationLimit > 10 ? 111 : 110,
      };

      const accessToken =
        localStorage.getItem("access_token") ||
        this.props.user?.accessToken ||
        "";
      const base =
        process.env.REACT_APP_ACV_BACKEND_API || process.env.REACT_APP_EP_URL;

      const res = await axios.post(
        `${base}/api/gpt/wb${this.props.user.slug}`,
        params,
        {
          headers: {
            Authorization: accessToken ? `Bearer ${accessToken}` : "",
            "Content-Type": "application/json",
          },
        }
      );

      const article = (res?.data?.data || "").trim();
      let topics = article
        ? article.split("\n").slice(0, topicGenerationLimit)
        : [];
      topics = topics
        .map((topic) => topic.replace(/^\d+\.?\s*|[-•]\s*/g, "").trim())
        .filter(Boolean)
        .slice(0, topicGenerationLimit);
      if (!topics.length) {
        throw new Error("No topics returned by AI.");
      }
      this.setState({ spinWheelSegments: topics });
      // Auto-insert into canvas when invoked via voice auto-generate
      const inserted = await this.generateSpinnerImageToCanvas(topics, 600);
      if (inserted?.success) {
        this.closeSpinWheelDialog();
        try {
          window.dispatchEvent(
            new CustomEvent("ACV_SPINWHEEL_STATUS", {
              detail: { status: "inserted" },
            })
          );
        } catch (e) {}
      } else {
        toast.success("Topics generated. Review and insert into wheel.");
        try {
          window.dispatchEvent(
            new CustomEvent("ACV_SPINWHEEL_STATUS", {
              detail: { status: "generated" },
            })
          );
        } catch (e) {}
      }
    } catch (error) {
      console.error("Spin wheel topics AI error:", error);
      this.setState({
        spinWheelError:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to generate topics.",
      });
      toast.error("Failed to generate topics.");
      try {
        window.dispatchEvent(
          new CustomEvent("ACV_SPINWHEEL_STATUS", {
            detail: { status: "error" },
          })
        );
      } catch (e) {}
    } finally {
      this.setState({ isGeneratingSpinWheelTopics: false });
    }
  };

  handleInsertSpinWheel = async () => {
    const segs = this.state.spinWheelSegments || [];
    if (!segs.length) {
      this.setState({ spinWheelError: "No topics to insert. Generate first." });
      return;
    }
    const ok = await this.generateSpinnerImageToCanvas(segs, 600);
    if (ok?.success) {
      this.closeSpinWheelDialog();
      try {
        window.dispatchEvent(
          new CustomEvent("ACV_SPINWHEEL_STATUS", {
            detail: { status: "inserted" },
          })
        );
      } catch (e) {}
    }
  };

  postCrossDomainMessage = () => {
    const msg = localStorage.getItem("msg");
    const iframeEl = document.getElementsByClassName("frameTag");

    if (this.props.iframeRef.current) {
      this.setupErrorListener();
    }

    // Make sure you are sending a string, and to stringify JSON
    iframeEl[0]?.contentWindow?.postMessage(
      {
        source: "whiteboard",
        message: JSON.parse(msg),
      },
      process.env.REACT_APP_EP_WHITEBOARD
    );
  };

  // Listen to message from child window
  bindEvent = (window, "message", (e) => {}, false);

  storeElementsInDB = (lessonId, page, teacherEmailId, body) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_EP_URL_WHITEBOARD_API}/post-whiteboard-data/${lessonId}/${page}/${teacherEmailId}`,
      headers: {},
      data: JSON.stringify(body),
    };

    axios
      .request(config)
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  refreshIframe = () => {
    const iframe = this.props.iframeRef.current;
    if (iframe) {
      const currentSrc = iframe.src;
      iframe.src = "";
      setTimeout(() => {
        iframe.src = currentSrc + "&v=" + Date.now();
      }, 100);
    }
  };

  // ✅ Function to check if iframe is actually functional
  checkIframeStillRunning = () => {
    const iframe = this.props.iframeRef?.current;

    if (!iframe) return;

    try {
      // Checking if the iframe has changed its URL (indicating it might have reloaded due to failure)
      if (
        iframe.contentWindow &&
        iframe.contentWindow.location.href === "about:blank"
      ) {
        console.error(
          "Iframe content might have failed due to a script error."
        );
        this.refreshIframe();
      }
    } catch (error) {
      console.warn("Cross-origin iframe, unable to check directly.");
    }
  };

  // Add a method to detect errors in the iframe
  setupErrorListener = () => {
    const iframe = this.props.iframeRef.current;

    iframe.addEventListener("error", () => {
      console.error("Iframe failed to load. Possible chunk error.");
      this.refreshIframe();
    });

    iframe.addEventListener("load", () => {
      setTimeout(() => {
        this.checkIframeStillRunning();
      }, 10000);
    });
  };

  async componentDidMount() {
    // Try to set up the error listener after iframe loads

    const wiseDay = this.state?.getSelectedData?.getDay() || v.getDay();
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    this.setState({ selectedDay: days[wiseDay] });

    // Rehydrate last action fallback for undo/redo
    try {
      const savedLast = sessionStorage.getItem("ACV_WHITEBOARD_LAST_ACTION");
      if (savedLast) {
        this.lastAction = JSON.parse(savedLast);
      }
    } catch (e) {}

    const workspaceDiv = document.getElementById("my-workspace");

    if (workspaceDiv) {
      // Create a MutationObserver instance and pass a callback function to handle mutations
      this.mutationObserver = new MutationObserver(this.checkForChildren);

      // Define the observer options
      const config = {
        childList: true, // Observe direct children changes
      };

      // Start observing the workspace div for changes
      this.mutationObserver.observe(workspaceDiv, config);
    }

    window.addEventListener("message", (e) => {
      if (event.data.type === "navigationResponse") {
        if (event.data.canLeave) {
          // Proceed with navigation
          // You may need custom logic here depending on your setup
          window.history.back();
        } else {
          // Stay on current page
          window.history.pushState(null, "", window.location.href);
        }
      }
      if (this.state.currentLsn) {
        if (e?.data?.type === "STORE_ELEMENTS") {
          this.setState({ isLoading: e.data.isLoading });
        }
        if (e?.data?.type === "UPLOAD_IMAGE") {
          this.setState({ isImageUploading: e.data.isLoading });
        }
      }
      if (e?.data?.type === "SHOW_WAITING_DIALOG") {
        this.setState({ isShowWaitingDialog: e.data.isLoading });
      }

      if (e?.data?.type === "EDIT_MODAL") {
        this.setState({ isEditable: e.data.isEditable });
      }
      if (e?.data?.type === "IS_START_COLLABORATION") {
        if (e?.data?.session) {
          const data = [...this.state.activeCollabLinks, e?.data?.lessonId];
          this.setState({ activeCollabLinks: data });
        } else {
          if (
            this.props.user.actualRole === "Student" ||
            this.props.user.actualRole === "Teacher"
          ) {
            this.props.setIsWBFullScreen(false);
          }
          const updatedActivelink = this.state.activeCollabLinks.filter(
            (id) => id !== e?.data?.lessonId
          );
          this.setState({ activeCollabLinks: updatedActivelink });
        }
      }
      if (e?.data?.type === "IS_START_STREAMING") {
        if (e?.data?.session) {
          // If session is true, add the lessonId to the activeStreamLinks
          const data = [...this.state.activeStreamLinks, e?.data?.lessonId];
          this.setState({ activeStreamLinks: data });
        } else {
          this.props.setIsWBFullScreen(false);

          // If session is false, remove the lessonId or reset the list entirely
          const updatedActiveLink = this.state.activeStreamLinks.filter(
            (id) => id !== e?.data?.lessonId
          );

          this.setState({
            activeStreamLinks: updatedActiveLink,
            isConfirmLiveStream: false,
          });
          // if (!this.state.isJoinCollab) {
          //   const refreshBtn = document.getElementById("datePicker-1");
          //   if (refreshBtn) {
          //     refreshBtn.click();
          //   }
          // }
        }
      }

      if (e?.data?.type === "RELOAD_WHITEBOARD") {
        console.log("--------------------called RELOAD_WHITEBOARD");
        this.props.setIsWBFullScreen(true);
        this.setState({ isReloadingWorkspace: false });
        const workspaceDiv = document.getElementById("my-workspace");

        if (workspaceDiv) {
          // Create a MutationObserver instance and pass a callback function to handle mutations
          this.mutationObserver = new MutationObserver(this.checkForChildren_);

          // Define the observer options
          const config = {
            childList: true, // Observe direct children changes
          };

          // Start observing the workspace div for changes
          this.mutationObserver.observe(workspaceDiv, config);
          this.setState({
            mutationObserverWithWorkspace: true,
          });
          this.checkForChildren_();
          return;
        }
      } else {
        this.setState({
          mutationObserverWithWorkspace: false,
        });
      }
    });
    microsoftTeams.getContext((context, error) => {
      this.setState({
        context: context,
      });
    });

    headers = {
      Authorization: "Bearer " + this.props.user.accessToken,
    };
    const subscription = JSON.parse(localStorage.getItem("subscription"));
    if (subscription && subscription?.whiteBoard) {
      this.setState({ isSubscribed: true, load: false });
    } else {
      this.setState({ isSubscribed: false, load: false });
    }

    if (
      this.props.user?.dbData?.subscription &&
      this.props.user?.dbData?.subscription?.whiteBoard
    ) {
      this.setState({ isSubscribed: true, load: false });
    } else {
      this.setState({ isSubscribed: false, load: false });
    }

    if (this.props.user?.dbData?.dayRemaining <= 2) {
      if (this.props.user?.dbData?.ExpirationDate) {
        if (this.props.user?.dbData?.dayRemaining <= 0) {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: false,
            isExpire: true,
          });
        } else {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: true,
            isExpire: false,
          });
        }
      }
    }

    // this.getAllLessons();
    await this.fetchLessons();
    this.getActiveCollabLinks();
    this.getActiveStreamLinks();

    if (navigator.onLine) {
      this.setState({ onLine: navigator.onLine });
    }

    window.addEventListener("offline", (e) => {
      this.setState({ onLine: navigator.onLine });
    });

    this.setState({ isFullscreen: !!document.fullscreenElement });
    document.addEventListener("fullscreenchange", () => {
      this.setState({ isFullscreen: !!document.fullscreenElement });
    });

    window.addEventListener("message", (e) => {
      if (e?.data?.type === "ZOOM_IN_OUT") {
        this.props.setIsWBFullScreen(e.data.isZoom);
      }
    });

    try {
      window.ACV_CURRENT_VOICE_HANDLER = this.handleVoiceCommand.bind(this);
      window.ACV_CURRENT_PAGE_KEY = "whiteboard";
    } catch (e) {}

    // Expose a simple API on window to call the spinner action
    window.generateSpinnerImageToCanvas = async (segments, size) => {
      return await this.generateSpinnerImageToCanvas(segments, size);
    };
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.messageListener);
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    try {
      if (window.ACV_CURRENT_VOICE_HANDLER) {
        delete window.ACV_CURRENT_VOICE_HANDLER;
      }
      if (window.ACV_CURRENT_PAGE_KEY) {
        delete window.ACV_CURRENT_PAGE_KEY;
      }
    } catch (e) {}
  }

  // Check if the loading or imageUploading states are not false for some reason, then set them to false
  startConstantChecking = () => {
    setTimeout(() => {
      const dataToSend = {
        type: "SEND_WHITEBOARD_DATA",
      };
      const iframeEl = document.getElementsByClassName("frameTag");
      iframeEl[0]?.contentWindow?.postMessage(
        dataToSend,
        process.env.REACT_APP_EP_WHITEBOARD
      );
    }, 3000);
  };

  getAllLessons = () => {
    axios
      .get(`${url}/api/lession/get-lessions${this.props.user.slug}`, {
        headers: headers,
      })
      .then((res) => {
        const lessions = res.data;
        this.setState({ lessions });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  getAllLessonsData = (lesson) => {
    const lessonIds = [];
    const lessonId = lesson.map((lsn) => {
      return lessonIds.push(`"${lsn.Title ? lsn.Title : lsn.LessonId}"`);
    });

    axios
      .post(
        `${whiteboard_api_url}/get-whiteboard-data-for-acv`,
        { lessonIds },
        {
          headers: headers,
        }
      )
      .then((res) => {
        this.setState({ lessonData: res.data.result });
      })
      .catch((err) => {
        console.log(err, err.response);
      });
  };

  getActiveCollabLinks = async () => {
    try {
      const response = await axios.get(
        `${whiteboard_api_url}/get-all-collaboration-link`
      );

      if (response.status === 200) {
        const lessons = response.data.result;
        this.setState({
          activeCollabLinks: lessons.map((lesson) => lesson.id),
          isFlexibleGroups: lessons,
        });
        return lessons;
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      console.log(err, err.response);
      if (err.response?.status === 401) {
        this.setState({ accDlg: true });
      }
    }
  };
  getActiveStreamLinks = async () => {
    try {
      const response = await axios.get(
        `${url}/api/streaming${this.props.user.slug}`,
        { headers: headers }
      );
      if (response.status === 200) {
        const lessons = response.data.result;
        this.setState({
          activeStreamLinks: lessons.map((lesson) => lesson.lessonId),
        });
        return lessons;
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      console.log(err, err.response);
      if (err.response?.status === 401) {
        this.setState({ accDlg: true });
      }
    }
  };

  fetchLessons = async (note, selectedValue, type) => {
    await this.getActiveCollabLinks();
    await this.getActiveStreamLinks();
    if (!this.state.isSubscribed) return;
    this.setState({ load: true });
    if (!note) {
      this.setState({ selectedLesson: null, showRecords: [] });
    }
    if (document.querySelector(".h-cls")) {
      document.querySelector(".h-cls").classList.remove("h-cls");
    }
    const selectedDate =
      type === "date" ? selectedValue : this.state.selectedDate;
    const selectedClass =
      type === "class" ? selectedValue : this.state.selectedClass;
    const selectedTeacher =
      type === "teacher" ? selectedValue : this.state.selectedTeacher;
    const lessonData = JSON.parse(localStorage.getItem("selectedLession"));

    axios
      .post(
        `${url}/api/lession/get-lession-by-teacher${this.props.user.slug}&pageName=whiteBoard`,
        {
          ClassName: selectedClass,
          TeacherEmailAlias: selectedTeacher,
          LessonDate: selectedDate,
        },
        { headers: headers }
      )
      .then((res) => {
        const showLesson = res.data.result.sort((a, b) =>
          a.StartTime.toLowerCase() > b.StartTime.toLowerCase() ? 1 : -1
        );
        this.getAllLessonsData(showLesson);
        this.setState({ showLesson });
      })
      .catch((err) => {
        this.setState({ load: false });
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      })
      .finally(() => {
        this.setState({ load: false });
      });
  };

  fetchRecordsByLesson = (lessonData, findCurrentLesson) => {
    axios
      .get(
        `${url}/api/record/get-record-by-lession/${
          lessonData?.Title ? lessonData.Title : lessonData?.LessonId
        }${this.props.user.slug}`,
        { headers: headers }
      )
      .then((res) => {
        if (
          this.props.user.actualRole === "Student" ||
          this.props.user.actualRole === "Teacher"
        )
          this.getActiveCollabLinks();
        this.getActiveStreamLinks();
        this.fetchCollabLink(lessonData);
        const data = {
          findCurrentLesson: findCurrentLesson ? findCurrentLesson : [],
          access_token: this.props.user.accessToken,
          user: this.props.user,
          lesson: this.state.selectedLesson,
          i18nextLng: localStorage.getItem("i18nextLng"),
          fullscreen: this.props?.isWBFullScreen,
          isLiveStreaming: this.state.activeStreamLinks.includes(
            lessonData?.Title ? lessonData.Title : lessonData?.LessonId
          )
            ? true
            : this.state.isConfirmLiveStream,
        };

        this.sendMessage(data);
        const showRecords = res.data.result;
        if (res.data.result.length) {
          const selectedLessonType = res.data.result[0].ClassType;
          this.setState({ showRecords, load: false, selectedLessonType });
        } else {
          axios
            .get(
              `${url}/api/lession/get-lesson-class-type/${
                this.state.selectedLesson?.Title
                  ? this.state.selectedLesson.Title
                  : this.state.selectedLesson?.LessonId
              }${this.props.user.slug}`,
              { headers: headers }
            )
            .then((res) => {
              const selectedLessonType = res.data?.result?.ClassType;
              this.setState({ showRecords, load: false, selectedLessonType });
            })
            .catch((err) => {
              toast.error(err?.response?.data?.message);
              console.log(err, err.response);
              if (err.response?.status === 401) {
                this.setState({ accDlg: true });
              }
            });
        }
      })
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  getLiveStreamLink = (lessonData) => {
    if (
      this.props.user.actualRole === "Student" &&
      this.state.activeStreamLinks.includes(lessonData.LessonId)
    ) {
      if (this.state.collabLinkDlg === false) {
        this.props.setIsWBFullScreen(false);
        this.setState({
          isLivestream: true,
        });
      }
    }
  };

  fetchCollabLink = (lessonData) => {
    axios
      .get(
        `${whiteboard_api_url}/get-collaboration-link/${
          lessonData?.Title ? lessonData.Title : lessonData?.LessonId
        }`,
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.data) {
          if (res.data.result) {
            this.setState({ collabLinkDlg: true });
            this.props.setIsWBFullScreen(false);
            this.setState({ contactDlg: false });
            if (res.data.result.collaboratorId === this.props.user.mail) {
              this.setState({ collabLinkDlg: false });
            }

            this.setState({ collabLink: res.data.result.collaborationLink });
          } else {
            this.setState({ isJoinCollab: false });
            this.setState({ collabLink: null });
            this.setState({ collabLinkDlg: false });
            this.setState({ contactDlg: true });
          }
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        this.setState({ collabLinkDlg: false });
        this.setState({ contactDlg: true });
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      })
      .finally(() => {
        this.getLiveStreamLink(lessonData);
      });
  };

  lessonTopicHandler = () => {
    axios
      .put(
        `${url}/api/lession/update-class-topic/${
          this.state.selectedLesson.Title
            ? this.state.selectedLesson.Title
            : this.state.selectedLesson.LessonId
        }${this.props.user.slug}`,
        {
          Tema: document.getElementById("textLessonTopic").value,
        },
        { headers: headers }
      )
      .then((res) => {
        this.fetchLessons("note");
        const status = res.data.status;
        if (status === "Success") {
          this.setState({ showTopic: false });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  lessonNoteHandler = () => {
    axios
      .put(
        `${url}/api/lession/update-class-note/${
          this.state.selectedLesson.Title
            ? this.state.selectedLesson.Title
            : this.state.selectedLesson.LessonId
        }${this.props.user.slug}`,
        {
          Tarea: document.getElementById("textLessonNote").value,
        },
        { headers: headers }
      )
      .then((res) => {
        this.fetchLessons("note");
        const status = res.data.status;
        if (status === "Success") {
          this.setState({ showNote: false });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  studentNoteHandler = (email, lsn, note) => {
    axios
      .put(
        `${url}/api/record/update-student-note${this.props.user.slug}`,
        {
          StudentEmailId: email,
          LessonId: lsn,
          Notes: note === null ? "" : note,
        },
        { headers: headers }
      )
      .then((res) => {
        const status = res.data.status;
        if (status === "Success") {
          const foundRecord = this.state.showRecords.find((stud) => {
            return stud.StudentEmailId === email
              ? stud.LessonId === lsn
                ? stud.LessonId === lsn
                : null
              : null;
          });
          const foundIndex = this.state.showRecords.findIndex((stud) => {
            return stud.StudentEmailId === email
              ? stud.LessonId === lsn
                ? stud.LessonId === lsn
                : null
              : null;
          });
          let recordData = [...this.state.showRecords];
          foundRecord.Notes = note;
          recordData[foundIndex] = foundRecord;
          this.setState({ showRecords: recordData });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  checkedRecordsHandler = (attendance, takenBy) => {
    let chkRecords = [...this.state.checkedRecords];
    chkRecords = chkRecords.map((student) => {
      return {
        Attendance: attendance,
        AttendanceTakenBy: takenBy,
        ClassId: student.ClassId,
        ClassName: student.ClassName,
        EndTime: student.EndTime,
        LessonDate: student.LessonDate,
        LessonId: student.LessonId,
        Notes: student.Notes,
        StartTime: student.StartTime,
        StudentEmailId: student.StudentEmailId,
        StudentName: student.StudentName,
      };
    });
    axios
      .post(
        `${url}/api/record/take-attendence${this.props.user.slug}`,
        chkRecords,
        {
          headers: headers,
        }
      )
      .then((res) => {
        this.setState({ checkedRecords: res.data.result });
        this.fetchRecordsByLesson();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };
  checkedRecordsModeHandler = (body) => {
    axios
      .post(
        `${url}/api/student/update-student-class-mode${this.props.user.slug}`,
        body,
        {
          headers: headers,
        }
      )
      .then((res) => {
        this.analyticsHandler();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };
  takeAttendance = (email, lsn, attendance, takenBy) => {
    this.changeRecordState(email, lsn, attendance, takenBy);
    axios
      .put(
        `${url}/api/record/update-student-attendance${this.props.user.slug}`,
        {
          StudentEmailId: email,
          LessonId: lsn,
          Attendance: attendance,
          AttendanceTakenBy: this.props.user.username,
        },
        { headers: headers }
      )
      .then((res) => {
        const response = res.data;
        if (response.status !== "Success") {
        }
      })
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  changeRecordState = (email, lsn, attendance, takenBy) => {
    const foundRecord = this.state.showRecords.find((stud) => {
      return stud.StudentEmailId === email
        ? stud.LessonId === lsn
          ? stud.LessonId === lsn
          : null
        : null;
    });
    const foundIndex = this.state.showRecords.findIndex((stud) => {
      return stud.StudentEmailId === email
        ? stud.LessonId === lsn
          ? stud.LessonId === lsn
          : null
        : null;
    });
    let recordData = [...this.state.showRecords];
    foundRecord.Attendance = attendance;
    foundRecord.AttendanceTakenBy = this.props.user.username;
    recordData[foundIndex] = foundRecord;
    this.setState({ showRecords: recordData });
  };

  analyticsHandler = () => {
    let analytics = {
      virtual: 0,
      total: 0,
      present: 0,
      absent: 0,
      late: 0,
      justification: 0,
    };
    this.state.showRecords.map((student) => {
      analytics.total++;
      if (student.ClassType === "Virtual") {
        analytics.virtual++;
      }
      if (student.Attendance === "Presente") {
        analytics.present++;
      } else if (student.Attendance === "Ausente") {
        analytics.absent++;
      } else if (student.Attendance === "Retardo") {
        analytics.late++;
      } else if (
        student.Attendance === "Sickness" ||
        student.Attendance === "Family emergency" ||
        student.Attendance === "Not feel well"
      ) {
        analytics.absent++;
        analytics.justification++;
      }
      return null;
    });
    this.setState({ showRecordsAnalytics: analytics });
  };

  pinnedHandler = (isVirtual, email) => {
    axios
      .put(
        `${url}/api/student/update-student-present-mode${this.props.user.slug}`,
        {
          isVirtual: isVirtual,
          StudentEmailID: [email],
        },
        { headers: headers }
      )
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  onCompactModeHandler = () => {
    const { isCompactMode } = this.state;
    this.setState({
      ...this.state,
      isCompactMode: !isCompactMode,
    });
    localStorage.setItem(
      "selectedLession",
      JSON.stringify(this.state.selectedLesson)
    );
  };

  handleClose = () => {
    this.props.setIsMobileViewFiltersOpen(false);
  };

  setOpenWorkSpace = () => {
    this.props?.setOpenWorkSpace(false);
  };

  setOpenWorkSpace_ = () => {
    this.props?.setOpenWorkSpace(true);
  };

  handleIframeError = (event) => {
    const iframe = event.currentTarget;
    setTimeout(() => this.refreshIframe(), 1000); // Wait 1 second before reload to prevent loops
  };

  normalCanvas = () => {
    return (
      <body onLoad={this.postCrossDomainMessage} style={{ overflow: "hidden" }}>
        <iframe
          src={`${process.env.REACT_APP_EP_WHITEBOARD}/${
            this.props.user.slug
          }&lessonId=${
            this.state.selectedLesson?.Title
              ? this.state.selectedLesson.Title
              : this.state.selectedLesson?.LessonId || "LessonId"
          }`}
          title="Whiteboard88"
          className="frameTag"
          style={{ height: "100%" }}
          key={`student-iframe-lang-${this.state.currentLanguage}`}
          ref={this.props.iframeRef}
          allow="fullscreen;camera;microphone;clipboard-read; clipboard-write; display-capture"
          onError={this.handleIframeError}
        ></iframe>
      </body>
    );
  };

  render() {
    const { t } = this.props;
    const { isCompactMode } = this.state;

    const styles = {
      cardImg: {
        width: "72px",
        height: "56px",
        right: "220px",
        marginLeft: "6px",
        marginTop: "6px",
        marginBottom: "6px",
        marginRight: "6px",
        borderRadius: "7px",
      },
      topic: {
        display: this.state.showTopic ? "block" : "none",
        position: "absolute",
        left: "20px",
        bottom: "20px",
        boxShadow: `
          0 2.8px 2.2px rgba(0, 0, 0, 0.034),
          0 6.7px 5.3px rgba(0, 0, 0, 0.048),
          0 12.5px 10px rgba(0, 0, 0, 0.06),
          0 22.3px 17.9px rgba(0, 0, 0, 0.072),
          0 41.8px 33.4px rgba(0, 0, 0, 0.086),
          0 100px 80px rgba(0, 0, 0, 0.12)
        `,
        minHeight: "260px",
        width: "340px",
        background: "white",
        borderRadius: "5px",
      },
      notes: {
        display: this.state.showNote ? "block" : "none",
        position: "absolute",
        left: this.state.showTopic ? "380px" : "20px",
        bottom: "20px",
        boxShadow: `
          0 2.8px 2.2px rgba(0, 0, 0, 0.034),
          0 6.7px 5.3px rgba(0, 0, 0, 0.048),
          0 12.5px 10px rgba(0, 0, 0, 0.06),
          0 22.3px 17.9px rgba(0, 0, 0, 0.072),
          0 41.8px 33.4px rgba(0, 0, 0, 0.086),
          0 100px 80px rgba(0, 0, 0, 0.12)
        `,
        minHeight: "260px",
        width: "340px",
        background: "white",
        borderRadius: "5px",
      },
      present: { backgroundColor: "#2F80ED", color: "white" },
      absent: {
        backgroundColor: "#EB5757",
        color: "white",
        marginLeft: "-10px",
      },
      justify: {
        backgroundColor: "#17a2b8",
        color: "white",
        marginLeft: "-10px",
      },
      home: { backgroundColor: "#04c68a", color: "white", marginLeft: "-10px" },
      late: { backgroundColor: "#464775", color: "white", marginLeft: "-10px" },
      btnPresent: { minWidth: "70px", marginLeft: "-10px" },
      btnAbsent: { minWidth: "66px", marginLeft: "-10px" },
      btnLate: { minWidth: "48px", marginLeft: "-10px" },
      btnHome: { minWidth: "48px", marginLeft: "-10px" },
      hideText: {
        whiteSpace: "nowrap",
        width: "180px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      hideContentText: {
        whiteSpace: "nowrap",
        width: "90px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    };

    const convertUtcToLocalTime = (utcDate, utcTime) => {
      return moment.utc(`${utcDate} ${utcTime}`).local().format("HH:mm");
    };

    const sendMessageToWhiteboard = (lsn) => {
      this.setState({
        waitingDialog: true,
        isLoading: true,
        currentLsn: lsn,
        isImageUploading: true,
      });
      const dataToSend = {
        type: "SEND_WHITEBOARD_DATA",
      };
      const iframeEl = document.getElementsByClassName("frameTag");
      iframeEl[0]?.contentWindow?.postMessage(
        dataToSend,
        process.env.REACT_APP_EP_WHITEBOARD
      );
      this.startConstantChecking();
    };

    const myCard = (lsn) => {
      // const cardToolTip = `${
      //   lsn.StartTime.trim() + " - " + lsn.EndTime.trim()
      // }   ${lsn.LessonDate}
      // <br />${lsn.ClassName.split(" - ")[0]}<br />${
      //   lsn.ClassName.split(" - ")[1]
      // }`;

      let date = moment.utc(`${lsn.LessonDate}`).local().format("YYYY-MM-DD");

      const localStartTime = convertUtcToLocalTime(
        moment(lsn.LessonDate).format("YYYY-MM-DD"),
        lsn.StartTime
      );
      const localEndTime = convertUtcToLocalTime(
        moment(lsn.LessonDate).format("YYYY-MM-DD"),
        lsn.EndTime
      );

      const cardToolTip = `${localStartTime + " - " + localEndTime}   ${date}
      <br />${lsn.ClassName.split(" - ")[0]}<br />${
        lsn.ClassName.split(" - ")[1]
      }`;
      const tooltipWithCollaboration = `Continue in this <br /> live collaboration <br /> session`;

      const lessonTitle = lsn?.Title ? lsn.Title : lsn?.LessonId;
      const stateLessonTitle = this.state.selectedLesson?.Title
        ? this.state.selectedLesson.Title
        : this.state.selectedLesson?.LessonId;

      // The following code is set to check whether data is available in the lesson or not.
      let lessonIds = [];
      this.state.lessonData.filter((lsnData) => {
        if (lsnData?.data?.length > 0) {
          return lessonIds.push(lsnData.lessonId);
        }
      });

      const findCurrentLesson = this.state.isFlexibleGroups.filter((lesson) => {
        if (lesson.id === lessonTitle) {
          return lesson;
        }
      });

      return (
        <Card
          key={lessonTitle}
          data-dom-key={this.getLessonDomKey(lsn)}
          className={
            this.state.selectedLesson && lessonTitle === stateLessonTitle
              ? this.state.activeCollabLinks.includes(lessonTitle) &&
                this.state.activeStreamLinks.includes(lessonTitle)
                ? "activeWithSelectedCard"
                : this.state.activeCollabLinks.includes(lessonTitle)
                ? "activeWithSelectedCard"
                : this.state.activeStreamLinks.includes(lessonTitle)
                ? "activeWithStreamAndSelectedCard"
                : "selectedCard"
              : this.state.activeCollabLinks.includes(lessonTitle)
              ? "activeWithSelectedCard"
              : this.state.activeStreamLinks.includes(lessonTitle)
              ? "activeWithStreamAndSelectedCard"
              : "card"
          }
          data-tip={
            this.state.activeCollabLinks.includes(lessonTitle)
              ? tooltipWithCollaboration
              : this.state.isCompactMode
              ? cardToolTip
              : ""
          }
          compact
          horizontal
          aria-roledescription="ACV - Asistente de clases virtuales | Tangible IT"
          onClick={async () => {
            // Push undo for lesson selection via UI
            try {
              if (!this.isPerformingUndo) {
                const prev = this.state.selectedLesson;
                const next = lsn;
                const prevId = prev?.LessonId ?? prev?.Title ?? null;
                const nextId = next?.LessonId ?? next?.Title ?? null;
                this._pushUndoAction({
                  type: "lesson",
                  previous: prevId,
                  previousKey: this.getLessonDomKey(prev),
                  next: nextId,
                  nextKey: this.getLessonDomKey(next),
                });
              }
            } catch (e) {}
            this.setState({ isChangedLesson: true, isMyWorkSpace: false });
            if (lsn) {
              this.props.setIsWBFullScreen(true);
              this.setState({
                wbDataNotAvailable: false,
              });
            }

            if (
              this.props.user.actualRole === "Student" &&
              // isDataNotAvailableLessonIds.includes(lessonTitle) &&
              !lessonIds.includes(lessonTitle) &&
              !this.state.activeCollabLinks.includes(lessonTitle) &&
              !this.state.activeStreamLinks.includes(lessonTitle)
            ) {
              this.props.setIsWBFullScreen(false);
              this.setState({
                isDataNotAvailable: true,
                wbDataNotAvailable: true,
              });
            }

            if (!document.querySelector(".Whiteboard.h-cls")) {
              document.querySelector(".Whiteboard").classList.add("h-cls");
            }
            if (this.state.isEditable) {
              this.setState({
                currentLsn: lsn,
                isOpen: true,
              });
            } else if (
              this.state.showTopic !== true &&
              this.state.showNote !== true &&
              (!this.state.selectedLesson || !this.state.isShowWaitingDialog)
            ) {
              this.setState({
                load: true,
                checkedRecords: [],
                checkedRecordsMode: [],
                selectedLesson: lsn,
                currentLsn: null,
              });
              this.fetchRecordsByLesson(lsn, findCurrentLesson);
            } else {
              const lessonId = this.state.selectedLesson.Title
                ? this.state.selectedLesson.Title
                : this.state.selectedLesson?.LessonId;

              if (lessonTitle === lessonId) return;

              sendMessageToWhiteboard(lsn);
            }

            // if (this.state.activeCollabLinks.includes(lessonTitle)) {
            //   this.setState({ collabLinkDlg: true });
            // }
          }}
        >
          <ReactTooltip
            place="right"
            type="light"
            effect="float"
            multiline={true}
          />

          <Card.Preview
            horizontal
            className="preview"
            styles={{
              marginRight: this.state.isCompactMode ? "0px" : "0.625rem",
            }}
          >
            <Image
              style={styles.cardImg}
              src={
                lsn?.LessionData
                  ? lsn?.LessionData.lessonImage?.ImageURL
                    ? lsn.LessionData.lessonImage.ImageURL +
                      this.props?.user?.SASToken
                    : lsn.ClassName.includes("Art")
                    ? Imgart
                    : lsn.ClassName.includes("Civismo")
                    ? Imgcivil
                    : lsn.ClassName.includes("Hist")
                    ? Imghistory
                    : lsn.ClassName.includes("Science")
                    ? ImgnaturalScience
                    : lsn.ClassName.includes("losof")
                    ? Imgphilosophy
                    : lsn.ClassName.includes("Ciencias Exactas")
                    ? ImgscienceExact
                    : lsn.ClassName.includes("Tec")
                    ? Imgtech
                    : Imgother
                  : lsn?.lessonImage?.ImageURL
                  ? lsn.lessonImage.ImageURL + this.props?.user?.SASToken
                  : lsn.ClassName.includes("Art")
                  ? Imgart
                  : lsn.ClassName.includes("Civismo")
                  ? Imgcivil
                  : lsn.ClassName.includes("Hist")
                  ? Imghistory
                  : lsn.ClassName.includes("Science")
                  ? ImgnaturalScience
                  : lsn.ClassName.includes("losof")
                  ? Imgphilosophy
                  : lsn.ClassName.includes("Ciencias Exactas")
                  ? ImgscienceExact
                  : lsn.ClassName.includes("Tec")
                  ? Imgtech
                  : Imgother
              }
            />
          </Card.Preview>
          <Card.Column
            className={isCompactMode ? "d-none" : ""}
            style={{
              position:
                this.props.user.actualRole === "Student" &&
                lessonIds.includes(lessonTitle) &&
                "relative",
            }}
          >
            <Card.Header>
              {!this.state.activeCollabLinks.includes(lessonTitle) &&
                !this.state.activeCollabLinks.includes(lessonTitle) &&
                this.props.user.actualRole === "Student" &&
                lessonIds.includes(lessonTitle) && (
                  <div
                    className="isDataAvalible"
                    style={{
                      position: "absolute",
                      justifyContent: "end",
                      zindex: 2,
                      display: "flex",
                      width: "100%",
                      marginLeft: "-1px",
                      marginTop: "30px",
                    }}
                  >
                    <img src={dbImage} alt="" style={{ width: "25px" }} />
                  </div>
                )}
              {this.state.activeStreamLinks.includes(lessonTitle) && (
                <div
                  style={{
                    position: "absolute",
                    justifyContent: "end",
                    zindex: 2,
                    display: "flex",
                    width: "100%",
                    bottom: "5px",
                    right: "5px",
                  }}
                >
                  <div className="live-container">
                    <div className="live-pill">
                      <div
                        className="live-dot"
                        style={{
                          backgroundColor: "#607d3b",
                        }}
                      ></div>
                      <div className="live-text">LIVE</div>
                    </div>
                  </div>
                </div>
              )}
              <Flex gap="gap.small">
                <Text
                  content={localStartTime + " - " + localEndTime}
                  size="small"
                  style={{ marginTop: "6px" }}
                />
                <Text
                  content={
                    this.state.isDateSelected
                      ? moment.utc(lsn.LessonDate).local().format("YYYY-MM-DD")
                      : moment(new Date()).format("YYYY-MM-DD")
                  }
                  size="small"
                  style={{ marginTop: "6px" }}
                />
              </Flex>
              <Text
                content={lsn.ClassName.split("-")[0]}
                weight="semibold"
                style={styles.hideText}
              />
              <Text
                content={
                  lsn.ClassName.split("-")[1] +
                  " - " +
                  lsn.ClassName.split("-")[2]
                }
                data-text={
                  lsn.ClassName.split("-")[1] +
                  " - " +
                  lsn.ClassName.split("-")[2]
                }
                size="small"
                style={styles.hideText}
              />
            </Card.Header>
          </Card.Column>
        </Card>
      );
    };

    return (
      <div
        className={
          this.props?.isWBFullScreen
            ? "Whiteboard Whiteboard h-cls h-ctr fullscreen"
            : this.state.isFullscreen || this.state.selectedLesson
            ? "Whiteboard Whiteboard h-cls h-ctr"
            : "Whiteboard Whiteboard s-ctr"
        }
        style={{
          height: this.props?.isWBFullScreen ? "100vh" : "calc(100vh - 61px)",
          zIndex: this.props?.isWBFullScreen && 90000,
          position: this.props?.isWBFullScreen && "relative",
        }}
      >
        {this.props?.user?.actualRole === "SuperAdmin" ? (
          <Dialog
            open={this.state.dialog}
            onConfirm={() => this.setState({ dialog: false })}
            confirmButton="Okay"
            content={
              <div style={{ gap: "5px", display: "grid" }}>
                Reminder: Your current subscription plan will expire on{" "}
                {this.state.ExpirationDate}.<br />
                <div>
                  To continue enjoying all the features and benefits, please{" "}
                  <a
                    href="https://www.acv.app/prices"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    click here
                  </a>{" "}
                  to renew your plan.
                </div>
              </div>
            }
            header="Your ACV Plan"
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: () => this.setState({ dialog: false }),
            }}
          />
        ) : null}
        {this.state.isOpen && (
          <Dialog
            className="editable-modal"
            open={this.state.isOpen}
            onConfirm={() => {
              this.setState({
                load: true,
                checkedRecords: [],
                checkedRecordsMode: [],
                selectedLesson: this.state.currentLsn,
                isOpen: false,
              });
              this.fetchRecordsByLesson(this.state.currentLsn);
            }}
            confirmButton="Okay"
            content={"If you change the lesson, your data will be lost!!"}
            header=" Are you sure?"
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: () => this.setState({ isOpen: false }),
            }}
            style={{
              width: "50% !important",
            }}
          />
        )}
        <Dialog
          open={this.state.accDlg}
          onConfirm={() => location.reload()}
          confirmButton="Refresh Now"
          content={
            <p className="refreshMsg">
              No big deal — but we need to refresh to show your content.
            </p>
          }
          header="Authorization expire"
        />
        <MUIDialog
          open={this.state.waitingDialog}
          id="loading-dialog"
          maxWidth="md"
          PaperProps={{
            sx: {
              padding: "30px 30px 25px 30px",
              borderRadius: 3,
            },
          }}
        >
          <IconButton
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              m: 1,
            }}
            onClick={() => {
              this.setState({
                load: true,
                checkedRecords: [],
                checkedRecordsMode: [],
                waitingDialog: false,
              });
            }}
          >
            <CloseIcon size="small" />
          </IconButton>
          <Typography
            variant="h6"
            sx={{
              fontSize: 18,
              fontWeight: "bold",
              fontFamily: "Segoe UI",
              mt: 1,
            }}
          >
            Please wait while we are saving your data...
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 3,
            }}
          >
            <Loader />
          </Box>
        </MUIDialog>

        {this.state.isDataNotAvailable &&
          this.props.user.actualRole === "Student" && (
            <Dialog
              open={this.state.isDataNotAvailable}
              onConfirm={() => {
                this.props.setIsWBFullScreen(false);
                this.setState({
                  isDataNotAvailable: false,
                  wbDataNotAvailable: true,
                });
              }}
              confirmButton="Okay"
              content={
                <p>
                  This lesson does not contain any data. Please choose another
                  lesson that has data
                </p>
              }
              style={{ maxWidth: 500 }}
              header="Data not Available"
              className="data-not-available-dialog"
            />
          )}
        {this.state.collabLinkDlg && (
          <Dialog
            open={this.state.collabLinkDlg}
            onConfirm={() =>
              this.setState({
                isJoinCollab: true,
                collabLinkDlg: false,
                contactDlg: false,
              })
            }
            confirmButton="Yes"
            cancelButton="No"
            onCancel={() => {
              this.props.setIsWBFullScreen(false);
              this.setState({
                isJoinCollab: false,
                collabLinkDlg: false,
                contactDlg: true,
                wbDataNotAvailable: true,
                isLivestream: false,
              });
            }}
            content={<p>Do you want to join collaboration?</p>}
            style={{ maxWidth: 500 }}
            header="Collaboration"
          />
        )}
        {/* for live stream */}
        {this.state.isLivestream &&
          this.props.user.actualRole === "Student" &&
          !this.state.isJoinCollab &&
          !this.state.collabLinkDlg && (
            <Dialog
              open={this.state.isLivestream}
              onConfirm={() => {
                this.props.setIsWBFullScreen(true);
                this.setState({
                  isLivestream: false,
                  isConfirmLiveStream: true,
                });
                //set this into msg local storage
                const msg = JSON.parse(localStorage.getItem("msg"));
                localStorage.setItem(
                  "msg",
                  JSON.stringify({ ...msg, isLiveStreaming: true })
                );
              }}
              confirmButton="Okay"
              cancelButton="Cancel"
              onCancel={() => {
                document.getElementById("datePicker-1").click();
                this.setState({
                  isLivestream: false,
                });
              }}
              content={
                <p>
                  This lesson does contain Live streaming. Please confirm if you
                  like to join the live streaming.
                </p>
              }
              style={{ maxWidth: 500 }}
              header="Live Streaming Available"
              className="data-not-available-dialog"
            />
          )}
        <div
          style={{
            position: "relative",
            display: this.props?.isWBFullScreen ? "none" : "block",
          }}
        >
          {!this.state.isExpire && this.state.isSubscribed && (
            <Controls
              state={{
                ...this.state,
                ...{ accessToken: this.props.user.accessToken },
              }}
              user={this.props.user}
              labels={t("attendance").controls}
              cLabels={t("AttendanceHistory").controls}
              onDateDataChange={async (date) => {
                //check collaboration is start or not
                const lessons = await this.getActiveCollabLinks();
                // const activeLessonIndex = lessons.findIndex((data) => {
                //   return this.state.showLesson.some((lesson) =>
                //     lesson.Title ? lesson.Title : lesson?.LessonId === data.id
                //   );
                // });

                // const isActive = activeLessonIndex !== -1;
                this.setState({ currentDate: date });
                // if (!isActive) {
                this.setState({
                  selectedDate: date,
                  isDateSelected: true,
                  getSelectedData: date,
                  showLesson: [],
                });
                await this.fetchLessons("", date, "date");
                // } else {
                // this.setState({
                //   isActiveSession: {
                //     active: true,
                //     lessonId: lessons[activeLessonIndex].id,
                //   },
                // });
                // }
              }}
              changeLsnByClass={async (selectedClass) => {
                this.setState({ selectedClass: selectedClass });
                await this.fetchLessons("", selectedClass, "class");
              }}
              changeLsnByTeacher={async (e) => {
                console.log(e);
                this.setState({ selectedTeacher: e });
                await this.fetchLessons("", e, "teacher");
              }}
              resetSelected={() => {
                this.setState(
                  {
                    selectedClass: null,
                    selectedTeacher: null,
                    isConfirmLiveStream: false,
                  },
                  () => this.fetchLessons()
                );
              }}
              fetchRcrd={() => this.fetchRecordsByLesson()}
              page="whiteboard"
              isLessonsAvailable={!!this.state.showLesson?.length}
              isFullscreen={this.state.isFullscreen}
              selectedLesson={this.state.selectedLesson}
              handleClose={this.handleClose}
              open={this.props.isMobileViewFiltersOpen}
              openWorkSpace={this.props.openWorkSpace}
              setOpenWorkSpace={this.setOpenWorkSpace_}
            />
          )}
        </div>
        <div
          style={{
            width: "100%",
            overflow: "auto",
            backgroundColor: "white",
            scrollbarWidth: "none",
            height:
              this.state?.isFullscreen ||
              this.state.selectedLesson ||
              this.state.isMyWorkSpace
                ? "100%"
                : "",
          }}
        >
          {
            <Flex
              gap="gap.medium"
              wrap
              className="container2"
              styles={{
                height:
                  this.state?.isFullscreen ||
                  this.props?.isWBFullScreen ||
                  this.state.isMyWorkSpace
                    ? "100%"
                    : "",
              }}
            >
              {this.state.isSubscribed &&
              this.state.showLesson &&
              this.state.showLesson.length &&
              !this.state.isExpire &&
              !this.state.isMyWorkSpace ? (
                <Flex
                  gap="gap.medium"
                  className={`tour-select-lesson ${
                    isCompactMode || this.state.isFullscreen
                      ? "availableClass mr-0"
                      : "availableClass"
                  }`}
                  styles={{
                    height: "calc(100vh - 61px)",
                    display: this.props?.isWBFullScreen ? "none" : "block",
                  }}
                >
                  {(this.props.user.slug === "?slug=acvpreprod" ||
                    this.props.user.slug === "?slug=acvapp") &&
                  (this.state.selectedDay === "Sunday" ||
                    this.state.selectedDay === "Saturday") ? null : (
                    <>
                      <div
                        style={{
                          paddingTop: "18px",
                          width:
                            isCompactMode || this.state.isFullscreen
                              ? "auto"
                              : "280px",
                          paddingLeft: "40px",
                        }}
                      >
                        <Label
                          style={{ color: "#252423", cursor: "pointer" }}
                          iconPosition="start"
                          icon={
                            isCompactMode || this.state.isFullscreen ? (
                              <IndentIcon />
                            ) : (
                              <NumberListIcon />
                            )
                          }
                          content={
                            isCompactMode || this.state.isFullscreen ? (
                              ""
                            ) : (
                              <Text
                                content={t("attendance").body.lessions}
                                size="medium"
                                weight="semibold"
                                style={{ marginLeft: "4px" }}
                              />
                            )
                          }
                          color="white"
                          onClick={() => this.onCompactModeHandler()}
                        />
                      </div>

                      <AvailbleClass
                        isCompactMode={isCompactMode}
                        state={this.state}
                        myCard={myCard}
                        isFullscreen={this.state.isFullscreen}
                      />
                    </>
                  )}
                </Flex>
              ) : (
                ""
              )}

              <div id="my-workspace" style={{ display: "none" }}></div>

              <Flex
                gap="gap.medium"
                wrap
                className="flex-grow"
                style={{
                  maxHeight: this.props.openWorkSpace && "100%",
                }}
              >
                {!this.state.isSubscribed || this.state.isExpire ? (
                  <Subscription
                    pageName="whiteboard"
                    isExpire={this.state.isExpire}
                    role={this.props.user.role}
                  />
                ) : !this.state.selectedClass &&
                  !this.state.showLesson?.length &&
                  !this.state.isMyWorkSpace ? (
                  <div style={{ margin: "0 auto" }}>
                    <h1 style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                      {t("attendance").body.noclass}
                    </h1>
                    <div className="heroframe" style={{ width: "300px" }}>
                      <img
                        alt="ACV - Tangible IT"
                        src={DateSelection}
                        className="frameTagimg"
                        draggable="false"
                      />
                    </div>
                  </div>
                ) : !this.state.selectedLesson && !this.state.isMyWorkSpace ? (
                  <div className="heroframe">
                    <img
                      alt="ACV - Tangible IT"
                      src={LessonSelection}
                      className="frameTagimg"
                      draggable="false"
                    />
                  </div>
                ) : (this.props.user.actualRole === "Student" ||
                    this.props.user.actualRole === "Teacher") &&
                  this.state.isJoinCollab &&
                  !this.state.isMyWorkSpace &&
                  !this.state.contactDlg ? (
                  <body
                    onLoad={this.postCrossDomainMessage}
                    style={{ overflow: "hidden" }}
                  >
                    <iframe
                      src={this.state.collabLink}
                      title="Whiteboard"
                      className="frameTag"
                      style={{ height: "100%" }}
                      allow="fullscreen;camera;microphone;clipboard-read; clipboard-write; display-capture"
                    ></iframe>
                  </body>
                ) : (
                  // this.props.user.actualRole !== "Student" && (
                  !this.state.wbDataNotAvailable &&
                  !this.state.collabLinkDlg &&
                  !this.state.isMyWorkSpace &&
                  !this.state.isLivestream &&
                  !this.state.isConfirmLiveStream &&
                  this.normalCanvas()
                )}
                {this.props.user.actualRole === "Student" &&
                  this.state.isConfirmLiveStream &&
                  this.normalCanvas()}
                {(this.state.isMyWorkSpace ||
                  this.state.isReloadingWorkspace) && (
                  <body
                    onLoad={this.postCrossDomainMessage}
                    style={{ overflow: "hidden" }}
                  >
                    <iframe
                      src={`${process.env.REACT_APP_EP_WHITEBOARD}/${this.props.user.slug}&lessonId=MyWorkSpace`}
                      title="Whiteboard88"
                      className="frameTag"
                      style={{ height: "100%" }}
                      key={`student-iframe-lang-${this.state.currentLanguage}-${
                        this.state.isReloadingWorkspace ? "reloading" : "loaded"
                      }`}
                      ref={this.props.iframeRef}
                      id="whiteboard-workspace"
                      allow="fullscreen;camera;microphone;clipboard-read; clipboard-write; display-capture"
                    ></iframe>
                  </body>
                )}
              </Flex>
            </Flex>
          }

          <Dialog
            open={this.state.isActiveSession.active}
            onConfirm={() => {
              // this.setState({
              //   isActiveSession: {
              //     ...this.state.isActiveSession,
              //     active: false,
              //   },
              // });
              // this.fetchLessons("", this.state.currentDate, "date");
              // // const id = lsn?.Title ? lsn.Title : lsn?.LessonId;
              // if (this.state.isActiveSession.lessonId)
              //   axios.delete(
              //     `${process.env.REACT_APP_EP_URL_WHITEBOARD_API}/delete-collaboration-link/${this.state.isActiveSession.lessonId}`
              //   );
            }}
            onCancel={() => {
              this.setState({
                isActiveSession: {
                  ...this.state.isActiveSession,
                  active: false,
                },
              });
              this.setState({
                selectedDate: this.state.selectedDate,
                isDateSelected: true,
              });
            }}
            confirmButton="Yes"
            cancelButton="No"
            content={
              "Are you certain that you want to change the date? Please note that if you proceed with this change, your session will be terminated."
            }
            header="Are you sure?"
            style={{ maxWidth: 500 }}
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: () =>
                this.setState({
                  isActiveSession: {
                    ...this.state.isActiveSession,
                    active: false,
                  },
                }),
            }}
          />
        </div>
        {null}
      </div>
    );
  }
}
export default withTranslation()(Whiteboard);
